import localeAntd from "ant-design-vue/lib/locale-provider/ar_EG";

const messages = {
  all: {
    selectionnerEleves: "حدد التلاميذ",
    printByLevel: "طباعة حسب المستوى",
    printLoginCredentials: "طباعة بيانات الدخول",
    understood: "لقد فهمت",
    automatique: "تلقائي",
    manuel: "يدوي",
    okay: "تأكيد",
    table: "جدول",
    add: "إضافة",
    or: "أو",
    edit: "تعديل",
    cancel: "إلغاء",
    save: "حفظ",
    cloneByType: "الاستنساخ حسب النوع",
    apply: "تطبيق",
    source: "المصدر",
    targets: "الأهداف",
    sureToCancelAlert: "هل أنت متأكد من الإلغاء؟",
    sureToDelete: "هل أنت متأكد من الحذف؟",
    startDate: "تاريخ البداية",
    endDate: "تاريخ النهاية",
    requiredStartDate: "تاريخ البداية مطلوب",
    requiredEndDate: "تاريخ النهاية مطلوب",
    requiredName: "الإسم مطلوب",
    requiredLevel: "المستوى مطلوب",
    enterInformationBelow: "أدخل المعلومات في الحقول أدناه",
    oui: "نعم",
    non: "لا",
    none: "لا شيء",
    and: "و",
    filterBy: "بحث عبر",
    filterByAddedDate: "بحث عبر تاريخ الإضافة",
    filtresEtRecherche: "المرشحات والبحث",
    sureTo: "هل انت متأكد؟",
    unsavedchanges: "تعديلات غير محفوظة!",
    unsavedchangesContent: "هل تريد حقا المغادرة؟ لم تقم بحفظ تعديلاتك!",
    unsavedChangesInfo:
      "لديك تعديلات غير محفوظة. يرجى الحفظ حتى تدخل تعديلاتك حيز التنفيذ.",
    unsavedChangesLeaveConfirm:
      "لديك تعديلات غير محفوظة. إذا غادرت، ستفقد هذه التعديلات. هل أنت متأكد أنك تريد المغادرة؟",
    savedChanges: "تم حفظ التعديلات بنجاح",
    typeNeeded: "أنواع الملفات المسموح بها: png و jpg و jpeg.",
    packAcces:
      "لا يمكنك الوصول إلى هذه الميزة باستخدام خطة الاشتراك الحالية الخاصة بك.",
    attention: "انتباه",
    nonGroupAssigned: "غير مصنف",
    pagination: {
      showTotal: "عرض {start}-{end} من {total} عنصر",
      pageSize: "عناصر في الصفحة",
      jumpTo: "الانتقال إلى",
      page: "صفحة",
      total: "المجموع",
      items: "عناصر",
    },
    date: "التاريخ",
    switchMode: "تبديل الوضع الداكن / الفاتح",
    loadingText: "جار التحميل...",
    selectDate: "اختر التاريخ",
    noData: "لا توجد بيانات",
    tpiAll: "الكل",
    pending: "قيد الإنتظار",
    dateRangeToday: "اليوم",
    dateRangeThisWeek: "هذا الأسبوع",
    dateRangeThisMonth: "هذا الشهر",
    dateRangeLastThreeMonths: "آخر ثلاثة أشهر",
    enabled: "مفعل",
    disabled: "معطل",
  },
  time: {
    minuteAgo: "منذ دقيقة واحدة",
    minutesAgo: "منذ {count} دقيقة",
    hourAgo: "منذ ساعة واحدة",
    hoursAgo: "منذ {count} ساعة",
    dayAgo: "منذ يوم واحد",
    daysAgo: "منذ {count} يوم",
    monthAgo: "منذ شهر واحد",
    monthsAgo: "منذ {count} شهر",
    yearAgo: "منذ سنة واحدة",
    yearsAgo: "منذ {count} سنة",
  },
  pdf: {
    pageNumber: "صفحة {current} / {total}",
  },
  months: {
    january: "جانفي",
    february: "فيفري",
    march: "مارس",
    april: "أفريل",
    may: "ماي",
    june: "جوان",
    july: "جويلية",
    august: "أوت",
    september: "سبتمبر",
    october: "اكتوبر",
    november: "نوفمبر",
    december: "ديسمبر",
  },
  pdfLogin: {
    loginInfo: "معلومات تسجيل الدخول",
    father: "الأب",
    mother: "الأم",
    guardian: "الوصي",
    teacher: "المعلم",
    student: "الطالب",
    students: "الطلاب",
    option1: "الخيار 1: تسجيل الدخول بالبيانات",
    option2: "الخيار 2: تسجيل الدخول برمز QR",
    username: "اسم المستخدم",
    password: "كلمة المرور",
    qrCodeInstruction:
      ": يمكنك تسجيل الدخول باستخدام رمز QR هذا في التطبيق المحمول",
    scanQRCode: "امسح رمز QR هذا باستخدام التطبيق المحمول:",
    howToAccess: "كيفية الوصول إلى المنصة",
    webPlatform: "المنصة الإلكترونية:",
    mobileApp: "التطبيق المحمول:",
    installApp: "قم بتثبيت تطبيق {appName} على هاتفك المحمول",
    importantInfo: "معلومات مهمة",
    changePassword: "• غيّر كلمة المرور في أول تسجيل دخول.",
    keepDocumentSafe: "• احتفظ بهذا المستند في مكان آمن.",
    contactAdmin: "• اتصل بالإدارة في حالة وجود مشاكل.",
    parentLogins: "بيانات دخول الآباء",
    teacherLogins: "بيانات دخول المعلمين",
    studentLogins: "بيانات دخول الطلاب",
    adminLogins: "بيانات دخول المسؤولين",
  },
  pack: {
    new: "جديد",
    upgrade: "ترقية",
    packMessage: "ترقية للحصول على المزيد من الميزات",
    typeNeededPNG: "أنواع الملفات المسموح بها: png.",
    infoConx: "معلومات تسجيل الدخول",
    lienConx: "رابط تسجيل الدخول",
    lienConxText: "أو تطبيق EdTeacher على الهاتف",
    upgradeModal: {
      title: "الميزة غير متاحة",
      subtitle: "خطة الاشتراك الحالية الخاصة بك لا تدعم هذه الميزة",
      description:
        "للوصول إلى هذه الميزة، تحتاج إلى ترقية خطتك. يرجى الاتصال بفريق المبيعات للحصول على مزيد من التفاصيل ومعلومات الأسعار.",
      contactInfo: "معلومات الاتصال",
      phone: "الهاتف",
      email: "البريد الإلكتروني",
      website: "الموقع الإلكتروني",
      contactSales: "اتصل بفريق المبيعات",
      close: "إغلاق",
    },
  },
  moduleType: {
    pedagogicalModule: "وحدة تعليمية",
    pilotModule: "وحدة نموذجية",
    specificModule: "وحدة نموذجية",
  },
  teacherAvailability: {
    available: "متوفر",
    notAvailable: "غير متوفر",
    saved: "تم حفظ التوفر بنجاح",
    notFilledYet: "المعلم لم يقم بملئ جدول التوفر الخاص به بعد",
  },
  smartSchedule: {
    generalParams: "الإعدادات العامة",
    comment: "تعليق",
    commentRequired: "التعليق مطلوب",
    startDay: "يوم البداية",
    endDay: "يوم النهاية",
    workingTime: "وقت العمل",
    breakingTime: "وقت الراحة",
    startAt: "يبدأ",
    endAt: "ينتهي",
    scheduleParmsAdded: "تمت إضافة إعدادات جدول جديدة بنجاح",
    generalParamsSaved: "تم حفظ الإعدادات العامة بنجاح",
    selectSchedule: "إختر الإعدادات",
    subjectsSchedParam: "المواد",
    weeklyRate: "الوقت في الأسبوع",
    module: "وحدة",
    subject: "مادة",
    moduleSpecific: "وحدة نموذجيّة",
    teacherClassParam: "تعيين المعلمين",
    teacherAffectedSuccess: "تم تعيين المعلمين بنجاح",
    teachersWeeklyRate: "الوقت في الأسبوع للمعلمين",
    name: "اسم الإعدادات",
    smartSchedule: "الجدول الذكي",
    smartSchedules: "الجداول الذكية",
    ready: "جاهز",
    pending: "قيد الإنتظار",
    finished: "منتهي",
    error: "خطأ",
    addParam: "إضافة إعدادات",
    migrateSuccess: "تم نقل الجداول الذكيّة بنجاح",
    migrate: "نقل الجداول الذكيّة",
    unmigrated: "تم إعادة استعادة جداول الأوقات بنجاح",
    noDataToUnmigrate: "جداول الأوقات تحتوي بالفعل على جلسات يدوية!",
    unmigrate: "استعادة الجداول اليدويّة",
    minDuration: "اعلى مدة",
    maxDuration: "أقصى المدة",
    fillAllClassroomsToGenerate: "الرجاء ملء جميع الفصول لتوليد جداول الأوقات ",
    weeklyRateMaxError:
      "يجب أن يكون الوقت في الأسبوع مساويًا أو أكبر من الحد الأقصى للمدة",
    weeklyRateMinError:
      "يجب أن يكون الوقت في الأسبوع مساويًا أو أكبر من الحد الأدنى للمدة",
  },
  calender: {
    calendar: "التقويم",
    noDescription: "لا يوجد وصف",
    month: "شهر",
    week: "أسبوع",
    day: "يوم",
    addEvent: "إضافة حدث",
    addEventTitle: "إضافة حدث جديد",
    duration: "المدة",
    durationRequired: "المدة مطلوبة",
    exam: "إمتحان",
    party: "حفلة",
    excursion: "رحلة",
    meeting: "إجتماع",
    other: "أخرى",
    eventType: "نوع الحدث",
    color: "اللون",
    typeRequired: "نوع الحدث مطلوب",
    editEventTitle: "تعديل الحدث",
    editEvent: "تعديل الحدث",
    editedEvent: "تم تعديل الحدث بنجاح",
    deletedEvent: "تم حذف الحدث بنجاح",
    addedEvent: "تم إضافة الحدث بنجاح",
    meetingBetweenTeachersAdvisors: "إجتماع بين المعلمين والمرشدين",
    createdBy: "إنشئ بواسطة المرشد",
  },
  chat: {
    ROOMS_EMPTY: "لا توجد غرف",
    ROOM_EMPTY: "لم يتم اختيار غرفة",
    NEW_MESSAGES: "رسائل جديدة",
    MESSAGE_DELETED: "تم حذف هذه الرسالة",
    MESSAGES_EMPTY: "لا توجد رسائل",
    CONVERSATION_STARTED: "بدأت المحادثة في:",
    TYPE_MESSAGE: "اكتب الرسالة",
    SEARCH: "يبحث",
    filter: "تصفية",
    IS_ONLINE: "متصل",
    searchParents: "ابحث عن ولي",
    parentDetails: "معلومات الوالدين",
    startNewConversationWithParent: "إنشاء محادثة جديدة مع أحد الأولياء",
    addParent: "إضافة الولي",
    deleted: "تم حذف الرسالة",
    LAST_SEEN: "اخر ظهور ",
    noLogin: "لا يوجد حساب تسجيل دخول",
    inactiveParent: "الولي غير نشط",
    alreadyAdded: "تمت الإضافة بالفعل للدردشة",
    availableToAdd: "متاح للإضافة",
    noParentsFound: "لم يتم العثور على أولياء أمور",
    legacyMessage: "الرسائل القديمة (قبل فصل نوع الوالد)",
    legacyMessageInfo:
      "الرسائل أعلاه تم إرسالها عندما كان للوالدين حساب مشترك.",
    deleteMessage: "حذف الرسالة",
    individualChats: "الدردشات الفردية",
    groupChats: "دردشات المجموعات",
    groupDetails: "تفاصيل المجموعة",
    name: "الاسم",
    members: "الأعضاء",
    teacher: "المعلم",
    parent: "ولي الأمر",
    manager: "الإدارة",
    group: "المجموعة",
    user: "مستخدم",
    description: "الوصف",
    noDescription: "لا يوجد وصف",
    classLabel: "القسم",
    subjectLabel: "المادة",
    noSubject: "لا توجد مادة",
    classroomBased: "بناءً على القسم",
    subjectBased: "بناءً على المادة",
    manualSelection: "يدوي",
    selectionMode: "طريقة الاختيار",
  },
  paymentStatus: {
    paymentStatus: "حالة الدفوعات",
    paidAmount: "المبالغ المدفوعة",
    monthRemainingPayments: " المبالغ المتبقيّة لشهر {month}",
    allRemainingPayments: "كل المبالغ المتبقيّة",
    noRemainingPyaments: "لا يوجد مبالغ متبقيّة",
    nothingPaid: "لا يوجد أي مفوعات",
    statutPaiement: "حالة الدفع",
    nomEleve: "اسم الطالب",
    categorie: "الفئة",
    frais: "الرسوم",
    montant: "المبلغ",
    etat: "الحالة",
    totalNonPaye: "إجمالي غير مدفوع",
    totalPaye: "إجمالي مدفوع",
    totalAPayer: "إجمالي للدفع",
    resteAPayer: "المتبقي للدفع",
    legende: "مفتاح الألوان",
    date: "التاريخ",
    inscription: "التسجيل",
    pastYearsArrearsTitle: "مبالغ غير مدفوعة من السنوات الدراسيّة السابقة",
    pastYearsArrearsSummary:
      "{fees} رسوم غير مدفوعة (الدراسة والأنشطة) في: {years}. يُنصح بتحصيلها قبل التسجيلات الجديدة.",
    pastYearsArrearsDetails: "عرض التفاصيل",
    pastYearsArrearsHide: "إخفاء التفاصيل",
    pastYearsArrearsCollect: "التحصيل على {year}",
    scolarite: "الدراسة",
    activite: "نشاط",
  },
  language: {
    ar: "العربيّة",
    fr: "الفرنسيّة",
    en: "الإنجليزيّة",
    sw: "السواحيليّة",
  },
  appreciation: {
    automatic: "ملاحظات آلية",
    automaticDescription: "نظام آلي بناء على المعدلات",
    automaticDescriptionCollege:
      "ملاحظة آلية حسب معدل المادة (إعدادي / ثانوي).",
    applyNotImplemented: "التطبيق غير متاح بعد؛ سيتم تفعيله في تحديث لاحق.",
    adminAppreciation: "ملاحظات الإدارة",
    withOptions: "ملاحظات محددة",
    manual: "ملاحظات يدوية",
    appreciation: "ملاحظات",
    applyAutomatic: "تطبيق الملاحظات الآلية",
    duplicateAppreciations: "استنساخ الملاحظات",
    existingAppreciations: "الملاحظات الموجودة",
    noExistingAppreciations: "لم يتم العثور على ملاحظات موجودة",
    selectToReplace: "اختر الملاحظات التي تريد استبدالها بملاحظات تلقائية:",
    add: "إضافة ملاجظة",
    changedToManual: "تم تغيير الملاحظات إلى الطريقة اليدوية",
    changedToOptions: "تم تغيير الملاحظات إلى الطريقة المخصصة",
    giveAppreciation: "إعطاء ملاحظة",
    bulkAppreciation: "ملاحظات جماعية",
    selectAppreciation: "اختيار ملاحظة",
    customAppreciation: "إضافة ملاحظة مخصصة",
    selectPredefinedAppreciation: "اختيار ملاحظة مسبقة",
    insertPredefinedAppreciation: "إدخال ملاحظة مسبقة",
    teacherManualDesc: "الأستاذ لديه الإمكانية لكتابة الملاحظات بشكل حر",
    saved: "تم حفظ الملاحظة بنجاح",
    deleted: "تم حذف الملاحظة بنجاح",
    teacherAppreciation: "ملاحظات المعلم",
    studentsWithoutAppreciation: "طلاب بدون أي ملاحظات",
    allStudentsHaveAppreciations: "تمت إضافة ملاحظات لكل الطلاب",
    missingAppreciation: "لم يتم إضافة ملاحظات",
    appreciationGiven: "تمت إضافة ملاحظات",
    noTeacherAssigned: "لم يتم تعيين معلم",
    transferAppreciation: "نقل الملاحظات",
    transferSource: "تقرير المصدر",
    transferTarget: "تقرير الهدف",
    selectTargetType: "اختر نوع التقرير الهدف",
    targetModulesSelected: "تم اختيار {count} وحدة/وحدات هدف",
    transferSelectSource: "يرجى اختيار وحدة مصدر",
    transferSelectTargetModules: "يرجى اختيار وحدة هدف واحدة على الأقل",
    transferNoModules: "لا توجد وحدات متاحة",
    transferPickTypeFirst: "اختر نوع التقرير الهدف لعرض الوحدات",
    transferOverwritePolicy: "ماذا تفعل إذا كانت الملاحظة موجودة مسبقاً",
    transferSkipExisting: "تخطي الملاحظات الموجودة",
    transferReplaceExisting: "استبدال الملاحظات الموجودة",
    transferConfirmTitle: "تأكيد النقل",
    transferConfirmContent:
      "نسخ الملاحظات من \"{source}\" ({sourceType}) إلى {count} وحدة/وحدات ({targets}) من النوع {targetType}؟ السياسة: {policy}",
    transferResult:
      "اكتمل النقل: تم نسخ {copied}، وتخطي {skipped}",
    applySuccess: "تم تطبيق الملاحظات الآلية على {count} طالب",
    applyNone: "لم يتم تطبيق أي ملاحظات آلية.",
    cloneCollegeSourceHint:
      "اختر المادة والسنة الدراسية التي تريد نسخ قواعد التقييم الآلي منها.",
    cloneCollegeTargetHint:
      "اختر سنة أو سنوات دراسية هدفاً أولاً. يمكنك اختيار عدة مستويات وعدة فصول؛ قائمة المواد تجمع إعداد البطاقة لكل هذه الأزواج. «تحديد الكل» يختار كل المستويات وكل الفصول وكل المواد ما عدا المصدر.",
    cloneSelectAllNoLevels: "لا توجد مستويات متاحة لهذه المؤسسة.",
    cloneSelectAllNoSubjects:
      "لم يتم العثور على مواد هدف، أو المادة المصدر فقط موجودة في الإعداد — أضف مواداً أخرى أو عدّل المرشحات.",
    cloneCollegeSourceIncomplete:
      "يرجى اختيار المادة المصدر والسنة الدراسية المصدر.",
    selectTargetSubjects: "يرجى اختيار مادة هدف واحدة على الأقل.",
    selectTargetTrimesters: "يرجى اختيار فصل هدف واحد على الأقل.",
    selectTargetLevels: "يرجى اختيار مستوى هدف واحد على الأقل.",
    selectSourceModule: "الرجاء اختيار الوحدة المصدر والسنة الدراسية",
    selectTargetSchoolYear: "الرجاء اختيار السنة الدراسية الهدف",
    selectTargetModules: "الرجاء اختيار الوحدات الهدف أو المرشحات",
    noTargetModulesFound: "لم يتم العثور على وحدات هدف",
    noAutoAppreciationToClone: "لا يوجد تقييم تلقائي للنسخ",
  },
  connected: {
    online: "متصل",
    offline: "غير متصل",
    all: "الكل",
    button_name: "المستخدمون",
    school_user: "مستخدم المشرف",
    noname: "لا اسم",
  },
  feedback: {
    title: "ملاحظات",
    sendFeedback: "إرسال ملاحظات",
    category: "فئة",
    comment: "تعليق",
    problem: "مشكلة / خطأ",
    idea: "فكرة للتحسين",
    others: "أخرى",
    section: "القسم",
    selectSection: "الرجاء تحديد القسم",
    priority: "أولوية",
    selectPriority: "الرجاء اختيار الأولوية",
    low: "قليلة",
    medium: "متوسط",
    high: "عالية",
    critical: "شديدة الأهمية",
    message: "رسالة",
    uploadFiles: "رفع الملفات",
    uploadAudio: "رفع مقطع صوتي",
    record: "تسجيل",
    successSent:
      "شكرًا لك على مساهمتك. سنراجعها ونرد عليك إذا لزم الأمر. نتمنى لك يومًا سعيدًا!",
  },
  certification: {
    Corresponding: "القرار المقابل",
    pass: "الارتقاء",
    fail: "يرسب",
    cnd_pass: "الارتقاء بالإسعاف",
    age_pass: "الارتقاء بالإسعاف العمري",
    add: "أضف الشهادة",
    moyPer: "المعدل المخصص للمدرسة",
    moySpec: "المعدّل المخصص",
    default: "قم بتعيين الشهادات الافتراضية",
    confirmDefault:
      "سيؤدي هذا الإجراء إلى إزالة شهائدك. هل أنت متأكد من تعيينه كافتراضي؟",
    name: "اسم الشهادة",
    min: "أدنى معدل",
    max: "أقصى معدل",
    minError: "لا يمكن أن يكون المعدل الأدنى أكبر من المعدل الأقصى",
    maxError: "لا يمكن أن يكون المعدل القصوى أقل من المعدل الأدنى ",
    defaultDone: "تم تحديث الشهادات بنجاح",
    addCertificateDesigns: "أضف تصاميم شهاداتك",
    namePlaceholder: "مثال: شهادة شكر",
    fileUploadedSuccessfully: "تم تحميل الملف بنجاح",
    moyenne: "المعدل",
    certificateDate: "تاريخ الشهادة",
    printDate: "تاريخ الطباعة",
    printDateEnabled: "تفعيل تاريخ الطباعة",
    dateFormat: "تنسيق التاريخ",
    dateLabel: "نص قبل التاريخ",
    stamp: "الختم",
    stampEnabled: "تفعيل الختم",
    stampPosition: "موضع الختم",
    stampScale: "حجم الختم",
    stampWarning: "لم يتم تكوين ختم لهذه المدرسة",
    stampHelp: "سيتم إضافة الختم تلقائيًا من إعدادات المؤسسة",
    generalSettings: "الإعدادات العامة",
    studentName: "اسم الطالب",
    className: "اسم الفصل",
    trimesterName: "اسم الثلاثي",
    schoolYearHeader: "السنة الدراسية",
    printDateHeader: "تاريخ الطباعة",
    stampHeader: "الختم",
    orientation: "الاتجاه",
    positionX: "الموضع X",
    font: "الخط",
    size: "الحجم",
    color: "اللون",
    enable: "تفعيل",
    format: "التنسيق",
    textBefore: "النص قبل",
    scale: "المقياس",
    vertical: "عمودي",
    horizontal: "أفقي",
    centered: "مركز",
    atStart: "في البداية",
    dateFormatDDMMYYYY: "يوم/شهر/سنة",
    dateFormatYYYYMMDD: "سنة-شهر-يوم",
    placeholderOrientation: "الاتجاه",
    placeholderPositionX: "الموضع X",
    placeholderSelectFont: "اختر خط",
    placeholderX: "س",
    placeholderY: "ص",
    placeholderTextSize: "حجم النص",
    placeholderDateLabel: "مثال: تاريخ الطباعة:",
    placeholderScale: "1.0",
    scaleHelp: "بين 0.1 و 3 (1 = الحجم العادي)",
  },
  decisionConseil: {
    decision: "القرار",
    decisionM: "القرار (ذكر)",
    decisionF: "القرار (أنثى)",
    decisionConseil: "قرارات المجلس",
    default: "قم بتعيين القرارات الإفتراضية",
    defaultDone: "تم تحديث القرارات بنجاح",
    confirmDefault:
      "سيؤدي هذا الإجراء إلى إزالة قراراتك. هل أنت متأكد من تعيينه كافتراضي؟",
    editorTitle: "قرارات المجلس لكل تلميذ",
    openEditor: "قرارات المجلس",
    auto: "تلقائي (حسب المعدل)",
    other: "أخرى",
    manualPlaceholder: "أدخل القرار",
    apply: "تطبيق",
    applyToSelected: "تطبيق على المحدد",
    selectDecision: "اختر قراراً",
    selectStudents: "يرجى تحديد تلميذ واحد على الأقل قبل التطبيق.",
    noClassroom: "يرجى اختيار قسم أولاً.",
    unsavedHint: "لديك تغييرات غير محفوظة. انقر على حفظ لتأكيدها.",
    bulkConfirmTitle: "تطبيق على المحدد",
    bulkConfirmContent:
      "سيتم تعيين هذا القرار فقط للتلاميذ المحددين الذين لديهم معدل عام. سيتم تخطي التلاميذ بدون معدل.",
    bulkConfirmCounts: "سيتم تحديث {eligible} من {selected} تلميذ(ة) محدد(ة).",
    noEligibleStudents:
      "لا يوجد لدى التلاميذ المحددين معدل عام. لا يمكن تطبيق القرار.",
    noMoyenneForStudent:
      "لا يوجد لدى هذا التلميذ معدل عام. لا يمكن تعيين قرار المجلس.",
    filterByStudentName: "البحث باسم التلميذ",
    decisonOnPlaceholder: "القرار المقابل",
    decisonOnRequired: "يرجى اختيار القرار المقابل (A/C/R) لمحضر مجلس القسم.",
    pvNotDisplayed: "غير معروض في المحضر",
    pvMissingKeyRow:
      "لن يظهر هذا التلميذ في محضر مجلس القسم. صحّح الإعدادات أو عيّن قراراً مقابلاً.",
    pvMissingKeyBanner: "{count} تلميذ(ة) بدون قرار مقابل (A/C/R)",
    pvMissingKeyHint:
      "لن يظهر هؤلاء التلاميذ في جداول المحضر. صحّح إعدادات قرارات المجلس أو عيّن قراراً لكل تلميذ.",
    pvMissingKeyMore: "... و {count} آخر(ين)",
    years: "فترات الدراسة",
  },
  notifications: {
    desactivation: "تم تعليق حسابك! اتصل بالإدارة لمزيد من المعلومات!",
    desactivateBuilding: "تم تعليق مؤسستك! اتصل بالإدارة لمزيد من المعلومات!",
    updateuser: "تم تعديل الحساب! الرجاء إعادة الاتصال!",
    updateAccess: "تم تعديل الصلاحيات! الرجاء إعادة الاتصال!",
  },
  login: {
    incorrectInfo: "إسم المستخدم أو كلمة المرور غير صحيحة",
    bienvenue: "مرحبا بك في",
    title: "نظام إدارة للمدارس",
    connectezVous: "تسجيل الدخول!",
    connextion: "تسجيل الدخول",
    requisMdp: " الرجاء إدخال كلمة المرور الخاصة بك!",
    requisUsername: "الرجاء إدخال اسم المستخدم!",
    username: "اسم المستخدم",
    password: "كلمةالمرور",
    connecte: "تم الإتصال",
    loginSuccess: "لقد قمت بتسجيل الدخول بنجاح",
    readAndAccept: "قرأت وأوافق على",
    termsAndConditions: "الشروط والأحكام",
    subscribePart1: " إذا لم تكن مدرستك مسجلة بعد، فاكتشف عروضنا الحصرية على",
    subscribePart2: " موقعنا",
    subscribePart3: "! وانضم إلى مجتمعنا التعليمي اليوم",
    scanQR: "قرّب رمز الاستجابة السريعة من كاميرا الويب لتسجيل الدخول.",
    back: "رجوع",
    qrCodeInvalid: "رمز الاستجابة السريعة غير صالح",
    oldQRCode:
      "يستخدم هذا الرمز تنسيقًا قديمًا. يرجى طلب رمز جديد من الإدارة.",
    qrCameraError: "تعذر الوصول إلى الكاميرا",
  },
  mfa: {
    twoFactorAuth: "المصادقة الثنائية",
    notEnabled: "المصادقة الثنائية غير مفعلة",
    notEnabledDescription:
      "قم بتفعيل المصادقة الثنائية لإضافة طبقة أمان إضافية لحسابك.",
    enable: "تفعيل",
    enabled: "المصادقة الثنائية مفعلة",
    enabledDescription: "حسابك محمي بالمصادقة الثنائية.",
    enabledSuccess: "تم تفعيل المصادقة الثنائية بنجاح.",
    disabled: "المصادقة الثنائية معطلة",
    disabledSuccess: "تم تعطيل المصادقة الثنائية بنجاح.",
    method: "الطريقة",
    authenticatorApp: "تطبيق المصادقة",
    sms: "رسالة نصية",
    phoneNumber: "رقم الهاتف",
    disable: "تعطيل",
    disableConfirmation:
      "هل أنت متأكد أنك تريد تعطيل المصادقة الثنائية؟ هذا سيجعل حسابك أقل أماناً.",
    passwordRequiredToDisable:
      "لأسباب أمنية، يرجى إدخال كلمة المرور الخاصة بك لتعطيل المصادقة الثنائية.",
    enterPasswordToDisable: "أدخل كلمة المرور الخاصة بك",
    passwordRequired: "كلمة المرور مطلوبة",
    invalidPassword: "كلمة مرور غير صحيحة. يرجى المحاولة مرة أخرى.",
    confirmDisable: "تعطيل المصادقة الثنائية",
    setup: "إعداد المصادقة الثنائية",
    chooseMethod: "اختر الطريقة",
    verify: "التحقق",
    complete: "إكمال",
    phoneRequired:
      "رقم الهاتف مطلوب للمصادقة عبر الرسائل النصية. يرجى إضافة رقم هاتف في ملفك الشخصي أولاً.",
    continue: "متابعة",
    scanQRCode: "امسح رمز QR",
    scanQRCodeDescription: "استخدم تطبيق المصادقة الخاص بك لمسح رمز QR هذا.",
    manualEntry: "لا يمكنك المسح؟ أدخل هذا الرمز يدوياً:",
    secret: "الرمز السري",
    next: "التالي",
    smsReady: "المصادقة عبر الرسائل النصية جاهزة. انقر على 'تفعيل' لتفعيلها.",
    verificationRequired: "التحقق مطلوب",
    enterAppCode: "أدخل الرمز المكون من 6 أرقام من تطبيق المصادقة الخاص بك.",
    enterSMSCode:
      "أدخل الرمز المكون من 6 أرقام المرسل إلى هاتفك. قد يستغرق وصول الرسالة النصية حتى 10 دقائق.",
    sentTo: "تم إرسال الرمز إلى",
    verificationCode: "رمز التحقق",
    codeRequired: "رمز التحقق مطلوب",
    codeLength: "يجب أن يكون الرمز 6 أرقام",
    codeFormat: "يجب أن يكون الرمز 6 أرقام",
    enterCode: "أدخل الرمز المكون من 6 أرقام",
    enterBackupCode: "أدخل رمز النسخ الاحتياطي",
    backupCode: "رمز النسخ الاحتياطي",
    authenticatorCode: "رمز المصادق",
    backupCodeLength: "يجب أن يكون رمز النسخ الاحتياطي 8 أحرف",
    backupCodeFormat: "يجب أن يكون رمز النسخ الاحتياطي 8 أحرف أبجدية رقمية",
    backupCodeHint:
      "أدخل أحد رموز النسخ الاحتياطي الخاصة بك. يمكن استخدام كل رمز مرة واحدة فقط.",
    useBackupCode: "لا يمكنك الوصول إلى المصادق؟ استخدم رمز النسخ الاحتياطي",
    useAuthenticatorCode: "استخدم رمز المصادق بدلاً من ذلك",
    resendCode: "إعادة إرسال الرمز",
    codeSent: "تم إرسال الرمز",
    codeSentDescription: "تم إرسال رمز تحقق جديد إلى هاتفك.",
    rateLimitExceeded: "تم الوصول إلى حد إعادة الإرسال",
    rateLimitMessage: "يجب عليك الانتظار {minutes} دقائق قبل طلب رمز جديد.",
    rateLimitMessageSingular:
      "يجب عليك الانتظار {minutes} دقيقة قبل طلب رمز جديد.",
    backupCodes: "رموز النسخ الاحتياطي",
    backupCodesDescription:
      "احفظ رموز النسخ الاحتياطي هذه في مكان آمن. يمكنك استخدامها للوصول إلى حسابك إذا فقدت الوصول إلى تطبيق المصادقة الخاص بك.",
    copyCodes: "نسخ الرموز",
    codesCopied: "تم نسخ رموز النسخ الاحتياطي إلى الحافظة",
    smsEnabledDescription:
      "تم تفعيل المصادقة عبر الرسائل النصية. سوف تتلقى رمزاً عبر الرسائل النصية عند تسجيل الدخول.",
    chooseMethodTitle: "اختر طريقة الأمان الخاصة بك",
    chooseMethodDescription:
      "حدد كيف تريد التحقق من هويتك عند تسجيل الدخول. نوصي باستخدام تطبيق المصادقة لأمان أفضل.",
    recommended: "موصى به",
    authenticatorAppDescription:
      "استخدم تطبيق مصادقة على هاتفك لتوليد رموز آمنة. يعمل حتى بدون اتصال بالإنترنت.",
    moreSecure: "أكثر أماناً من الرسائل النصية",
    fasterLogin: "تسجيل دخول أسرع - لا انتظار للرسائل النصية",
    moreReliable: "أكثر موثوقية - لا تأخير في الرسائل النصية",
    noNetworkNeeded: "لا حاجة لشبكة على هاتفك",
    industryStandard: "طريقة أمان معيارية في الصناعة",
    smsDescription: "تلقي رموز التحقق عبر رسالة نصية على رقم هاتفك.",
    setupAuthenticatorApp: "إعداد تطبيق المصادقة",
    setupAuthenticatorAppDescription:
      "اتبع هذه الخطوات البسيطة لإعداد المصادقة الثنائية باستخدام تطبيق مصادقة.",
    step1Download: "الخطوة 1: تنزيل تطبيق مصادقة",
    downloadInstruction:
      "إذا لم يكن لديك تطبيق مصادقة بعد، قم بتنزيل أحد هذه التطبيقات المجانية على هاتفك:",
    appStore: "متجر التطبيقات",
    googlePlay: "جوجل بلاي",
    step2Scan: "الخطوة 2: مسح رمز QR",
    scanQRCodeInstruction:
      "افتح تطبيق المصادقة الخاص بك وامسح رمز QR هذا بكاميرا هاتفك. سيضيف التطبيق حسابك تلقائياً تحت اسم 'EdManager'.",
    cantScan: "لا يمكنك مسح رمز QR؟",
    manualEntryDescription:
      "إذا لم تتمكن من مسح رمز QR، يمكنك إدخال هذا الرمز السري يدوياً في تطبيق المصادقة الخاص بك:",
    copySecret: "نسخ الرمز السري",
    secretCopied: "تم نسخ الرمز السري إلى الحافظة",
    iHaveScanned: "لقد قمت بمسح الرمز",
    setupSMS: "إعداد المصادقة عبر الرسائل النصية",
    setupSMSDescription:
      "سترسل المصادقة عبر الرسائل النصية رموز التحقق إلى رقم هاتفك المسجل.",
    smsReadyDescription:
      "المصادقة عبر الرسائل النصية جاهزة للتفعيل. سوف تتلقى رمزاً مكوناً من 6 أرقام عبر رسالة نصية في كل مرة تقوم فيها بتسجيل الدخول.",
    enterAppCodeDescription:
      "افتح تطبيق المصادقة الخاص بك وأدخل الرمز المكون من 6 أرقام المعروض على شاشتك.",
    enterSMSCodeDescription:
      "تحقق من هاتفك للحصول على رسالة SMS وأدخل الرمز المكون من 6 أرقام الذي تلقيته.",
    codeHint: "يتجدد الرمز كل 30 ثانية. تأكد من إدخال الرمز الحالي.",
    backupCodesWarning: "مهم: احفظ هذه الرموز الآن!",
    securityAlertTitle: "⚠️ توصية أمنية: قم بتمكين المصادقة الثنائية",
    securityAlertDescription:
      "احمِ حسابك بطبقة أمنية إضافية. تقلل المصادقة الثنائية بشكل كبير من خطر الوصول غير المصرح به إلى حسابك.",
    benefit1:
      "يمنع الوصول غير المصرح به حتى إذا تم اختراق كلمة المرور الخاصة بك",
    benefit2: "مطلوب من أفضل الممارسات الأمنية للحسابات الحساسة",
    benefit3: "يحمي بياناتك ويمنع هجمات الاستيلاء على الحساب",
    setupError: "خطأ في إعداد المصادقة الثنائية",
    setupErrorDescription: "تعذر تكوين المصادقة الثنائية",
    enableError: "خطأ في تفعيل المصادقة الثنائية",
    enableErrorDescription:
      "رمز التحقق غير صحيح. يرجى التحقق من الرمز وإعادة المحاولة.",
    disableError: "خطأ في تعطيل المصادقة الثنائية",
    disableErrorDescription:
      "كلمة المرور غير صحيحة. يرجى التحقق من كلمة المرور وإعادة المحاولة.",
    invalidCode: "رمز التحقق غير صالح",
    invalidCodeDescription: "رمز التحقق غير صحيح",
    smsError: "خطأ في إرسال الرسالة النصية",
    smsErrorDescription: "تعذر إرسال رمز الرسالة النصية",
    adminStatusOn: "المصادقة الثنائية مفعّلة",
    adminStatusOff: "المصادقة الثنائية غير مفعّلة",
    adminDisableConfirm:
      "تعطيل المصادقة الثنائية لهذا الحساب؟ سيتم تسجيل خروج المستخدم من جميع الأجهزة وسيتمكن من الدخول بكلمة المرور فقط.",
    adminDisableSuccess: "تم تعطيل المصادقة الثنائية بنجاح",
    adminDisableError: "تعذر تعطيل المصادقة الثنائية",
  },
  forceLogout: {
    passwordChanged: "تم تغيير كلمة المرور الخاصة بك",
    accountDeactivated: "تم تعطيل حسابك",
    mfaEnabled: "تم تفعيل المصادقة الثنائية على حسابك",
    securityEvent: "تم اكتشاف حدث أمني",
    sessionExpired: "انتهت الجلسة",
    loggedOut: "تم تسجيل خروجك. يرجى تسجيل الدخول مرة أخرى.",
  },
  trialCommercialBlock: {
    title: "انتهت فترة التجربة الخاصة بكم",
    badge: "انتهت التجربة المجانية",
    body:
      "شكرًا لتجربتكم EdTrust. لمواصلة إدارة مؤسستكم عبر EdManager، يُرجى الاتصال بفريقنا التجاري لاختيار العرض المناسب.",
    contactTitle: "اتصلوا بفريقنا التجاري",
    switchBuildingHint:
      "لا يزال بإمكانك الوصول إلى مؤسساتك الأخرى عبر تغيير المؤسسة أدناه.",
    accountsKeptTitle: "حسابات EdParent وEdTeacher محفوظة",
    parentsKept: "لا يتم حذف حسابات الأولياء.",
    teachersKept: "لا يتم حذف حسابات المدرّسين.",
    accountsKeptFootnote: "سيتم استعادة الوصول الكامل فور تسوية وضعيتكم.",
    phoneLabel: "الهاتف",
    emailLabel: "البريد الإلكتروني",
  },
  overduePaymentBlock: {
    title: "تم تعليق الوصول إلى EdManager",
    badge: "الدفع قيد الانتظار",
    body:
      "لم يتم بعد تسديد رسوم الاشتراك الخاصة بمؤسستكم. لإعادة تفعيل الوصول، يُرجى الاتصال بفريقنا التجاري لتسوية الدفع.",
    reasonLabel: "السبب:",
    reason: "تجاوز الموعد النهائي للدفع بأكثر من {days} يومًا (التاريخ المحدد: {date}، بتوقيت تونس، UTC+1).",
    reasonNoDate: "تجاوز الموعد النهائي للدفع بأكثر من {days} يومًا.",
    contactTitle: "هل لديكم سؤال حول الدفع؟ اتصلوا بفريقنا التجاري",
  },
  auth: {
    loginFailed: "فشل تسجيل الدخول",
    ssoLoginFailed: "فشل تسجيل الدخول SSO",
    genericError: "حدث خطأ",
  },
  niveau: {
    niveauPre: "مرحلة ما قبل المدرسة",
    niveau0: "تحضيري",
    playGroup: "مجموعة اللعب",
    pp1: "PP1",
    pp2: "PP2",
    niveau1: "سنة أولى",
    niveau2: "سنة ثانية",
    niveau3: "سنة ثالثة",
    niveau4: "سنة رابعة",
    niveau5: "سنة خامسة",
    niveau6: "سنة سادسة",
    autres: "أخرى",
    niveau7: "سنة سابعة",
    niveau8: "سنة ثامنة",
    niveau9: "سنة تاسعة",
    niveau10: "أولى ثانوي",
    niveau11: "ثانية ثانوي",
    niveau12: "ثالثة ثانوي",
    niveau13: "رابعة ثاتوي",
    autres: "أخرى",
  },
  assiduite: {
    assiduite: "الحضور",
    retard: "متأخر",
    present: "حاضر",
    absence: "غائب",
    exclus: "إقصاء",
    assiduiteMSA: "تم تحديث الحضور",
    assiduiteMoisChart: "{className} حضور الفصل هذا الشهر ",
    nb_absent: "عدد الغيابات",
    nb_delay: "عدد التأخيرات",
    nb_exclusion: "عدد الإقصاء",
    date: "التاريخ",
    areYouSureToEdit: "هل أنت متأكد أنك تريد تغيير حالة الحضور؟",
    erreurRecuperationSeances: "خطأ في استرجاع الجلسات",
    erreurRecuperationDonnees: "خطأ في استرجاع بيانات الحضور",
    callSheet: "ورقة الحضور",
    date: "التاريخ",
    type: "النوع",
    seance: "الجلسة",
  },
  teacherAttendance: {
    title: "حضور المعلمين",
    teacher: "المعلم",
    filterTeacher: "تصفية حسب المعلم",
    allTeachers: "جميع المعلمين",
    filterStatus: "تصفية حسب الحالة",
    allStatuses: "جميع الحالات",
    notMarked: "غير مسجل",
    status_present: "حاضر",
    status_absent: "غائب",
    status_late: "متأخر",
    status_absent_morning: "غائب (صباحًا)",
    status_absent_afternoon: "غائب (بعد الظهر)",
    status_absent_morning_short: "صباح",
    status_absent_afternoon_short: "بعد الظهر",
    lateTitle: "تسجيل التأخير",
    enterDelay: "يرجى إدخال مدة التأخير (بالدقائق)",
    delayPlaceholder: "المدة بالدقائق",
    updated: "تم تحديث الحضور",
    removed: "تم حذف الحضور",
    offSite: "خارج الموقع",
    offSiteHint: "تم تسجيل الحضور خارج نطاق المدرسة",
    tabDaily: "التسجيل اليومي",
    tabPersonnelDaily: "يومي (بدون جدول)",
    tabReport: "التقرير",
    reportMode: "نوع التقرير",
    personnelDailyReportTitle: "تقرير الحضور اليومي",
    markedDays: "الأيام المسجلة",
    tabComparison: "المتوقع مقابل الفعلي",
    searchByName: "البحث بالاسم",
    searchByNamePlaceholder: "اسم الموظف...",
    comparisonHint:
      "مقارنة الساعات المتوقعة (إعداد المادة × الأسابيع، أو الجدول / الإعداد اليومي) مع الساعات الفعلية. وسّع صف المعلم لعرض التفصيل حسب المادة.",
    comparisonTitle: "تقرير المتوقع مقابل الفعلي",
    expectedHours: "الساعات المتوقعة",
    actualHours: "الساعات الفعلية",
    absentHours: "ساعات الغياب",
    delayHours: "ساعات التأخير",
    varianceHours: "الفرق",
    timetableHours: "ساعات الجدول",
    noSubjectBreakdown: "لا يوجد تفصيل حسب المادة لهذا الشخص.",
    validationPending: "في انتظار المصادقة",
    validationValidated: "مصادق عليه",
    validate: "مصادقة",
    validateAll: "مصادقة الكل المعلق",
    validationHint:
      "التسلسل الهرمي للمصادقة مفعّل: يبقى التسجيل معلّقًا حتى يؤكده المسؤول.",
    moduleDisabled:
      "حضور المعلمين معطّل لهذه المؤسسة. فعّله من المؤسسة → الإعدادات.",
    personnelDailyHint:
      "حضور لكل شخص لكل يوم، غير مرتبط بالجدول الزمني. غير مسجل = حاضر افتراضيًا.",
    filterPersonnel: "تصفية حسب الموظف",
    allPersonnel: "جميع الموظفين",
    defaultPresent: "حاضر (افتراضي)",
    reportTitle: "تقرير حضور المعلمين",
    period: "الفترة",
    delayMinutes: "التأخير (دقيقة)",
    workedHours: "ساعات العمل",
    workedDays: "أيام العمل",
    editHistory: "سجل التعديلات",
    noHistory: "لا يوجد سجل تعديلات بعد",
    recordDeleted: "تم حذف هذا التسجيل",
    showDeleted: "إظهار المحذوف",
    historyBy: "بواسطة",
    historyBefore: "قبل",
    historyAfter: "بعد",
    historyAction_created: "إنشاء",
    historyAction_updated: "تعديل",
    historyAction_deleted: "حذف",
    historyAction_restored: "استعادة",
    source_teacher_checkin: "تسجيل المعلم",
    source_admin_manual: "إدخال يدوي",
    minShort: "د",
  },
  avance: {
    ajoutAvance: "إضافة دفع مسبق",
    ajoutAvanceSubTitle: ".الرجاء إكمال الحقول أدناه لإضافة دفع مسبق",
    montantAvance: "المبلغ المسبق",
    impoAnnulerAvance: "غير قادر على إلغاء الدفع المسبق",
    typeRecetteRequis: "نوع الدخل مطلوب",
    saisirChequeInfo: "أدخل معلومات الصك",
    saisirChequeEspaceInfo: "أدخل معلومات الصك و النقد",
    chequeNumRequis: "رقم الصك مطلوب",
    historiqueAvances: "سجل المدفوعات المسبقة",
    avanceAjoute: "تمت إضافة الدفع المسبق بنجاح",
  },
  xlsxUploader: {
    cliquer: "أدخل معلومات الصك و النقد",
    importEleves: "إدخال الطلاب",
    importElevesSubTitle: "إدخال الطلاب باتباع الشكل في القالب",
    downloadTemplate: "تحميل القالب الإكسل",
    affectation: "إدخال الوليين",
    affectationSubTitle: "إدخال الوليين",
    enregistrer: "تسجيل",
    enregistrerSubTitle: "التحقق ثم التسجيل",
    erreurValidationEleves: "خطأ في التحقق - ورقة الطلاب",
    erreurValidationParents: "خطأ في التحقق - ورقة الوليين",
    erreurFormatDate: "خطأ في تنسيق التاريخ",
    formatFichierInvalide: "تنسيق الملف غير صالح",
    formatFichierInvalideSubTitle:
      "يرجى تحميل القالب الصالح وإدخال البيانات الخاصة بك!",
    verifierDonnees: "التحقق من البيانات",
    affecterParents: "إدخال الوليين",
    sectionParent: "الوليين في الجدول",
    totalEleves: "إجمالي الطلاب",
    totalParents: "إجمالي الوليين",
    elevesNonAffectes: "طلاب غير مدخلين",
    verificationParents:
      "يجب التحقق من ، ويمكن أن يتم تعيين العديد من الوليين بنفس الاسم",
    eleveNonAffecte: "طلاب غير مدخلين",
    affecterParent: "إدخال الولي",
    rechercher: "البحث",
    reset: "إعادة التعيين",
    laLigne: "السطر",
    lesLignes: "الأسطر",
    dansLeFichierExcel: "في الملف الإكسل",
    verifierDonneesEleves: "يرجى التحقق من البيانات المطلوبة للطلاب",
    verifierDonneesParents: "يرجى التحقق من البيانات المطلوبة للوليين",
    verifierDonnees: "يرجى التحقق من البيانات المطلوبة للطلاب والوليين",
    listeImporteeSucces: "تمت إدخال القائمة بنجاح",
    elevesExistantsDeja: "طلاب موجودون محتملون",
    elevesExistantsDejaSubTitle:
      "قد يكون هؤلاء الطلاب موجودين بالفعل في قاعدة البيانات",
    verificationEnCours: "جاري التحقق من الطلاب الموجودين...",
    eleveExistePotentiellement: "هذا الطالب موجود محتمل بالفعل",
    confirmerEnregistrement: "تأكيد التسجيل",
    resumeImportation: "ملخص الاستيراد",
    totalDansFichier: "المجموع في ملف Excel",
    elevesAInserer: "الطلاب المراد إدراجهم",
    elevesAvecParentsSimilaires: "طلاب مع أولياء متشابهين",
    elevesExistantsPotentiels: "طلاب موجودون محتملون",
    elevesRetiresDeListe: "طلاب تم حذفهم من القائمة",
    confirmezVousEnregistrement: "هل تؤكد تسجيل هؤلاء الطلاب؟",
    eleves: "طلاب",
    confirmerRetraitTitle: "تأكيد الحذف",
    confirmerRetrait: "تأكيد الحذف",
    confirmer: "تأكيد",
    annuler: "إلغاء",
    confirmerRetraitMessage: "هل أنت متأكد من حذف {count} طالب من القائمة؟",
    actionIrreversible: "هذا الإجراء لا رجعة فيه",
    selectionnerAuMoinsUn: "يرجى تحديد طالب واحد على الأقل",
    elevesRetires: "تم حذف {count} طالب بنجاح",
    modeSelection: "وضع التحديد نشط",
    modeSelectionDescription:
      "حدد الطلاب المراد حذفهم من القائمة، ثم انقر على 'تأكيد الحذف'",
    retirerDeLaListe: "حذف من القائمة",
    elevesExistants: "طلاب موجودون بشكل محتمل",
    elevesExistantsPotentiels: "طلاب موجودون بشكل محتمل",
    existeDeja: "موجود بشكل محتمل في قاعدة البيانات",
    correspondances: "المطابقات",
    eleveExisteDeja: "طالب موجود بشكل محتمل",
    elevesExistentDeja: "طلاب موجودون بشكل محتمل",
    lignesExcel: "الأسطر",
    verifierAvantImport: "يرجى التحقق قبل الحفظ",
    erreurVerificationExistence:
      "خطأ في التحقق من الطلاب الموجودين. يرجى المتابعة بحذر.",
    filtrerPar: "تصفية حسب",
    effacerFiltres: "مسح التصفيات",
    incompleteImport:
      "تم إدخال القائمة بنجاح، ولكن بعض الطلاب أو الوليين لم يتم إدخالهم",
    erreurImportationParents: "خطأ في إدخال الوليين",
    erreurImportationEleves: "خطأ في إدخال الطلاب",
    erreurImportationSubTitle: "يرجى التحقق من الأسطر التالية",
    actions: "الإجراءات",
    nomPrenom: "الاسم الكامل",
    dateNaissance: "تاريخ الميلاد",
    adresse: "العنوان",
    sexe: "الجنس",
    telephone: "الهاتف",
    identifiantUnique: "المعرف الفريد",
    parent: "الولي",
    garcon: "ذكر",
    fille: "أنثى",
  },
  profil: {
    noParentCredentials: "هذا الولي ليس لديه حساب تسجيل الدخول",
    noParentInfo: "يرجى إضافة معلومات الولي لإنشاء حساب تسجيل الدخول",
    photoMediaConsent: "موافقة ولي الأمر على الصور والوسائط",
    photoMediaConsentCard: "الصور والوسائط",
    photoMediaConsentHint: "تنطبق على جميع التلاميذ المرتبطين بهذا الحساب.",
    parentSuggestionTitle: "الآباء الذين لديهم نفس رقم الهاتف",
    changerNomUtilisateur: "تغيير اسم المستخدم",
    historique: "السجل",
    paiement: "الدفع",
    payes: "مدفوع",
    nonPayes: "غير مدفوع",
    bulletin: " تقرير المدرسة عن التلميذ",
    qrCode: "رمز الاستجابة السريعة",
    informations: "معلومات",
    Control: "منظومة الولي",
    edtudiant: "معلومات التلميذ",
    paiementScol: "دفع الرسوم الدراسية",
    paiementAct: "دفع رسوم الانشطة",
    paidWithAvance: "مدفوع مقدماً",
    listeReglements: "قائمة المدفوعات",
    sexe: "الجنس",
    nom: "اللقب ",
    middleName: "الاسم الأوسط",
    prenom: "الاسم",
    nomFr: "اللقب بالفرنسية",
    prenomFr: "الاسم بالفرنسية",
    middleNameFr: "الاسم الأوسط بالفرنسية",
    nemisNumber: "رقم NEMIS للطالب",
    birthCertificate: "شهادة الميلاد",
    saccoName: "اسم SACCO",
    saccoBankName: "اسم بنك SACCO",
    fullname: "الاسم الكامل",
    dateNaissance: "تاريخ الميلاد",
    garcon: "ولد",
    fille: "بنت",
    adresse: "عنوان بريدي",
    postalAddress: "العنوان البريدي",
    physicalAddress: "العنوان الفعلي",
    tel: "هاتف",
    classe: "فصل دراسي",
    notes: "درجات",
    healthInformation: "المعلومات الصحية",
    bloodType: "فصيلة الدم",
    medicalCondition: "الحالة الطبية",
    medicalNotes: "الملاحظات الطبية",
    allergies: "الحساسية",
    parentNoteOnAllergies: "ملاحظة الوالدين حول الحساسية",
    unknown: "غير معروف",
    nonInscrit: "غير مسجل بعد",
    nomUser: "إسم المستخدم",
    mdp: "كلمة السر",
    currentPassword: "كلمة المرور الحالية",
    NewPwd: "كلمة المرور الجديدة",
    ConfirmNewPwd: "تأكيد كلمة المرور الجديدة",
    resetPwd: "إعادة تعيين كلمة المرور",
    gere: "إدارة",
    consulter: "مراجعة",
    consulterPaiement: "مراجعة الدفع",
    etat: "الحالة",
    mois: "الشهر",
    etablissement: "المؤسسة",
    ajouteLe: "أضيف في",
    lastModifi: "أخر تعديل",
    annulerInscri: "إلغاء الإشتراك",
    father: "الأب",
    mother: "الأم",
    guardian: "المشرف",
    changerPrametreParent: "تغيير إعدادات الولي",
    changerPrametreParents: "تغيير إعدادات الوليين",
    changerPrametreEleve: "تغيير إعدادات التلميذ",
    changerPrametreTeacher: "تغيير إعدادات المعلم",
    teacherCredentialsSessionWarning:
      "سيؤدي تغيير اسم المستخدم أو كلمة المرور إلى تسجيل خروج المعلم من جميع الأجهزة والجلسات.",
    noTeacherCredentials: "هذا المعلم ليس لديه حساب تسجيل الدخول",
    noTeacherInfo:
      "يرجى إضافة معلومات (البريد الإلكتروني) لهذا المعلم لإنشاء حساب تسجيل الدخول",
    ajouterCompteEnseignant: "إضافة حساب معلم",
    inscriActivitePour: "{name} تسجيل أنشطة إلى",
    poid: "وزن",
    taille: "الطول",
    maladies: "الأمراض",
    remarques: "ملاحظات",
    selectOption: "يجب إختيار عنصر واحد على الأقل",
    aucuneMaladieEnregistree: "لم يتم تسجيل أي مرض",
    aucuneDossierMedical: "لا توجد سجلات طبية!",
    annulationEleve: "إلغاء تسجيل التلميذ",
    deleteEleve: "حذف التلميذ",
    nameChangeRequest: "تم طلب تغييرات الاسم في",
    firstNameChangeRequest: "تغيير الاسم الأول من",
    lastNameChangeRequest: "تغيير اسم العائلة من",
    requestedBy: "تم الطلب من قبل",
    student: "تلميذ",
    to: "إلى",
    approuver: "قبول",
    rejeter: "رفض",
    birthPlace: "مكان الولادة",
    confirmDelete:
      "هل أنت متأكد من أنك تريد حذف صورة التلميذ؟ هذه الخطوة لا يمكن التراجع عنها.",
    viewStudentPhoto: "عرض صورة التلميذ",
    uploadStudentPhoto: "تحميل صورة التلميذ",
    removeStudentPhoto: "حذف صورة التلميذ",
    years: "سنة",
    profile: "الملف الشخصي",
    userProfilePhoto: "صورة الملف الشخصي",
    uploadUserPhoto: "تحميل صورة الملف الشخصي",
    removeUserPhoto: "حذف صورة الملف الشخصي",
    ajouterCompteParent: "إضافة حساب ولي",
    unavailableUserName: "اسم المستخدم غير متاح!",
    passwordMustIncludeDigit: "يجب أن تحتوي كلمة المرور على رقم واحد على الأقل",
    passwordMustIncludeUppercase:
      "يجب أن تحتوي كلمة المرور على حرف كبير واحد على الأقل",
    passwordMustIncludeLowercase:
      "يجب أن تحتوي كلمة المرور على حرف صغير واحد على الأقل",
    passwordMinLength: "يجب أن تكون كلمة المرور مكونة من 8 أحرف على الأقل",
    passwordMustNotMatchUsername:
      "يجب أن تكون كلمة المرور مختلفة عن اسم المستخدم",
    administration: "الإدارة",
  },
  topBar: {
    issuesHistory: "تاريخ المشاكل",
    projectManagement: "ادارة مشروع",
    typeToSearch: "بحث",
    findPages: "جاري البحث عن صفحات ...",
    actions: "الأفعال",
    status: "الحالة",
    profileMenu: {
      hello: "اهلا",
      billingPlan: "خطة الفواتير",
      role: "وظيفة",
      email: "البريد الإلكتروني",
      phone: "هاتف",
      editProfile: "تعديل الملف الشخصي",
      logout: "تسجيل الخروج",
    },
    notification: {
      notifications: "الاشعارات",
      searchPlaceholder: "...البحث عن إشعارات",
      noNotifications: "لا يوجد أشعارات!",
      errorFetch: "فشل في تحميل الإشعارات",
      readMore: "اقرأ المزيد",
    },
    bookmarks: "المفضلة",
    pack: "الباقة",
    storage: {
      menuLabel: "التخزين",
      menuHintNoBar: "افتح للتفاصيل والسجل",
      tooltip: "استخدام التخزين",
      modalTitle: "سجل استخدام التخزين",
      seriesStorage: "التخزين",
      noData: "لا توجد بيانات مسح بعد",
      objectsLabel: "عناصر",
      currentSummary: "الأحدث: {storage} · {count} عناصر",
      scopeDescription:
        "يشمل هذا المجموع كل التخزين المستخدم لمؤسستكم على المنصة، بما في ذلك المقررات والواجبات والملفات التي يرفعها الأساتذة وما شابه ذلك.",
      quotaTitle: "تخزين الباقة",
      quotaUsedOf: "{used} من {allowed} مستخدمة",
      quotaUnlimitedLine: "{used} مستخدمة · لا يوجد سقف تخزين في باقتكم",
      quotaOver:
        "لقد تجاوزتم حد التخزين المسموح للباقة. قد يُحظر الرفع. تواصلوا مع فريق المبيعات لزيادة الحصة.",
      quotaNear:
        "اقتربتم من حد التخزين. أفرغوا مساحة أو تواصلوا مع فريق المبيعات لزيادة الحصة.",
      objectsInLastScan: "{count} عنصرًا في آخر مسح",
      chartLimitLabel: "حد الباقة",
    },
  },
  command: {
    idCommand: "رقم الطلب",
    clientName: "اسم الزبون",
    date: "تاريخ",
    montant: "المبلغ",
    productName: "اسم المنتج",
    quantity: "الكمية",
    etat: "الحالة",
    status: "الحالة",
    detailsTitle: "تفاصيل الطلب",
    available: "متوفر",
    unavailable: "غير متوفر",
    productsInCommand: "المنتجات في الطلب",
    associatedCommands: "الطلبات المرتبطة",
    state: "الحالة",
    Commands: "الأوامر",
    createdAt: "تم الإنشاء في",
    pending: "	في الانتظار",
    inProgress: "قيد التنفيذ",
    cancelled: "تم الإلغاء",
    validated: "تم التحقق",
    active: "نشط",
    inactive: "غير نشط",
    note: "ملاحظة",
    showArchived: "عرض الأرشيف",
    search: " البحث حسب المرجع أو اسم العميل",
    showActive: "عرض النشطة",
    ennote: "أدخل ملاحظة للأمر",
  },
  product: {
    image: "صورة المنتج",
    name: "اسم المنتج",
    price: "السعر",
    availability: "التوفر",
    quantity: "الكمية",
    lastUpdate: "اخر تحديث",
    addProduct: "إضافة منتج",
    editProduct: "تعديل المنتج",
    visiblity: "الرؤية",
    tags: "العلامات",
    description: "الوصف",
    coverPicture: "صورة الغلاف",
    additionalPictures: "صور إضافية",
    submit: "إرسال",
    private: "خاص",
    public: "عام",
    visibility: "الرؤية",
    uploadAdditionalPictures: "رفع صور إضافية",
    uploadCoverPicture: "رفع صورة الغلاف",
    modifyCoverPicture: "تعديل صورة الغلاف",
    pictures: " صور",
    Products: "المنتجات",
    available: "متوفر",
    comingSoon: "قريبا",
    outOfStock: "غير متوفر",
    unavailable: "غير متاح",
    reqprice: "	السعر مطلوب",
    reqavailability: "التوفر مطلوب",
    reqquantity: "	الكمية مطلوبة",
    productAdded: "تم إضافة المنتج بنجاح",
    impoPubAjout: "تعذر إضافة المنتج",
    reqname: "الاسم مطلوب",
    tag: "أدخل الوسوم أو اختر من الموجود",
    ref: "أدخل المرجع (اختياري)",
    currency: "د.ت",
    search: "أدخل اسم المنتج",
    minprice: "أقل سعر",
    maxprice: "أقصى سعر",
    reference: "مرجع",
    noChanges: "لم يتم اكتشاف أي تغييرات",
    productDetails: "تفاصيل المنتج",
  },
  menu: {
    statstiqueGeneral: "إحصائيات عامة",
    financialStats: "إحصائيات مالية",
    accessTeacher: "صلاحيات المدرس",
    marketproducts_list: "قائمة المنتجات",
    marketPlace: "المتجر المدرسي",
    connection: "المستخدمين",
    powerbi: "powerBI",
    parametrageEtablissement: "إعدادات المؤسسة",
    parametrageComptabilite: "إعدادات المحاسبة",
    parametrageScolarite: "إعدادات المدرسة",
    printExport: "الطباعة والتصدير",
    dataManagement: "إدارة البيانات",
    accessManagement: "إدارة الوصول",
    parentLogins: "دخول أولياء الأمور",
    studentLogins: "دخول الطلاب",
    smartSchedule: "الجدول الذكي",
    teacherAvailability: "توفر المعلم",
    calender: "التقويم و الأحداث",
    supervision: "المراقبة",
    ptchat: "محادثات الأولياء مع الأساتذة",
    cheques: "الشيكات",
    chat: "الدردشة",
    logout: "تسجيل خروج",
    etablissement: "المؤسسة",
    generale: "عامة",
    accueil: "الإستقبال",
    parametrage: "إعدادات",
    actualite: "الأخبار",
    administration: "الادارة",
    autorisation: "الصلاحيات",
    utilisateur: "المستخدم",
    liste: "قائمة الطلاب",
    activites: "الأنشطة",
    cantine: "المطعم المدرسي",
    etatPaiement: "حالة الدفع ",
    inscriActiv: "التسجيل: أنشطة",
    emploiActivites: "الجدول: الأنشطة",
    assiduiteActivites: "الحضور: الأنشطة",
    scolarite: "المدرسة",
    inscriScol: "التسجيل المدرسي",
    etatPaiements: "حالة الدفع ",
    listePunition: "قائمة العقوبات",
    emploi: "جدول الأوقات",
    eleves: "التلاميذ",
    enseignants: "المعلمون",
    bulletin: "بطاقة الأعداد",
    bulletinCollege: "بطاقة أعداد الإعدادي / الثانوي",
    bulletinStatistique: "الإحصاء المدرسي",
    notes: "الأعداد",
    notesModule: "درجات المواد",
    notesParEleve: "درجات التلاميذ",
    notesModuleComplet: "درجات الوحدات",
    personnel: "طاقم العاملين",
    listePersonnels: "قائمة الموظفين",
    listeEnseignants: "قائمة المعلمين",
    teacherAttendance: "حضور المعلمين",
    listeActivites: "قائمة الأنشطة",
    virementBancaire: "حوالة مصرفية",
    listeEleves: "قائمة التلاميذ",
    comptabilite: "المحاسبة",
    etatRecettes: "قوائم الدخل",
    journaleCaisse: "مجلة النقدية",
    depenses: "المصاريف",
    nouvelleDepense: "مصروف جديد",
    fournisseurs: "الموردون",
    fournisseurProfile: "ملف المورد",
    factures: "الفواتير",
    saisiePaiement: "إدخال الدفع",
    historiquePaiements: "سجل المدفوعات",
    encaissementValidation: "التحقق من الاستلام",
    reconciliation: "المصادقة",
    avoirFournisseur: "إشعار دائن المورد",
    dettes: "الالتزامات",
    depensesPersonnel: "حساب الأجور",
    etatImpayes: "حالة غير مدفوعة الأجر",
    listeReglement: "قائمة المدفوعات",
    reglementsAnnules: "المدفوعات الملغاة",
    etatImpayesActivites: "حالة الأنشطة غير مدفوعة الأجر ",
    etatImpayesScolarite: "حالة المدرسية الغير مدفوعة الأجر",
    declaration: "بيان",
    decaissement: "الصرف",
    declarationTva: "بيان TVA",
    chiffreAffaires: "حجم الأعمال",
    chiffreAffairesScolarite: "معدل دوران الرسوم الدراسية",
    statistique: "الإحصائيات",
    administration: "الإدارة",
    actulite: "الأخبار",
    sms: "الرسائل القصيرة",
    smsAndNotifications: "الرسائل القصيرة والإشعارات",
    envoyerSms: "إرسال رسائل قصيرة",
    envoyerSmsLogin: "تسجيل دخول الوالدين",
    degital_library: "المكتبة الرقمية",
    degital_library_list: "قائمة المستندات",
    envoyerParClasseSms: "إرسال إلى الفصول",
    historiqueSms: "السجل",
    caisseAvance: "الدفع المسبق",
    assiduite: "دفتر الغيابات",
    preinscription: "التسجيل المسبق",
    profile: "ملفي الشخصي",
    certificate: "شهادة",
    finance: "المالية",
    tresorerie: "الخزينة",
    manageCaisses: "إدارة المحافظ",
    myCaisse: "محفظتي",
    encaissement: "تحصيل النقود",
    chequeEtTraite: "الشيكات و الأوراق المالية",
  },
  finance: {
    invoiceBuilder: "إضافة دفعة",
    legend: "المفتاح :",
  },
  accueil: {
    title: "لوحة التحكم",
    subtitle: "نظرة عامة على أنشطة وإحصائيات المدرسة",
    refresh: "تحديث",
    activite: "نشاط",
    activiteSubtitle: "إجمالي عدد الأنشطة المتاحة",
    eleves: "الطلاب",
    elevesSubtitle: "إجمالي عدد الطلاب المسجلين",
    employees: "الموظفين",
    employeesSubtitle: "إجمالي عدد الموظفين",
    classes: "فصل دراسي",
    classesSubtitle: "إجمالي عدد الفصول المتاحة",
    serviceActiv: "خدمات / أنشطة",
    benefice: "اجمالي الربح",
    montant: "مقدار",
    pourcentage: "النسبة المئوية",
    depense: "إجمالي المصروفات",
    RevenuDep: "المصروفات / الدخل ",
    depenses: "نفقات",
    revenu: "الإيرادات",
    tnd: "دينار",
    totalClasses: "إجمالي عدد الفصول",
    nombreDeClasses: "عدد الفصول",
    totalBoys: "إجمالي الأولاد",
    totalGirls: "إجمالي البنات",
    noDataClasses: "لا توجد بيانات للفصول",
    noDataNiveaux: "لا توجد بيانات للمستويات",
    moreDetails: "انقر هنا لمزيد من التفاصيل",
    boys: "أولاد",
    girls: "بنات",
    stat: "الإحصائيات التفصيلية",
    deletedClasse: "تم حذف الفسم",
    dashboard: {
      hello: "مرحباً",
      guest: "زائر",
      subtitleOverview: "إليك نظرة عامة على مؤسستك اليوم.",

      quickCantine: "المطعم",
      quickConsolidation: "التوحيد",
      quickClasses: "الأقسام",
      quickEmploi: "جدول الأوقات",
      quickEleves: "التلاميذ",
      quickDiscipline: "الانضباط",
      quickSupport: "الدعم",

      financialSummary: "الملخص المالي",
      seeDetails: "عرض التفاصيل",
      encaissementDuJour: "تحصيل اليوم",
      decaissementDuJour: "صرف اليوم",
      vsHier: "مقارنة بالأمس",
      soldeNetJour: "الرصيد الصافي لليوم",

      criticalTasks: "المهام الحرجة",
      criticalTasksSubtitle: "إجراء مطلوب · تحتاج إلى انتباهك",
      enAttente: "قيد الانتظار",
      allClear: "كل شيء محدّث!",
      punitionsPending: "عقوبات بانتظار المصادقة",
      actualitesPending: "أخبار بانتظار المصادقة",
      notificationsUnread: "إشعارات غير مقروءة",
      messagesUnanswered: "رسائل أولياء غير مُجابة",
      addNews: "إضافة خبر",
      newsCtaFirstTitle: "أضف أول خبر لديك وأعلم الأولياء",
      newsCtaFirstSubtitle: "شارك المعلومات المهمة لمؤسستك ببضع نقرات.",
      newsCtaTodayTitle: "أضف خبر اليوم لإبقاء الأولياء على اطلاع",
      newsCtaTodaySubtitle:
        "لم يُنشر أي خبر اليوم. ابقَ على تواصل مع الأولياء.",

      pendingRequests: "الطلبات المعلقة",
      enAttenteReponse: "بانتظار الرد",
      requestsParents: "الأولياء",
      requestsEleves: "التلاميذ",
      requestsPersonnel: "الموظفون",

      birthdays: "أعياد الميلاد القادمة هذا الشهر",
      searchByName: "البحث بالاسم...",
      staff: "موظف",
      student: "تلميذ",
      birthdayToday: "اليوم",
      birthdayTomorrow: "غداً",
      birthdayInDays: "خلال {days} أيام",
      birthdayOnDate: "{date}",
      noBirthdaysToday: "لا توجد أعياد ميلاد هذا الشهر",

      topStudents: "أفضل 10 معدلات",
      moyenne: "المعدل",
      bulletinPedagogique: "تربوي",
      bulletinPilote: "تجريبي",
      bulletinSpecifique: "خاص",
      noTopStudents: "لا توجد معدلات متاحة لهذا الكشف",
      accessDenied: "غير مصرح بالوصول",

      upcomingEvents: "الأحداث القادمة",
      seeAllEvents: "عرض كل الأحداث",
      noUpcomingEvents: "لا توجد أحداث خلال الأيام السبعة القادمة",

      latestNews: "آخر الأخبار",
      seeAllNews: "عرض كل الأخبار",
      noNews: "لا توجد أخبار حالياً",

      roomsAvailability: "توفر القاعات في الوقت الفعلي",
      free: "شاغرة",
      occupied: "مشغولة",
      noRooms: "لا توجد قاعات مُعدّة",

      disciplineBreakdown: "توزيع العقوبات التأديبية",
      total: "المجموع",
      cases: "حالة",
      noSanctions: "لا توجد عقوبات مسجّلة",
    },
  },
  action: {
    cloneSuccess: "تمت إعادة النسخ بنجاح",
    refreshPage: "يرجى تحديث الصفحة لرؤية التأثير الكامل",
    impressionReussie: "طباعة ناجحة",
    erreurImpression: "حدث خطأ أثناء الطباعة",
    reinitialiser: "إعادة تعيين",
    clone: "استنساخ",
    simpleBadge: "شارة بسيطة",
    badgeAvecPhoto: "شارة مع صورة",
    reset: "إعادة تعيين",
    imprimerTab: "طباعة الجدول",
    imprimerFreresSoeurs: "طباعة قائمة الإخوة والأخوات",
    imprimerBadges: "طباعة الشارات",
    imprimerNewBadges: "طباعة الشارات مع الصور",
    actions: "أجراءات",
    operation: "عملية",
    supprimer: "حذف",
    ajouter: "إضافة",
    modifier: "تعديل",
    consulter: "مراجعة",
    annuler: "إلغاء",
    enregistrer: "حفظ",
    afficher: "عرض",
    voir: "مشاهدة",
    desactiver: "إلغاء نشاط",
    activer: "تفعيل",
    imprimer: "طباعة",
    confirmer: "تأكيد",
    changer: "تغيير",
    importer: "تنزيل",
    preview: "عرض",
    clone: "استنساخ",
    revoke: "إلغاء",
    retour: "رجوع",
    refresh: "تحديث",
    retry: "إعادة المحاولة",
    selectAll: "تحديد الكل",
    bulkEdit: "تعديل مجمع",
    saveAll: "حفظ الكل",
    applySameReduction: "تطبيق نفس الخصم",
    selected: "محدد",
    editing: "جاري التعديل",
    fullyPaid: "مدفوع بالكامل",
    imprimerHistorique: "طباعة التاريخ",
    genererPdfHistorique: "إنشاء PDF",
    pdfGenereAvecSucces: "تم إنشاء PDF بنجاح",
    succes: "نجاح",
    upload: "تحميل",
    search: "بحث",
    fermer: "إغلاق",
    status: "الحالة",
    suivant: "التالي",
  },
  sms: {
    smsSentSuccess: "تم إرسال الرسالة النصية بنجاح",
    selectionner: "تحديد",
    corriger: "تصحيح",
    noValidParentsInformation: "لا توجد معلومات صحيحة الاولياء التلميذ:",
    noValidParentInformation: "لا توجد معلومات صحيحة لل{parent} التلميذ:",
    noAccount: "لا يوجد حساب لل{parent} التلميذ:",
    paymentRappel: "تذكير بالدفع",
    deatilsAutoSmsTitle: "تفاصيل الرسائل الآلية",
    seeProfile: "عرض الملف الشخصي",
    newPayment: "عملية دفع جديدة",
    newInscription: "تسجيل جديد",
    newAbsence: "غياب أو تأخر",
    newCourse: "درس أو تمرين",
    bulletinDispo: "بطاقة الأعداد متوفرة",
    actualite: "أخبار جديدة",
    autoSms: "إعدادات الرسائل التلقائية",
    autoPn: "إعدادات الإشعارات التلقائية",
    votreSolde: "رصيدكم",
    nbrSmsRestant: "عدد الرسائل القصيرة المتبقيّة",
    paymentTemplate1:
      'لقد دفعت {المبلغ المدفوع} دينار تونسي رسوم "{اسم النشاط}" لـ {اسم التلميذ}. هذا الدفع للفترة {قائمة الأشهر}.',
    paymentTemplate2:
      "لقد دفعت {المبلغ المدفوع} دينار تونسي رسوم الدراسة لـ {اسم التلميذ}. هذا الدفع للفترة {قائمة الأشهر}.",
    inscriptionTemplate1: "تم تسجيل طفلك {اسم التلميذ} بنجاح في {اسم النشاط}.",
    inscriptionTemplate2:
      "تم تسجيل طفلك {اسم التلميذ} بنجاح في الفصل {اسم الفصل}.",
    absenceTemplate1:
      'كان طفلك {اسم التلميذ} غائباً في {التاريخ} في {الوقت} أثناء جلسة "{اسم الجلسة}"',
    absenceTemplate2:
      'وصل طفلك {اسم التلميذ} متأخراً في {التاريخ} في {الوقت} أثناء جلسة "{اسم الجلسة}"',
    courseTemplate1: "تم إضافة درس جديد لطفلك بعنوان: {العنوان}.",
    courseTemplate2: "تم إضافة تمرين جديد لطفلك بعنوان: {العنوان}.",
    bulletinTemplate:
      "بطاقة الأعداد {البيداغوجية/النموذجية/المخصصة} لـ {اسم التلميذ} للثلاثي {الثلاثي} متوفرة على EdParent.",
    actualiteTemplate: "تم إضافة خبر جديد على Edparent بعنوان: {العنوان}.",
    nomlExpediteur: "إسم المرسل",
    desclExpediteur: "يتم إرسال الرسائل القصيرة بإسم",
    gererListeDistinateurs: "إدارة قائمة المستلمين",
    envoyerDesSms: "إرسال الرسائل القصيرة",
    listeVosEleves: "قائمة التلاميذ",
    listeClasses: "قائمة الفصول",
    selectionnerEleves: "حدد التلاميذ",
    selectionnerClases: "حدد الفصول",
    pressEnterToSelect: "إضغط على إدخال للتحديد",
    pressEnterToRemove: "إضغط على إدخال للإزالة",
    selected: "محدد",
    maxClassesReached: "يمكنك اختيار 4 فصول كحد أقصى",
    entrerNumerosSpecifiques: "ادخل الأرقام المخصصة",
    entrerNumerosSpecifiquesDesc: "يجب الفصل بين أرقام الهواتف بفاصلات",
    categorieTag: "الفئة / العلامة",
    categorieTagDesc: "تساعدك العلامات على تنظيم رسائلك بشكل جيد.",
    saisirCategorieTag: "أدخل الفئات / العلامات",
    contenueVotreMessage: "أدخل محتوى رسالتك",
    contenueMessage: "أدخل محتوى الرسالة القصيرة",
    listeFinale: "القائمة النهائية",
    nombreSms: "عدد الرسائل القصيرة",
    nombreMessage: "عدد الرسائل",
    nomberTotal: "العدد الجملي",
    nombreMessageParCategorie: "عدد الرسائل بالنسبة للكل فئة",
    nombreCaracteres: "عدد الحروف",
    pere: "الأب",
    mere: "الأم",
    guardian: "المشرف",
    specifique: "مخصص",
    destinataire: "المتلقي",
    telephone: "الهاتف",
    parents: "الأولياء",
    personnel: "شخصي",
    sanction: "عقوبة",
    bulletin: "بطاقة أعداد",
    envoyer: "إرسال",
    nonInscrit: "غير مسجّل",
    noOptions: "القائمة فارغة",
    jours: "الأيام",
    boiteEnvoieSms: "صندوق الرسائل القصيرة المرسلة",
    message: "الرسالة",
    numsSpecifiques: "الأرقام المخصصة",
    listeParents: "قائمة الأولياء",
    envoyeParUser: "تم إرسالها عبر المستخدم",
    groupe: "مجموعة",
    tags: "الفئات / العلامات",
    envoiDate: "تاريخ الإرسال",
    selectAll: "اختر الكل",
    selectAllTeachers: "اختر جميع المعلمين",
    selectAllStudents: "اختر جميع الطلاب",
    envoyerDesSmsLogins: "إرسال رسائل قصيرة لتسجيل الدخول",
    alertNumberSMS:
      "إذا كان اسم المستخدم وكلمة المرور طويلين (يتجاوزان 22 حرفًا عربيا أو 156 حرفا فرنسا) ، فيمكن أن يستهلك عدد الرسائل القصيرة للوالد 2 رسالة نصية قصيرة من الرصيد",
    envoyerDesLoginsParents: "إرسال بيانات دخول الأولياء",
    noRecipients: "يرجى تحديد على الأقل مستلم واحد لإرسال الرسالة القصيرة.",
    confirmSendTitle: "تأكيد إرسال الرسائل القصيرة",
    invalidPhones: "غير صالح",
    duplicatePhones: "مكرر",
    duplicateTag: "مكرر",
    noValidNumbers: "لا توجد أرقام صالحة",
    confirmTotalLabel: "عدد الرسائل القصيرة التي سيتم إرسالها",
    calculerNombreSms: "حساب عدد الرسائل القصيرة...",
    totalSms: "إجمالي الرسائل القصيرة: ",
    boiteEnvoie: "صندوق الرسائل القصيرة المرسلة",
    nomUtilisateur: "اسم المستخدم",
    nombreSmsEnvoye: "عدد الرسائل القصيرة المرسلة",
    date: "تاريخ",
  },
  library: {
    yes: "نعم",
    no: "لا",
    createdBy: "انشأ من قبل",
    lastUpdate: "اخر تحديث",
    createdAt: "أنشئت في",
    ajouterDocument: "إضافة مستند",
    editDocument: "تعديل مستند",
    titre: "العنوان",
    subject: "الموضوع",
    grade: "المستوى",
    search: "بحث",
    submit: "إرسال",
    contentType: "نوع المحتوى",
    text: "نص",
    video: "فيديو",
    attachment: "مرفق",
    uploadAttachment: "رفع مرفق",
    uploadVideo: "رفع فيديو",
    visibility: "الرؤية",
    public: "عام",
    private: "خاص",
    added: "تمت الإضافة",
    deleted: "تم الحذف",
    updated: "تم التحديث",
    document: "المستند",
    documents: "المستندات",
    levelRequired: "المستوى مطلوب",
    select: "اختر",
    docRequired: "تحتاج إلى تحميل المستندات",
    maxDocs: "لا يمكنك تحميل أكثر من 15 ملفاً",
    ressources: "الموارد",
    search: " أدخل العنوان للبحث",
    fileName: "اسم الملف",
    fileUploadError: "يمكنك فقط تحميل ملف JPG أو JPEG أو PNG!",
    uploadText: "رفع نص",
    shared: "مشترك",
    add: "إضافة",
  },
  mobileNotifications: {
    title: "الإشعارات المحمولة",
    detailsTitle: "تفاصيل الإشعارات الآلية للهاتف المحمول",
    enablePaymentReminder: "تفعيل تذكيرات الدفع",
    recurringFrequency: "تكرار التكرار",
    weekly: "أسبوعي",
    monthly: "شهري",
    dayOfWeek: "يوم الأسبوع",
    dayOfMonth: "يوم الشهر",
    time: "الوقت",
    selectDays: "اختر الأيام",
    paymentReminderTitle: "تذكير بالدفع",
    paymentReminderClassroom: "تذكير بالدفع - الدراسة",
    paymentReminderActivity: "تذكير بالدفع - الأنشطة",
    notificationTitle: "العنوان",
    // Monthly payment messages (matching Lambda function)
    messageClassroomMonthly:
      "تذكير: يرجى سداد رسوم الدراسة لشهر {month} حالياً. يرجى مراجعة التطبيق للتفاصيل.",
    messageActivityMonthly:
      "تذكير: يرجى سداد رسوم الأنشطة لشهر {month} حالياً. يرجى مراجعة التطبيق للتفاصيل.",
    // Tranche payment messages (matching Lambda function)
    messageClassroomTranche:
      "تذكير: يرجى سداد رسوم الدراسة للقسط المستحق حالياً. يرجى مراجعة التطبيق للتفاصيل.",
    messageActivityTranche:
      "تذكير: يرجى سداد رسوم الأنشطة للقسط المستحق حالياً. يرجى مراجعة التطبيق للتفاصيل.",
    sendNow: "إرسال الآن",
    sendNotificationSuccess: "تم إرسال إشعار تذكير الدفع بنجاح",
    sendNowConfirmTitle: "إرسال الإشعار الآن؟",
    sendNowConfirmMessage:
      "هل أنت متأكد من أنك تريد إرسال إشعارات تذكير الدفع لجميع الآباء الذين لديهم مدفوعات غير مدفوعة الآن؟",
    timeRequired: "الوقت مطلوب عند تفعيل الإشعارات",
    dayOfWeekRequired:
      "يجب اختيار يوم واحد على الأقل من أيام الأسبوع للتردد الأسبوعي",
    dayOfMonthRequired:
      "يجب اختيار يوم واحد على الأقل من أيام الشهر للتردد الشهري",
  },
  notificationConfig: {
    title: "إعدادات الإشعارات",
    sendPaymentValidationNotification: "إرسال إشعار عند التحقق من الدفع",
  },
  subject: {
    subject1: " اللغة العربية",
    subject2: "اللغة الفرنسية",
    subject3: "الرياضيات",
    subject4: "العلوم",
    subject5: "التاريخ ",
    subject6: "الجغرافيا",
    subject7: "التربية الإسلامية",
    subject8: "التربية المدنية",
    subject9: "التربية البدنية",
    subject10: " ",
    subject11: " اللغة الإنجليزية",
    subject12: "Langue Vivante",
    subject13: "Physique-Chimie",
    subject14: "Sciences de la Vie et de la Terre",
    subject15: "Technologie",
    subject16: "Philosophie",
  },
  actualite: {
    ajouterAlbum: "إضافة ألبوم",
    ajouterActualite: "إضافة خبر",
    modifierAlbum: "تعديل ألبوم",
    modifierActualite: "تعديل خبر",
    album: "ألبوم",
    date: " تاريخ الإصدار",
    seenAtLabel: "شوهد في",
    tousClasses: "جميع الأقسام",
    titre: "العنوان",
    categorie: "الفئة",
    customCategory: "فئة مخصصة",
    customCategoryPlaceholder: "أدخل فئة مخصصة",
    categoryInfo: "إعلام",
    categoryImportantInfo: "إعلام هام",
    categoryUrgent: "عاجل",
    categoryAvisImportant: "تنبيه مهم",
    categoryAvis: "تنبيه",
    categoryImportant: "مهم",
    categoryOther: "أخرى",
    cibles: "هدف",
    jaimes: "أعجبني",
    photos: "الصور",
    dateCreation: "تاريخ الإنشاء",
    tous: "الكل",
    enseignants: "المعلمون",
    eleves: "الطلاب",
    teachers: "المعلمون",
    students: "الطلاب",
    administration: "الادارة",
    parents: "الآباء",
    cliquer: "انقر أو اسحب الملف إلى المنطقة لتحميله",
    support:
      "دعم التنزيل الفردي أو الجماعي. احظر بشدة تحميل بيانات الشركة أو ملفات المجموعة الأخرى",
    description: "وصف",
    ajouterPub: "أضف منشورًا",
    trimestre1: "الثلاثي الأول",
    trimestre2: "الثلاثي الثاني",
    trimestre3: "الثلاثي الثالث",
    trimester_one: "الثلاث الأصلي",
    trimester_two: "الثلاث المستنسخ",
    retour: "إرجاع",
    pasImages: "لا توجد صور",
    mentionJaimes: "الإعجابات",
    seenByParentsNewsTitle: "الأولياء الذين شاهدوا هذا الخبر",
    notSeenByParentsNewsTitle: "الأولياء الذين لم يشاهدوا هذا الخبر",
    seenNotSeenParentsTitle: "تمت المشاهدة / لم تتم المشاهدة من قبل الأولياء",
    seenNotSeenParentsLabel: "تمت المشاهدة ولم تتم المشاهدة من قبل الأولياء",
    seenTrackedOnlyForParents:
      "يتم تتبع المشاهدات فقط للأخبار الموجهة إلى الأولياء.",
    noParentSeenNews: "لم يقم أي ولي بمشاهدة هذا الخبر بعد.",
    allParentsSeenNews: "جميع الأولياء المستهدفين شاهدوا هذا الخبر.",
    seenCountLabel: "تمت المشاهدة ({count})",
    notSeenLabel: "لم تتم المشاهدة",
    notSeenCountLabel: "لم تتم المشاهدة ({count})",
    modifierImages: "تحرير الصور",
    specificFor: "مخصص إلى",
    levels: "المستويات",
    classrooms: "الأقسام",
    students: "التلاميذ",
    activities: "الأنشطة",
    selectActivities: "اختر الأنشطة",
    activitiesRequired: "الأنشطة مطلوبة",
    specified: "مخصص",
    specifiedInfo: "سيتم تطبيق التخصيصات على الوالدين فقط",
    studentSpecifiedInfo: "سيتم تطبيق التخصيصات على التلاميذ فقط",
    teacherSpecifiedInfo: "سيتم تطبيق التخصيصات على المعلمين فقط",
    selectionnerEnseignants: "اختر المعلمين",
    files: "الملفات",
    noFiles: "لا توجد ملفات",
    details: "تفاصيل الخبر",
    aucuneActualite: "لا توجد أخبار منشورة",
    enableComments: "تفعيل التعليقات",
    commentsEnabled: "يمكن تفعيل أو تعطيل التعليقات لكل خبر على حدة",
    commentsDisabled: "التعليقات معطلة لجميع الأخبار",
    videoProcessing: "جاري معالجة الفيديو...",
    videoError: "خطأ في معالجة الفيديو",
    videoNotReady: "الفيديو غير جاهز بعد",
    videoLoading: "جاري تحميل الفيديو...",
    videoNotSupported: "متصفحك لا يدعم تشغيل هذا الفيديو",
    videoTagNotSupported: "متصفحك لا يدعم علامة الفيديو.",
    videoPlaybackError: "خطأ في تشغيل الفيديو",
    videoQualityAuto: "تلقائي",
    videoQuality: "الجودة",
    enableCommentsForThisNews: "تفعيل التعليقات لهذا الخبر",
    enableCommentsForThisNewsDesc: "السماح للمستخدمين بالتعليق على هذا الخبر",
    searchAndFilters: "البحث والمرشحات",
    total: "المجموع",
    actualitesPlural: "أخبار",
    clearFilters: "مسح المرشحات",
    searchByTitle: "البحث بالعنوان",
    filterByCategory: "تصفية حسب الفئة",
    actualiteLabel: "خبر",
    filterByCreationDate: "تصفية حسب تاريخ الإنشاء",
    filterByTarget: "تصفية حسب الهدف",
    search: "بحث",
    parentLabel: "الوالد:",
    videos: "الفيديوهات",
    uploadVideo: "انقر أو اسحب ملفات الفيديو هنا للتحميل",
    videoSupport: "دعم صيغ الفيديو MP4 و MOV و AVI و MKV",
    pendingValidation: "في انتظار التحقق",
    validated: "تم التحقق",
    approve: "موافقة",
    reject: "رفض",
    rejected: "مرفوض",
    confirmReject: "هل أنت متأكد من رفض هذا الخبر؟",
    newsValidated: "تمت الموافقة على الخبر بنجاح",
    newsRejected: "تم رفض الخبر بنجاح",
    createdByTeacher: "أنشأه المعلم",
    createdByLabel: "أنشأه",
    statusLabel: "الحالة",
    validation: "التحقق",
    validatedLabel: "تم التحقق",
    teacher: "معلم",
    admin: "مدير",
    filterByValidation: "تصفية حسب الحالة",
    allNews: "الكل",
    pendingOnly: "في الانتظار",
    validatedOnly: "تم التحقق",
    rejectedOnly: "مرفوضة",
    seeMore: "عرض المزيد",
    seeLess: "عرض أقل",
    like: "أعجبني",
    liked: "أعجبني به",
    commentBtn: "تعليق",
    writeCommentPlaceholder: "اكتب تعليقًا...",
    commentsCountLabel: "{count} تعليقات",
    noLikesYet: "كن أول من يعجبه هذا المنشور",
    noCommentsYet: "لا توجد تعليقات حتى الآن",
    postOptions: "خيارات",
    composerPrompt1: "ما الجديد في المدرسة اليوم؟",
    composerPrompt2: "شارك أخبار اليوم مع مجتمع المدرسة بالكامل…",
    composerPrompt3: "أعلن عن نشاط، احتفِ بإنجاز، أو أبقِ الجميع على اطلاع.",
    composerPrompt4: "لديك معلومة مهمة أو خبر سار تود مشاركته؟",
    composerPrompt5: "ألهم الأولياء والتلاميذ والفريق — ابدأ منشورك من هنا.",
    emojiPickerLabel: "إضافة رمز تعبيري",
    sendCommentLabel: "إرسال التعليق",
  },
  activityClub: {
    confirmDeletePost: "هل أنت متأكد من حذف هذا النشاط / النادي؟",
    tabNews: "المستجدات والألبومات",
    tabClub: "نشاط / نادي",
    addPost: "إضافة نشاط / نادي",
    editPost: "تعديل نشاط / نادي",
    noPosts: "لا توجد منشورات نشاط / نادي",
    searchByTitle: "البحث بالعنوان",
    activity: "نشاط / نادي",
    other: "آخر",
    customActivityName: "اسم النادي",
    price: "السعر",
    registrationStartDate: "تاريخ بدء التسجيل",
    clubStartDate: "تاريخ بدء النادي",
    clubEndDate: "تاريخ نهاية النادي",
    maxPlaces: "الحد الأقصى للأماكن",
    maxPlacesOptional: "اتركه فارغاً لعدد غير محدود",
    unlimited: "غير محدود",
    coverImage: "صورة الغلاف",
    attachments: "مرفقات",
    pending: "قيد الانتظار",
    accepted: "مقبول",
    rejected: "مرفوض",
    subscribers: "المشتركون",
    views: "المشاهدات",
    searchByName: "البحث بالاسم",
    allStatuses: "كل الحالات",
    parentName: "ولي الأمر",
    studentName: "التلميذ",
    status: "الحالة",
    subscribedAt: "تاريخ الاشتراك",
    accept: "قبول",
    reject: "رفض",
    register: "التسجيل",
    joinSuccess: "تم إرسال طلبك",
    registrationStartsOn: "يبدأ التسجيل في {date}",
    status_pending: "قيد الانتظار",
    status_accepted: "مقبول",
    status_rejected: "مرفوض",
    enableComments: "تفعيل التعليقات",
    commentsEnabled:
      "يمكن تفعيل أو تعطيل التعليقات لكل منشور نشاط / نادي على حدة",
    commentsDisabled: "التعليقات معطلة لجميع منشورات النشاط / النادي",
    enableCommentsForThisPost: "تفعيل التعليقات لهذا المنشور",
    enableCommentsForThisPostDesc:
      "السماح للمستخدمين بالتعليق على منشور النشاط / النادي هذا",
    composerPrompt1: "شارك نشاطاً أو نادياً جديداً…",
    composerPrompt2: "أعلن عن فتح التسجيل…",
    composerPrompt3: "انشر معلومات عن النادي القادم…",
  },
  common: {
    loading: "جار تحميل الإحصائيات...",
    selected: "محدد",
    editing: "جاري التعديل",
  },
  message: {
    noSelection: "لم يتم العثور على تحديد",
    noValidUpdates: "لم يتم العثور على تحديثات صالحة",
    bulkUpdateSuccess: "تم تحديث {count} خصم بنجاح",
    bulkUpdateError: "خطأ أثناء التحديث المجمع",
    enterReductionValue: "يرجى إدخال قيمة الخصم",
    paymentDataNotFound: "بيانات الدفع غير موجودة",
    loadingBulletin: "يرجى الإنتظار...",
  },
  confirmation: {
    revokeAccess: "هل تؤكد إلغاء الوصول؟",
    revokeAccessSaved: "تم إلغاء الوصول بنجاح",
    solveTheConflictError: "من فضلك قم بحل التعارض قبل المتابعة ",
  },
  etablissement: {
    reductionType: "نوع الخصم",
    pourcentage: "النسبة المئوية",
    dinar: "دينار",
    shilling: "شلن",
    currency: "العملة",
    TND: "الدينار التونسي (TND)",
    KES: "الشلن الكيني (KES)",
    currencyRequired: "العملة مطلوبة",
    accessUpdated: "تم تحديث الوصول بنجاح",
    editingAccess: "تعديل الوصول",
    access: "الوصول",
    editAccess: "تعديل الوصول",
    config: "الإعدادات",
    editConfig: "تعديل الإعدادات",
    editBuilding: "تعديل المؤسسة",
    accessConfig: "تم تعديل الإعدادات بنجاح",
    editingConfig: "جاري تعديل الإعدادات",
    alertDisableChat:
      "تمكين أو تعطيل الدردشة بين الآباء والمعلمين (إذا تم تعطيلها، سيفقد المعلمون والآباء الوصول إلى الدردشة على الفور في تطبيقات الهاتف المحمول والويب)",
    alertDisableTeacherParentGroupChat:
      "تمكين أو تعطيل دردشة مجموعات المعلم-الولي (إذا تم تعطيلها، تبقى المجموعات الحالية مرئية لكن للقراءة فقط للمعلمين والأولياء).",
    teacherParentGroupChat: "دردشة مجموعات المعلم-الولي",
    alertRequirePunishmentValidation:
      "عند التفعيل، تبقى العقوبات المضافة من طرف الإدارة في وضع الانتظار إلى حين مصادقة أحد المسؤولين عليها. عند التعطيل (الوضع الافتراضي)، تتم المصادقة عليها تلقائيًا فور إضافتها.",
    requirePunishmentValidation:
      "طلب مصادقة على العقوبات المضافة من طرف الإدارة",
    alertTeacherAttendanceEnabled:
      "تفعيل أو تعطيل وحدة حضور المعلمين (تسجيل الجلسات، الحضور اليومي، التقارير والمتوقع مقابل الفعلي). عند التعطيل يُخفى القائمة وتُحظر الواجهات البرمجية.",
    teacherAttendanceEnabled: "تفعيل حضور المعلمين",
    alertRequireTeacherAttendanceValidation:
      "عند التفعيل يبقى التسجيل معلّقًا حتى يصادقه المسؤول. عند التعطيل (الافتراضي) يكون التسجيل نهائيًا فورًا دون تغيير أوضاع الجلسات/اليومي الحالية.",
    requireTeacherAttendanceValidation:
      "طلب مصادقة حضور المعلمين/الموظفين (التسلسل الهرمي)",
    etablissements: "المؤسسات",
    classe: "فصل دراسي",
    classes: "الفصول الدراسية",
    niveaux: "المستويات",
    ajouterNiveau: "إضافة مستوى",
    createAllLevels: "إنشاء جميع المستويات",
    niveauxHint:
      "حدد الرسوم لكل مستوى. ترث الفصول العادية رسوم مستواها تلقائيًا.",
    levelRequiredFirst:
      "يجب إنشاء هذا المستوى في علامة التبويب المستويات قبل إضافة فصل.",
    niveauAffectation: "مستوى (تعيين)",
    elevesAffectes: "التلاميذ المعينون",
    salles: "القاعات",
    services: "الخدمات",
    activites: "الأنشطة",
    typeQualification: "أنواع الكفاءات",
    anneeScolaire: "سنة دراسية",
    logo: "الشعار",
    name: "الإسم",
    nom: "الإسم",
    designation: "التعيين",
    legalName: "الاسم القانوني",
    headMaster: "(ة)المدير",
    dateEnregistrement: "تاريخ التسجيل",
    createdAt: "تاريخ التسجيل",
    phone: "الهاتف",
    mainPhone: "الهاتف الرئيسي",
    email: "البريد الإلكتروني",
    mainEmail: "البريد الإلكتروني الرئيسي",
    additionalEmails: "بريد إلكتروني إضافي",
    addEmail: "إضافة بريد إلكتروني",
    additionalPhones: "هواتف إضافية",
    addPhone: "إضافة هاتف",
    kenyaPhoneRequirement: "يلزم وجود رقمي هاتف إضافيين على الأقل",
    MF: "الرقم الضريبي",
    schoolNEMISNumber: "رقم NEMIS للمدرسة",
    RIB: "الرقم البنكي",
    adress: "العنوان",
    geoLat: "خط العرض (GPS)",
    geoLng: "خط الطول (GPS)",
    geoRadius: "نصف القطر (متر)",
    geoHint:
      "إحداثيات المدرسة لتسجيل حضور المعلمين (خارج الموقع إذا كان خارج النطاق).",
    postalAddress: "العنوان البريدي",
    type: "النوع",
    niveau: "مستوى",
    fraisInscri: "رسوم التسجيل",
    fraisMensuel: "رسوم شهرية",
    fraisParJour: "رسوم يومية",
    typeActivite: "نوع النشاط",
    nameActivite: "اسم النشاط",
    parJour: "يومي",
    mensuelleParTranche: "شهري/بالأقساط",
    emploi: "جدول أوقات",
    dateCreation: "تاريخ الإنشاء",
    capacite: "طاقة الإستيعاب",
    fournisseurs: "المزودين",
    fournisseur: "المزود",
    fournisseurNonRequis: "المزود (غير مطلوب) :",
    service: "خدمات",
    responsable: "المسؤول",
    responsableActivite: "مسؤول النشاط",
    ordrePriorite: "الترتيب / الأولوية",
    order: "ترتيب",
    dateDebut: "تاريخ البدء",
    dateFin: "تاريخ النهاية",
    seuleFois: "مرة واحدة فقط",
    entrerInfo: "أدخل المعلومات في الحقول أدناه",
    modifierEmploi: "{name} تعديل الجدول الزمني لـ",
    other: "أخرى",
    editAlert:
      "تعديل العام الدراسي لا ينتج عنه تعديل في شهور تسجيل التلاميذ المسجلين بالفعل ، هل أنت متأكد من التعديل؟",
    clickOrDragToUpload: "انقر أو اسحب ملفًا إلى هذه المنطقة للرفع",
    clickForUploadLogo: "انقر لتعديل الشعار",
    ecole: "مدرسة الابتدائية",
    college: "مدرسة إعدادية",
    lycee: "مدرسة ثانوية",
    collegeEtLycee: "مدرسة إعدادية و ثانوية",
    primaireEtCollege: "مدرسة ابتدائية و إعدادية",
    jardinEnfant: "روضة أطفال",
    preSchool: "ما قبل المدرسة",
    prePrimary: "ما قبل الابتدائي",
    middle: "المدرسة المتوسطة",
    junior: "الثانوية الدنيا",
    senior: "الثانوية العليا",
    cache: "الختم",
    choisir: "إختيار",
    matriculeFiscale: "رقم التسجيل الضريبي",
    ArabicName: "الإسم بالعربية",
    delegeRegional: "المندوبية الجهوية",
    countyLocation: "موقع الدولة",
    slogan: "الشعار",
    nameRequired: "الإسم مطلوب",
    arabicNameRequired: "الإسم بالعربية مطلوب",
    legalNameRequired: "الاسم القانوني مطلوب",
    delegeRegionalRequired: "المندوبية الجهوية مطلوبة",
    countyLocationRequired: "موقع الدولة مطلوب",
    headMasterRequired: "المدير مطلوب",
    headMasterFrench: "المدير بالفرنسية",
    headMasterGender: "جنس المدير",
    additionalDirectors: "مديرون إضافيون",
    directorName: "اسم المدير",
    addDirector: "إضافة مدير",
    male: "ذكر",
    female: "أنثى",
    phoneRequired: "الهاتف مطلوب",
    showFeesParentPayment: "إظهار رسوم الدفع للآباء",
    showInvoicesParentPayment: "إظهار فواتير الدفع للآباء",
    alertShowFeesParentPayment:
      "إذا تم التمكين، سيكون الآباء قادرين على رؤية رسوم الدفع في التطبيق المحمول",
    alertShowInvoicesParentPayment:
      "إذا تم التمكين، سيكون الآباء قادرين على رؤية فواتير الدفع في التطبيق المحمول",
    rib20Digits: "يجب أن يحتوي الرقم البنكي على 20 خانة",
    tranches: "التقسيمات",
    fraisMensuelle: "الرسوم الشهرية",
    addTranche: "إضافة متكررة",
    tranche: "التقسيم",
    verifierTranches: "تحقق من رسوم التقسيمات",
    establishmentCode:  "رمز المنشأة",
  },
  comptabilite: {
    comptabilite: "محاسبة",
    fournisseur: "المزود",
    typeDepense: "نوع المصاريف",
    tabDepenseTypes: "أنواع المصاريف",
    tabDepenseCategories: "الفئات",
    tabDepenseSubcategories: "الفئات الفرعية",
    tabAssociates: "المرتبطون",
    tabUnites: "الوحدات",
    tabCompanies: "الشركات",
    companyLegalName: "اسم الشركة",
    companyCode: "الرمز",
    companyArchiveConfirm: "أرشفة هذه الشركة؟",
    companyArchived: "تم أرشفة الشركة",
    tabDebiteurs: "المدينون",
    tabDocumentDisplay: "عرض الإيصالات / الفواتير",
    documentDisplayIntro:
      "قم بتهيئة عرض الإيصالات والفواتير لهذه المؤسسة. الخيارات غير المضبوطة تحتفظ بالسلوك الافتراضي.",
    documentDisplayHeader: "الترويسة",
    documentDisplayFooter: "التذييل",
    documentDisplayPayment: "الدفع والتخفيضات",
    documentDisplayPrint: "الطباعة",
    documentDisplayPreview: "معاينة",
    previewDocument: "معاينة",
    previewHint: "انقر على معاينة لرؤية النتيجة بالخيارات الحالية (غير المحفوظة).",
    showLogo: "إظهار الشعار",
    titleMode: "عنوان المؤسسة",
    titleModeDefault: "العنوان الافتراضي",
    titleModeCustom: "عنوان مخصص",
    customTitle: "عنوان مخصص",
    includeSchoolTypeInTitle: "إدراج نوع المدرسة في العنوان",
    showClass: "إظهار القسم",
    showFooterText: "إظهار نص مخصص في الأسفل",
    footerText: "نص مخصص",
    showCachetSignatureLabel:
      "إظهار « الختم والتوقيع » (يُخفى عند عرض صورة الختم)",
    showStamp: "إظهار صورة الختم",
    stampScale: "حجم الختم",
    stampScaleHint: "اضبط حجم صورة الختم على ملف PDF (من 0.5x إلى 2.5x).",
    showSignature: "إظهار منطقة التوقيع",
    showTuitionSummary: "إظهار ملخص دفع الدراسة",
    showActivitySummary: "إظهار ملخص دفع الأنشطة",
    paymentSummaryHint:
      "المبلغ الإجمالي، الأشهر / الأقساط المدفوعة (مدين) وغير المدفوعة (دائن) للسنة الدراسية.",
    showTableNote: "عرض نص مخصص أسفل الجداول",
    tableNoteHint:
      "يُطبع النص كما هو في المساحة البيضاء أسفل جداول الدفع / الملخص مباشرة (وليس في التذييل).",
    tableNoteText: "النص المخصص",
    tableNoteColor: "لون النص",
    tableNoteFontSize: "حجم النص",
    tableNoteAlign: "موضع النص",
    tableNoteAlignAuto: "تلقائي (حسب اللغة)",
    tableNoteAlignLeft: "يسار",
    tableNoteAlignCenter: "وسط",
    tableNoteAlignRight: "يمين",
    showPaymentMethodDetails: "إظهار تفاصيل وسائل الدفع",
    showOnTransReduction: "إظهار التخفيض على الإجمالي",
    baseReductionDisplay: "عرض التخفيضات الأساسية",
    baseReductionHidden: "عدم الإظهار",
    baseReductionTotal: "إظهار مجموع التخفيضات",
    baseReductionPercentPerLine: "إظهار النسبة لكل عنصر",
    copiesPerPage: "تنسيق الطباعة",
    copiesPerPage1: "إيصال / فاتورة واحدة في الصفحة (عمودي)",
    copiesPerPage2:
      "نسختان في صفحة أفقية (نفس المستند يمينًا ويسارًا)",
    autoPrint: "طباعة الإيصال تلقائياً بعد الدفع",
    documentDisplayFiscal: "الضرائب (فاتورة)",
    tvaApplicable: "ضريبة القيمة المضافة مطبقة",
    showTva: "إظهار ضريبة القيمة المضافة على الفاتورة",
    tvaRate: "معدل ضريبة القيمة المضافة (كسر)",
    tvaRateHint:
      "مثال: 0.07 لـ 7%. اتركه فارغاً لاستخدام القيمة الافتراضية من البيئة.",
    timbreApplicable: "الطابع الجبائي مطبق",
    showTimbre: "إظهار الطابع على الفاتورة",
    timbreAmount: "مبلغ الطابع الجبائي",
    timbreAmountHint: "اتركه فارغاً لاستخدام القيمة الافتراضية من البيئة.",
    retenueApplicable: "الخصم من المصدر مطبق",
    showRetenue: "إظهار الخصم من المصدر على الفاتورة",
    retenuePercent: "الخصم من المصدر (%)",
    retenuePercentHint:
      "نسبة من المبلغ شامل الضريبة (نفس منطق خصم المورد).",
    documentNumbering: "ترقيم المستند",
    numberFormatCustom: "تنسيق مخصص",
    numberFormatCustomHint:
      "معطّل = التنسيق الحالي (YYYYMM + 3 أرقام). مفعّل = بادئة / تاريخ / تسلسل قابل للضبط، بشكل مستقل للإيصالات والفواتير.",
    numberFormatPrefix: "البادئة",
    numberFormatDatePattern: "تنسيق التاريخ",
    numberFormatDateNone: "بدون تاريخ",
    numberFormatSeparator: "الفاصل",
    numberFormatPadding: "أرقام التسلسل",
    numberFormatPattern: "نمط حر (اختياري)",
    numberFormatPatternHint:
      "الرموز: {PREFIX} {YYYY} {YY} {MM} {DD} {YYYYMM} {SEQ}. مثال: FACT-{YYYY}-{SEQ}.",
    numberFormatExample: "الأرقام التالية: {example}",
    numberFormatStartNumber: "رقم البداية",
    numberFormatStartNumberHint:
      "لمواصلة ترقيم موجود (مثال: آخر فاتورة FACT-2026-000598 ← أدخل 599). يتم احترام التنسيق والأصفار البادئة. إذا وُجدت مستندات بعد هذا الرقم، يستمر التسلسل بعد آخر رقم دون تكرار.",
    numberFormatTabReceipt:
      "الترقيم لإيصالات القبض فقط. انتقل إلى تبويب الفاتورة لضبط الفواتير.",
    numberFormatTabInvoice:
      "الترقيم للفواتير فقط. انتقل إلى تبويب الإيصال لضبط الإيصالات.",
    numberFormatSeparatorHint:
      "يُستخدم فقط إذا كان النمط الحر فارغاً. اتركه فارغاً لدمج البادئة والتاريخ والتسلسل.",
    numberFormatPatternPlaceholder:
      "فارغ = استخدام البادئة / التاريخ / الفاصل أعلاه",
    numberFormatPresetParts: "استخدام البادئة + التاريخ",
    numberFormatPresetYyyy: "تطبيق {PREFIX}-{YYYY}-{SEQ}",
    numberFormatPresetYyyymm: "تطبيق {PREFIX}-{YYYYMM}-{SEQ}",
    numberFormatSeqRequired:
      "يجب أن يحتوي النمط على {SEQ} ليكون لكل مستند رقم فريد. سيُضاف تلقائياً عند الحفظ.",
    numberFormatUnsafeChars:
      "الأحرف / \\ : * ? \" < > | لا يمكن أن تظهر في اسم ملف PDF وسيتم استبدالها بـ -.",
    reference: "المرجع",
    expenseKind: "النوع",
    expenseKindOpex: "مصاريف تشغيلية (OPEX)",
    expenseKindCapex: "أصول رأسمالية (إهلاك) (CAPEX)",
    expenseKindOther: "أخرى",
    capexFormula: "صيغة الإهلاك",
    description: "الوصف",
    category: "الفئة",
    categoryDeactivatedCascade:
      "تم أرشفة الفئة. تم أيضاً تعيين {subcategories} فئات فرعية مرتبطة إلى غير نشط.",
    categoryDeactivateConfirm:
      "أرشفة هذه الفئة؟ سيتم تعيين جميع الفئات الفرعية النشطة التابعة لها إلى غير نشط.",
    subcategory: "الفئة الفرعية",
    parentSubcategory: "فئة فرعية إضافية",
    direction: "الاتجاه",
    directionNormal: "عادي",
    directionInverse: "معكوس",
    visibility: "الظهور",
    visibilityHint: "الأشخاص أو الأدوار المعنية (نص حر)",
    associateType: "نوع المرتبط",
    associateInternal: "داخلي",
    associateExternal: "خارجي",
    fullName: "الاسم الكامل",
    unitKind: "نوع الوحدة",
    unitPrincipal: "أساسي",
    unitSecondary: "ثانوي",
    companyName: "اسم الشركة",
    debtorName: "اسم المدين",
    depenseTypeDeactivatedCascade:
      "تم أرشفة نوع المصروف. تم أيضاً تعيين {categories} فئات و{subcategories} فئات فرعية إلى غير نشط.",
    depenseTypeDeactivateConfirm:
      "أرشفة نوع المصروف هذا؟ سيتم تعيين جميع الفئات النشطة والفئات الفرعية التابعة لها إلى غير نشط.",
    deleteAllowed: "حذف",
    optional: "(اختياري)",
    typeRecette: "نوع الدخل",
    nom: "اسم",
    adresse: "عنوان بريدي",
    telephone: "هاتف",
    email: "البريد الإلكتروني",
    codeTVA: "رمز TVA",
    depenseParametrageNotice:
      "استخدم «حذف» لأرشفة عنصر (غير نشط). يختفي من هذه القوائم؛ تُحفظ البيانات للتتبع.",
    noDeleteHint:
      "الحذف يؤرشف السطر (غير نشط)؛ لا يظهر بعد ذلك في هذه القائمة.",
    planComptable: "خطة الحسابات",
    accountingClass: "الحساب",
    accountingParentClass: "الحساب الأب",
    accountingClassReference: "الحساب (المرجع)",
    accountingClassPlaceholder: "اختر حسابًا…",
    accountingClassHint:
      "اختياري. اختر حسابًا من خطة الحسابات التونسية (مثلا 60 – المشتريات).",
    accountingClassChildHint:
      "يُنشأ الحساب النهائي تلقائيًا انطلاقًا من الحساب الأب.",
    accountingClassParentMissing:
      "لا يوجد حساب للفئة الأم بعد. عيّنه أولاً ليتم توليد حساب الطفل تلقائيًا.",
    accountingClassParentMissingShort: "اختر حسابًا أبًا أولًا.",
    accountingClassChangeBlocked:
      "لا يمكن تغيير الحساب: توجد فئات فرعية لها حساب مُنشأ. أعد ضبطها أولًا.",
    accountingClassAutoGenerated: "تم التوليد تلقائيًا",
    accountingClassAutoGeneratedHint:
      "يُخصَّص رمز الطفل عند الإنشاء انطلاقًا من حساب الفئة.",
    accountingClassNotAssigned: "لا يوجد حساب",
    serviceClassMissing:
      "الخدمة الأم لا تملك حسابًا بعد. أدخله أولاً لتوليد حساب تلقائي.",
    accountingClassAssign: "تعيين حساب",
    subCategory: "الفئة الفرعية",
  },
  decaissement: {
    expenseMode: "نوع المصروف",
    normal: "عادي",
    declaree: "مصرح بها",
    beneficiaryType: "نوع المستفيد",
    beneficiaryName: "اسم المستفيد",
    companyEntity: "شركة المجموعة",
    amortizationEmpty:
      "لا توجد فواتير مورد مع إهلاك CAPEX لهذه السنة الدراسية.",
    amortizationFilterCategories: "فئات CAPEX",
    amortizationFilterCategoriesPlaceholder: "كل فئات CAPEX",
    amortizationFullyAmortizedCount: "أصول مُهلكَة بالكامل",
    amortizationKpiRemaining: "كم تبقّى من القيمة؟",
    amortizationKpiThisMonth: "كم إهلاك هذا الشهر؟",
    amortizationStatusActive: "قيد الإهلاك",
    amortizationStatusComplete: "مُهلك بالكامل",
    amortizationTab: "الإهلاك",
    amortizationTableCost: "الأساس القابل للإهلاك",
    amortizationTableRemaining: "القيمة المتبقية",
    amortizationTableThisMonth: "هذا الشهر",
    amortizationTableStatus: "الحالة",
    capexAmountColumn: "المبلغ",
    capexDepreciationPeriodMonths: "مدة الإهلاك (بالأشهر)",
    capexInvoiceDate: "تاريخ الفاتورة (للإهلاك)",
    capexJulyJuneHint:
      "يُحسب الإهلاك وفق نوافذ السنة الدراسية (من يوليو إلى يونيو).",
    capexMonthsColumn: "الأشهر",
    capexSchedulePreview: "جدول الإهلاك (معاينة)",
    capexSchoolYearColumn: "السنة الدراسية",
    capexSectionTitle: "إهلاك الأصول الرأسمالية",
    capexCompleteAmountsFirst:
      "أدخل أولاً مبالغ الفاتورة (بدون ضريبة، الضريبة، الإجمالي)؛ يظهر الإهلاك بعد احتساب المبلغ الواجب دفعه.",
    invoiceNumber: "رقم الفاتورة",
    invoiceDate: "تاريخ الفاتورة",
    invoiceDateNotInFuture: "لا يمكن أن يكون تاريخ الفاتورة في المستقبل.",
    depenseCreatedAt: "تاريخ الإنشاء",
    entryDateNotInFuture: "لا يمكن أن يكون تاريخ الإدخال في المستقبل.",
    description: "الوصف",
    amountTTC: "المبلغ TTC",
    amountTVA: "مبلغ TVA",
    amountAfterRetention: "المبلغ بعد الخصم",
    applyRetention: "تطبيق الخصم",
    attachment: "مرفق",
    paymentManagement: "إدارة الدفع",
    planPayment: "جدولة الدفع",
    payNow: "دفع فوري",
    totalToPay: "المجموع الواجب دفعه",
    addSchedule: "إضافة قسط",
    fundSource: "مصدر التمويل",
    myCaisse: "صندوقي",
    otherCaisse: "صندوق آخر",
    caisseBank: "صندوق بنكي",
    cashName: "اسم الصندوق",
    availableForThisPayment: "المبلغ المتاح لهذه الطريقة من الدفع",
    caisseBalanceExceedsAvailWarning:
      "هذا المبلغ يتجاوز الرصيد المتاح للحساب المحدد (لهذه الطريقة من الدفع).",
    receiptNumber: "رقم الوصل (السند)",
    methodReference: "مرجع طريقة الدفع",
    paymentSaved: "تم حفظ الدفع بنجاح",
    missingRequiredFields: "يرجى تعبئة كل الحقول المطلوبة",
    activityOrServiceRequired: "يرجى اختيار نشاط أو خدمة",
    formSectionGeneral: "معلومات عامة",
    formSectionDetails: "تفاصيل المصروف",
    formSectionAttachments: "المستندات الداعمة والملاحظات",
    formSectionPayment: "الدفع أو الأقساط",
    formSectionPaymentHint:
      "اختر دفعًا فوريًا أو أضف قسطًا واحدًا على الأقل. بالنسبة للمصاريف المعلنة للشريك/الموظف يجب أن يساوي مجموع الأقساط المبلغ.",
    paymentTotalInvalid: "أدخل مبلغ مصروف صالحًا أعلاه قبل اختيار طريقة الدفع.",
    validation: {
      expenseModeRequired: "وضع المصروف مطلوب",
      invoiceDateRequired: "تاريخ الفاتورة مطلوب",
      entryDateRequired: "تاريخ الإدخال مطلوب",
      subCategoryRequired: "الفئة الفرعية مطلوبة",
      amountRequired: "المبلغ مطلوب",
      amountMustBePositive: "يجب أن يكون المبلغ أكبر من صفر",
      beneficiaryTypeRequired: "نوع المستفيد مطلوب",
      beneficiaryRequired: "المستفيد مطلوب",
      invoiceNumberRequired: "رقم الفاتورة مطلوب",
      amountHTRequired: "المبلغ دون ضريبة مطلوب",
      amountHTMustBePositive: "يجب أن يكون المبلغ دون ضريبة أكبر من صفر",
      amountTTCRequired: "المبلغ شامل الضريبة مطلوب",
      amountTTCMustBePositive: "يجب أن يكون المبلغ شامل الضريبة أكبر من صفر",
      amountTVARequired: "مبلغ الضريبة مطلوب",
      capexPeriodRequired: "مدة الإهلاك (بالأشهر) مطلوبة",
      capexInvoiceDateRequired: "تاريخ فاتورة الأصل الثابت مطلوب",
      paymentCaisseRequired: "اختر صندوقًا لسطر الدفع {n}",
      paymentBankRequired: "اختر حساب بنك/صندوق لسطر الدفع {n}",
      scheduleDateRequired: "تاريخ القسط {n} مطلوب",
      scheduleAmountRequired: "يجب أن يكون مبلغ القسط {n} أكبر من صفر",
      selectCaisse: "اختر صندوقًا",
      selectCaisseBank: "اختر حساب بنك/صندوق",
      checkHighlightedFields: "تحقق من الحقول المميزة في النموذج.",
    },
    duplicateInvoiceTitle: "فاتورة مكررة",
    viewExistingInvoice: "عرض الفاتورة الموجودة",
    invoiceNotFoundForRedirect: "تعذر العثور على الفاتورة الموجودة.",
    schedulesMustMatchInvoice:
      "يجب أن يساوي مجموع أقساط الخطة المبلغ الكامل للمصروف (مطابق لمبلغ الفاتورة).",
    formSubsectionBeneficiary: "المستفيد",
    formSubsectionProvider: "تفاصيل المورد",
    formSubsectionAmount: "تفاصيل المبلغ",
    activityPercent: "النسبة (%)",
    activityPercentTotal: "المجموع المخصص",
    activityPercentSumMustBe100: "يجب أن يبلغ مجموع النسب 100٪.",
    activityDuplicate: "لا يمكن تكرار نفس النشاط.",
    addActivityAllocation: "إضافة نشاط",
    activitySingleFullAmount: "يُخصص 100٪ من المصروف لهذا النشاط.",
    activityAllocations: "الأنشطة (التوزيع)",
    classRoom: "الدراسة (القسم)",
    classRoomAllocations: "الدراسة (التوزيع)",
    levels: "المستويات",
    activityPlaceholder: "اختر نشاطاً (اختياري)",
    classRoomPlaceholder: "اختر قسماً (اختياري)",
    addClassRoomAllocation: "إضافة قسم",
    classRoomPercentTotal: "المجموع المخصص (الأقسام)",
    classRoomPercentSumMustBe100: "يجب أن يبلغ مجموع نسب الأقسام 100٪.",
    classRoomDuplicate: "لا يمكن تكرار نفس القسم.",
    classRoomSingleFullAmount: "يُخصص 100٪ من المصروف لهذا القسم.",
    combinedAllocationPercentTotal: "إجمالي الدراسة + النشاط",
    combinedAllocationPercentSumMustBe100:
      "يجب أن يبلغ مجموع نسب الدراسة والنشاط 100٪.",
    combinedAllocationSingleHint: "100٪ مخصصة لهذا العنصر.",
    paymentMethod: {
      cash: "نقدا",
      cheque: "شيك",
      virement: "تحويل",
      prelevement: "اقتطاع",
      traite: "كمبيالة",
      tpe: "TPE",
      mixed: "دفع متعدد",
    },
    directionInverse: "معكوس",
    directionInverseHint:
      "هذه الفئة الفرعية من نوع عكسي: المدرسة تسلف المال والمستفيد سيسدد لاحقاً. الدفع الفوري فقط متاح.",
    repaymentSchedule: "جدول السداد",
    repaymentScheduleHint:
      "حدد مواعيد سداد المستفيد للمبلغ الذي أقرضته المدرسة.",
    methodDetailsSumError:
      "يجب أن يتطابق مجموع المبالغ التفصيلية مع المبلغ الإجمالي للدفع",
    chequeNum: "رقم الشيك",
    traiteNum: "رقم الكمبيالة",
    chequeBank: "البنك",
    chequeTitulaire: "صاحب الشيك",
    traiteRib: "رقم الحساب البنكي",
    virementNum: "رقم التحويل",
    addCheque: "إضافة شيك",
    addTraite: "إضافة كمبيالة",
    addVirement: "إضافة تحويل",
    placeholderChequeNum: "الرقم",
    placeholderTraiteNum: "الرقم",
    placeholderDueDate: "يوم/شهر/سنة",
    placeholderBank: "البنك",
    placeholderTitulaire: "صاحب الحساب",
    placeholderRib: "20 رقماً",
    placeholderAmount: "0.000",
    placeholderVirementRef: "المرجع",
    legendDebtRow: "دين",
    legendDebtRowHint: "الصفوف بهذا الخلفية مرتبطة بدين.",
  },
  fournisseur: {
    title: "الموردون",
    companyName: "اسم الشركة",
    codeTVA: "رمز الضريبة",
    retenue: "الاستقطاع المطبق",
    website: "الموقع الإلكتروني",
    category: "الفئة",
    subCategory: "الفئة الفرعية",
    archiver: "أرشفة",
    archived: "مؤرشف",
    active: "نشط",
    archivedNotice: "هذا المورد مؤرشف ولا يمكن اختياره لمصاريف جديدة.",
    confirmArchive: "هل أنت متأكد من أرشفة هذا المورد؟",
    invoiceHistory: "سجل الفواتير",
    creditNotesTitle: "إشعارات دائنة للمورد (أvoir)",
    creditNotesEmpty: "لا توجد إشعارات دائنة لهذا المورد",
    schedulingStatus: "التخطيط",
    invoiceStatus: "حالة الفاتورة",
    paid: "مدفوعة",
    partial: "مدفوعة جزئياً",
    unpaid: "غير مدفوعة",
    scheduled: "مخططة",
    notScheduled: "غير مخططة",
    addSchedule: "إضافة تخطيط",
    editSchedule: "تعديل التخطيط",
    deleteSchedule: "حذف التخطيط",
    confirmDeleteSchedule: "هل أنت متأكد من حذف هذا التخطيط؟",
    scheduleExceedsRemaining: "إجمالي المبالغ المخططة يتجاوز المبلغ المتبقي",
    cannotEditPaidSchedule: "لا يمكن تعديل التخطيطات المدفوعة أو الملغاة",
    dueDate: "تاريخ الاستحقاق",
    scheduledAmount: "المبلغ المخطط",
    totalAmount: "المبلغ الإجمالي",
    totalPaid: "إجمالي المدفوع",
    remaining: "المتبقي",
    invoiceSummary: "ملخص الفاتورة",
    noSchedules: "لا توجد تخطيطات لهذه الفاتورة",
    scheduleCreated: "تم إنشاء التخطيط بنجاح",
    scheduleUpdated: "تم تحديث التخطيط بنجاح",
    scheduleDeleted: "تم حذف التخطيط بنجاح",
    schedulesDisabledInvoicePaid:
      "لا يمكن إضافة جدولة دفع عندما تكون حالة الفاتورة «مدفوعة».",
    supplierArchived: "تم أرشفة المورد بنجاح",
    allSuppliers: "جميع الموردين",
    showArchived: "عرض المؤرشفين",
    searchPlaceholder: "البحث بالاسم، رمز الضريبة...",
    totalInvoices: "إجمالي الفواتير",
    totalRemaining: "إجمالي المتبقي",
    contactInfo: "معلومات الاتصال",
    businessInfo: "المعلومات التجارية",
    financialOverview: "نظرة مالية عامة",
    paymentBreakdown: "توزيع المدفوعات",
    paymentProgress: "تقدم المدفوعات",
    scheduleProgress: "تقدم الجدولة",
    scheduleDueToday: "الاستحقاق التالي اليوم",
    scheduleDueInDays: "الاستحقاق التالي خلال {n} أيام",
    scheduleDueInMonths: "الاستحقاق التالي خلال {n} أشهر",
    scheduleOverdueByDays: "متأخر بمقدار {n} أيام",
    noData: "لا توجد بيانات",
  },
  factures: {
    title: "الفواتير",
    filtersTitle: "عوامل التصفية",
    searchPlaceholder: "بحث في التسمية، المرجع، رقم الفاتورة، الوصف…",
    filterInvoiceStatus: "حالة الدفع",
    filterSchedulingStatus: "التخطيط",
    filterBeneficiaryType: "نوع المستفيد",
    filterExpenseMode: "نوع المصروف",
    filterProvider: "المورد",
    filterDateRange: "تاريخ الفاتورة",
    resetFilters: "إعادة تعيين عوامل التصفية",
    detailTitle: "تفاصيل الفاتورة",
    reference: "المرجع",
    manageSchedules: "الأقساط",
    goToPaymentEntry: "إدخال الدفع",
    viewSupplier: "ملف المورد",
    attachments: "المرفقات",
    attachmentCount: "{n} ملف(ات)",
    noAttachments: "لا توجد مرفقات",
    beneficiaryProvider: "مورد",
    beneficiaryAssociate: "شريك",
    beneficiaryEmployee: "موظف",
    beneficiaryCompany: "شركة المجموعة",
    beneficiaryDebiteur: "مدين",
    tableLabel: "التسمية",
    paginationTotal: "{total} فاتورة",
    createNewDepense: "مصروف جديد",
    backToInvoiceList: "العودة إلى الفواتير",
  },
  saisiePaiement: {
    title: "إدخال الدفع",
    pending: "قيد الانتظار",
    pendingSchedules: "التخطيطات المعلقة",
    unplannedExpenses: "المصاريف غير المخططة",
    paySelected: "دفع المحدد",
    groupPayment: "دفع مجمع",
    duplicateSchedule: "تكرار التخطيط",
    paymentExecuted: "تم الدفع بنجاح",
    selectAtLeastOne: "اختر تخطيطاً واحداً على الأقل",
    beneficiary: "المستفيد",
    invoiceRef: "مرجع الفاتورة",
    dueDate: "تاريخ الاستحقاق",
    amount: "المبلغ",
    selectFundSource: "اختر مصدر التمويل",
    selectMethod: "اختر طريقة الدفع",
    confirmPayment: "تأكيد الدفع",
    totalSelected: "إجمالي المحدد",
    addScheduleFromHere: "إضافة تخطيط",
    noUnplannedExpenses: "لا توجد مصاريف غير مخططة",
    noPendingSchedules: "لا توجد تخطيطات معلقة",
    filterBeneficiaryType: "نوع المستفيد",
    filterExpenseMode: "نوع المصروف",
    filterDueDateRange: "فترة الاستحقاق",
    expenseLabel: "المصروف",
    expenseMode: "النوع",
    splitPaymentsHint:
      "أضف سطراً لكل طريقة. النقد يستخدم صندوقك الرئيسي فقط؛ الشيك والتحويل والكمبيالة وTPE تستخدم حساباً بنكياً. يجب أن يساوي المجموع الإجمالي.",
    tableSearch: "بحث",
    tableSearchPlaceholder:
      "مصروف، مستفيد، مرجع الفاتورة، نوع المستفيد، الوضع أو المبلغ…",
    paymentLine: "سطر الدفع {n}",
    addPaymentLine: "إضافة سطر دفع",
    removePaymentLine: "حذف هذا السطر",
    splitsTotal: "المجموع الموزّع",
    splitsSumMismatch: "يجب أن يساوي المجموع الموزّع المبلغ المحدد",
    lineAmountRequired: "كل سطر يجب أن يكون له مبلغ موجب",
    manageSchedules: "إدارة الأقساط",
    cannotLoadDepenseForSchedules:
      "تعذر فتح تعديل الأقساط (بيانات المصروف ناقصة).",
    drawerDepenseSchedulesTitle: "المصروف وجدول دفع الأقساط",
    depenseDetailsSection: "تفاصيل الفاتورة / المصروف",
    schedulesEditHint:
      "عدّل الأقساط المعلقة أو أضف أسطراً أو احذفها. يجب ألا يتجاوز المجموع المجدول المبلغ الإجمالي للمصروف.",
    clickedScheduleBadge: "من القائمة",
    batchPendingTotal: "إجمالي الأقساط المعلقة",
    batchRequiredRemaining: "المطلوب (إجمالي الفاتورة ناقص المدفوع)",
    batchSchedulesEmptyHint:
      "أضف سطراً أو أكثر. يجب أن يساوي المجموع المبلغ المطلوب قبل الحفظ.",
    unsavedSchedulesHint: "احفظ أو ألغِ لتحديد الأقساط للدفع.",
    batchSchedulesSaved: "تم حفظ خطة الأقساط.",
    selectToPaySection: "ادفع الآن (اختر الأقساط)",
  },
  paiementHistory: {
    title: "سجل المدفوعات",
    paymentDetail: "تفاصيل الدفع",
    date: "التاريخ",
    paymentMode: "نوع الدفع",
    immediate: "فوري",
    scheduled: "مجدول",
    status: "الحالة",
    validationStatus: "حالة التحقق",
    method: "الطريقة",
    fundSource: "المصدر",
    createdBy: "أنشئ بواسطة",
    rejectedBy: "رُفض بواسطة",
    rejectedAt: "رُفض في",
    validatedBy: "صُوثق بواسطة",
    validatedAt: "صُوثق في",
    rejectionReasonMissing: "لم يُسجَّل سبب الرفض",
    searchReceipt: "بحث برقم الإيصال",
    dateRange: "الفترة",
    noPayments: "لا توجد مدفوعات",
    relatedInvoices: "الفواتير المرتبطة",
    schedules: "الأقساط المرتبطة",
    schedulesThisPayment: "الأقساط المدفوعة بهذا الدفع",
    otherSchedules: "تخطيطات أخرى",
    otherSchedulesHint:
      "أقساط أخرى لنفس المصاريف (معلقة أو مدفوعة بشكل منفصل).",
    debtLabel: "عنوان الدين",
    debtRepaymentStatus: "سداد الدين",
    debtRemainingInstallments: "الأقساط المتبقية على هذا الدين",
    debtNoRemainingInstallments:
      "لا توجد أقساط معلقة على هذا الدين (الكل مدفوع أو لا يوجد جدول).",
    expenseOrInvoice: "مصروف / مرجع",
    statuses: {
      completed: "مكتمل",
      pending: "قيد الانتظار",
      cancelled: "ملغى",
      awaiting_validation: "في انتظار التحقق",
    },
    validationStatuses: {
      pending_validation: "قيد الانتظار",
      validated: "تم التحقق",
      rejected: "مرفوض",
    },
  },
  encaissementValidation: {
    title: "التحقق من الاستلام (عكسي)",
    detailTitle: "تفاصيل الأقساط العكسية",
    searchPayeur: "البحث حسب الدافع / العنوان",
    filterBenType: "نوع المستفيد",
    filterDateRange: "فترة الاستحقاق",
    colPayeur: "الدافع",
    colLibelle: "العنوان",
    colMontant: "المبلغ",
    colDueDate: "تاريخ الاستحقاق",
    colCreatedBy: "أنشئ بواسطة",
    colDepensePaymentStatus: "حالة الصرف",
    colStatut: "الحالة",
    statusPending: "قيد الانتظار",
    statusReceived: "مستلم",
    statusCancelled: "ملغى",
    confirm: "تأكيد",
    confirmDisabledHint:
      "يجب التحقق من الصرف في المطابقة قبل تأكيد الاستلام.",
    outboundPaymentNone: "لا يوجد صرف",
    confirmTitle: "تأكيد استلام الدفعة",
    paymentMethod: "طريقة الدفع",
    fundDestination: "وجهة الأموال",
    receivedBy: "مستلم بواسطة",
    receivedAt: "تاريخ الاستلام",
    noSchedules: "لا توجد أقساط عكسية",
    depenseInfo: "معلومات المصروف",
    paymentInfo: "تفاصيل الدفعة المستلمة",
    otherSchedules: "أقساط أخرى على هذا المصروف",
    repaymentSchedules: "أقساط السداد (عكسي)",
    repaymentComplete: "تم السداد بالكامل",
    scheduleTotal: "مبلغ القسط الواجب استلامه",
    splitPaymentsHint:
      "أضف سطراً لكل طريقة دفع. يجب أن يساوي مجموع المبالغ إجمالي القسط. يمكن لكل سطر أن يكون له صندوق أو حساب بنكي مختلف.",
    paymentLine: "سطر الدفع {n}",
    addPaymentLine: "إضافة سطر دفع",
    removePaymentLine: "حذف هذا السطر",
    splitsTotal: "المجموع الموزّع",
    splitsSumMismatch: "يجب أن يساوي المجموع الموزّع مبلغ القسط",
    lineAmountRequired: "كل سطر يجب أن يكون له مبلغ موجب",
    pendingInverseSchedules: "أقساط قيد الانتظار",
    editRepaymentSchedulesSection: "أقساط السداد",
  },
  reconciliation: {
    title: "المصادقة",
    pendingValidation: "في انتظار المصادقة",
    validated: "تمت المصادقة",
    rejected: "مرفوض",
    rejectionReason: "سبب الرفض",
    rejectionReasonRequired: "سبب الرفض مطلوب",
    paymentValidated: "تمت المصادقة على الدفع بنجاح",
    paymentRejected: "تم رفض الدفع بنجاح",
    validatePayment: "مصادقة",
    rejectPayment: "رفض",
    confirmValidation: "هل أنت متأكد من المصادقة على هذا الدفع؟",
    createdBy: "أنشأه",
    noPaymentsPending: "لا توجد مدفوعات في انتظار المصادقة",
    noPaymentsRejected: "لا توجد مدفوعات مرفوضة",
    noPaymentsValidated: "لا توجد مدفوعات مصادق عليها",
    noPaymentsFound: "لم يتم العثور على مدفوعات",
    filterValidationStatus: "حالة المصادقة",
    filterPendingValidation: "في انتظار المصادقة",
    filterValidatedOnly: "المصادق عليها فقط",
    filterRejectedOnly: "المرفوضة فقط",
    filterAllPayments: "الكل (في الانتظار، مصادق عليها، مرفوضة)",
    colPaymentType: "النوع",
    colCaisseDebit: "خصم الصندوق",
    paymentTypeNormal: "صادر",
    paymentTypeInverse: "عكسي",
    caisseDebitPending: "عند المصادقة",
    caisseDebitAlreadyApplied: "تم الخصم مسبقاً",
    validateModalTitle: "المصادقة على الدفع",
    validateModalPaymentType: "نوع الدفع",
    validateModalAmount: "المبلغ",
    validateModalInverseIntro:
      "مصروف عكسي: سيتم خصم المبالغ من الصناديق عند هذه المصادقة.",
    validateModalInverseDebitList: "تفاصيل الخصومات التي ستُطبَّق:",
    validateModalInverseAlreadyDebited:
      "تم خصم المبلغ من الصندوق مسبقاً. هذه المصادقة تؤكد العملية.",
    validateModalNormalIntro:
      "تم خصم هذا الدفع من الصندوق عند إدخاله. المصادقة تؤكد العملية المحاسبية.",
    splitLineSummary: "{method} — {amount} من {caisse}",
  },
  avoir: {
    title: "فواتير الإشعار الدائن",
    newCreditNote: "إشعار دائن جديد",
    pendingReception: "في انتظار الاستلام",
    received: "مستلم",
    cancelled: "ملغى",
    confirmReception: "تأكيد الاستلام",
    amountExceedsInvoice: "المبلغ يتجاوز إجمالي الفاتورة",
    creditNoteCreated: "تم إنشاء الإشعار الدائن بنجاح",
    receptionConfirmed: "تم تأكيد الاستلام بنجاح",
    selectInvoice: "اختر فاتورة",
    selectProvider: "اختر مورداً",
    receptionMethod: "طريقة الاستلام",
    noCreditNotes: "لا توجد إشعارات دائنة",
    depenseMissingForDetail: "تعذر تحميل الفاتورة المرتبطة لعرض التفاصيل.",
    invoiceAlreadyHasAvoir:
      "توجد بالفعل إشعار دائن لهذه الفاتورة. يُسمح بإشعار دائن واحد لكل فاتورة.",
    invoiceNotFullyPaid: "يمكن إنشاء إشعار دائن فقط للفاتورة المسددة بالكامل.",
    detailDrawerTitle: "تفاصيل الإشعار الدائن",
    detailSectionCreditNote: "إشعار دائن",
    detailSectionReception: "الاستلام",
    detailSectionOriginalInvoice: "فاتورة المورد الأصلية",
    detailSupplierLabel: "المورد",
    detailSchoolYear: "السنة الدراسية",
    receptionValidatedAt: "تاريخ الاستلام",
    receptionValidatedBy: "سُجّل الاستلام بواسطة",
    totalReceived: "إجمالي المستلم",
    transferDestinationCaisse: "صندوق الوجهة (بعد التحويل)",
    receptionSplitLines: "الاستلام حسب طريقة الدفع",
    splitDestination: "الوجهة",
    detailPendingReception:
      "هذا الإشعار الدائن في انتظار الاستلام؛ ستظهر طرق الدفع بعد التأكيد.",
  },
  dette: {
    title: "إدارة الالتزامات",
    newDebt: "دين جديد",
    credit: "ائتمان",
    engagement: "التزام",
    loan: "قرض",
    debtType: "نوع الدين",
    beneficiary: "المستفيد",
    beneficiaryType: "نوع المستفيد",
    associate: "شريك",
    debiteur: "مدين",
    installmentAmount: "مبلغ القسط",
    numberOfInstallments: "عدد الأقساط",
    firstInstallmentDate: "تاريخ القسط الأول",
    generateInstallments: "إنشاء الأقساط",
    sumMismatch: "مجموع الأقساط يجب أن يساوي المبلغ الإجمالي",
    debtCreated: "تم إنشاء الدين بنجاح",
    depenseTemplate: "نموذج المصروف",
    installments: "الأقساط",
    debtInfo: "معلومات الدين",
    totalAmount: "المبلغ الإجمالي",
    noDebts: "لا توجد ديون",
    debtDetail: "تفاصيل الدين",
    schedulePending: "قيد الانتظار",
    schedulePaid: "مدفوع",
    scheduleCancelled: "ملغى",
    paidOn: "تاريخ الدفع",
    noSchedulesDetail: "لا توجد أقساط لهذا الدين.",
    nextPaymentEta: "القسط القادم",
    initialReceiptStep: "استلام الأموال",
    initialReceiptHint:
      "سجّل كيف يدخل المبلغ المقترض إلى الصناديق (نقد، شيك، بنك). يجب أن يطابق المجموع مبلغ الدين؛ وتظهر الحركات في سجل كل صندوق.",
    initialReceiptDetail: "استلام الأموال الأولي",
    receivedAt: "تاريخ الاستلام",
    receivedBy: "استلم بواسطة",
    encaissementLines: "أسطر الدفع (التقسيم)",
  },
  scolarite: {
    moduleType: "نوع الوحدة",
    affichageParametrage: "إعدادات العرض",
    matieres: "المواد",
    modules: "الوحدات",
    modulesSpec: "الوحدات المخصصة",
    nomModule: "إسم الوحدة",
    affectationDansClasses: "تعيين في الأقسام",
    affectationEnseignants: "تعيين المعلمين",
    enseignants: "معلمون",
    typePunitions: "نوع العقوبات",
    typeStudentDiscipline: "نوع انضباط الطالب",
    nom: "اسم",
    customName: "الاسم المخصصة",
    coefficient: "الدرجة",
    listeMatieres: "قائمة المواد",
    listeModules: "قائمة الوحدات",
    infoModule:
      "قم بتعيين الموضوعات للوحدات النمطية من أجل تنظيم إدارة الملاحظات!",
    listeModulesSpec: "قائمة الوحدات المخصصة",
    infoModuleSpec:
      "قم بتعيين الموضوعات للوحدات المخصصة من أجل تنظيم إدارة الملاحظات!",
    ajouterModule: " إضافة وحدة",
    ajouterMatiere: "إضافة مادة",
    affectes: "متأثر",
    nonAffectes: "غير متأثر",
    recherche: "البحث",
    element: "عنصر",
    aucunDonnee: "لا توجد بيانات",
    modifierListeMatieres: "{name} : تعديل قائمة مواد الوحدة",
    modifierListeEnseignants: "{name} : تعديل قائمة معلمين الفصل",
    supprime: "محذوف",
    aucuneClasseTrouvee: "لم يتم العثور على أي فصل",
    charcherParClasse: "البحث عبر إسم الفصل",
    afficherClassesSupprimees: "عرض الفصول المحذوفة",
    deletedClasses: "الفصول المحذوفة",
    activeClasses: "الفصول النشطة",
    other: "أخرى",
    confirmDeleteModule:
      "سيتم حذف جميع الحصص المتعلقة بهذه الوحدة. تستخدم هذه الوحدة في الفصول الدراسية أدناه",
    certification: "الشهادات",
    appreciation: "ملاحظات",
    modulesVerySpec: "الوحدات المخصصة للغاية",
    subsubjects: "المواد الفرعيّة",
    subsubject: "مادة فرعيّة",
    ajouterSubsubject: "إضافة مادة فرعيّة",
    addNewSubsubject: "إدارة المواد الفرعيّة",
    choisirSubsubject: "إختر مادة فرعيّة",
    mark: "العدد الأقصى",
    listeModulesVerySpec: "قائمة الوحدات المخصصة للغاية",
    infoModuleVerySpec:
      "قم بتعيين الموضوعات للوحدات المخصصة للغاية من أجل تنظيم إدارة الملاحظات!",
    totalMarksMustBe20:
      "{subject} : المجموع الكلي للمواد الفرعيّة يجب أن يكون 20",
    subjectDejaExiste: "المادة موجودة بالفعل",
    SubSubjectDejaExiste: "هذه المادة الفرعيّة موجودة بالفعل",
    cloneParam: "استنساخ إعدادات",
    fromSchoolYear: "السنة الدراسية المصدر",
    toSchoolYear: "السنة الدراسية الهدف",
    selectParamToClone: "اختر إعدادات لاستنساخها",
    duppModules: "استنساخ الوحدات",
    nombreElevesManquants: "	عدد الطلاب الذين تنقصهم الدرجات",
    SubModuleDejaExiste: "هذه الوحدة الفرعية موجودة بالفعل",
    adminAppreciation: "تقييم الإدارة",
    incompleteDataWarning:
      "بعض المواد لديها إعدادات غير مكتملة. تم تطبيق القيم الافتراضية. يرجى المراجعة والحفظ للإصلاح.",
  },
  autorisation: {
    accueil: "ترحيب",
    admin: "المسؤول",
    designation: "تعيين",
    compteAdmin: "حساب المسؤول",
    dossierMedical: "ملف طبي",
    listeEleves: "قائمة الطلاب",
    parametrage: "ضبط",
    activite: "نشاط",
    administration: "الادارة",
    scolarite: "التعليم",
    personnel: "عامل",
    personnels: "طاقم العاملين",
    comptabilite: "محاسبة",
    declarations: "الإعلانات",
    paiements: "المدفوعات ",
    medicalNote: "مذكرة طبية",
    medicalNoteContext: "يمكن للوالدين عرض وتعديل الملاحظات الطبية لأطفالهم.",
    noteForTeachers: "ملاحظات طبية للمعلمين",
    noteForTeachersContext:
      "يمكن للوالدين عرض وتعديل ملاحظات أطفالهم للمعلمين.",
    modifierFraisClasse: "تعديل رسوم الفصول",
    modifierFraisClasseHint:
      "يسمح بتعديل رسوم الفصل العادي (وإلا تُورَّث من المستوى).",
    decaissementLegacyAccess: "الصرف — وصول كامل (قديم)",
  },
  utilisateur: {
    listeUtilisateur: "قائمة المستخدمين",
    nom: "الإسم",
    role: "الوظيفة",
    acces: "الوصول إلى المؤسسات",
    actif: "نشيط",
    nonActif: "غير نشيط",
    mdp: "كلمة السر",
    activerDesactiver: "مفعل / غير مفعل",
    confirmerMdp: "تأكيد كلمة المرور",
    changerMdp: "يمكنك تغيير كلمة المرور",
    active: "نشط",
    nonActive: "غير نشط",
    desactiverAlert: "هل تريد إلغاء نشاط هذا المستخدم؟",
    activerAlert: "هل تريد تنشيط هذا المستخدم؟",
    userDesactive: "تم إلغاء نشاط المستخدم",
    userActive: "تم تنشيط المستخدم",
    passwordAgain: "يرجى إدخال كلمة المرور مرة أخرى",
    passwordMatch: "الإدخالات غير متطابقة!",
    sessions: "الجلسات",
    sessionOnline: "متصل",
    sessionOffline: "غير متصل",
    viewSessions: "عرض ({count})",
    activeSessionsFor: "الجلسات النشطة — {user}",
    device: "الجهاز",
    unknownDevice: "جهاز غير معروف",
    ipAddress: "عنوان IP",
    sessionSource: "المصدر",
    lastActive: "آخر نشاط",
    expiresAt: "تنتهي في",
    actions: "إجراءات",
    withActiveSessions: "بجلسات نشطة",
    allUsersFilter: "الكل",
    restricted: "مقيّد",
    sessionScopeDenied: "يجب أن يكون لديك وصول إلى جميع مؤسسات هذا المستخدم.",
    revokeSession: "إلغاء",
    revokeSessionConfirm: "هل تريد إلغاء هذه الجلسة؟",
    revokeSessionSuccess: "تم إلغاء الجلسة.",
    revokeAllSessions: "إلغاء جميع الجلسات",
    revokeAllSessionsConfirm:
      "هل تريد إلغاء جميع الجلسات وتسجيل خروج هذا المستخدم فوراً؟",
    revokeSessionsSuccess: "تم إلغاء جميع جلسات المستخدم.",
    revokeSessionsError: "تعذر إلغاء جلسات المستخدم.",
    loadSessionsError: "تعذر تحميل جلسات المستخدم.",
  },
  parentalControl: {
    changeUserName: "تغيير اسم المستخدم",
    disableAccount: "تعطيل حساب الوالد",
    enableAccount: "تفعيل حساب الوالد",
    parentQrCode: "رمز الاستجابة السريعة للوالد",
    accountActive: "تم تفعيل الحساب، يمكن للمستخدم الوصول إلى التطبيق.",
    accountInactive: "تم تعطيل الحساب، لا يمكن للمستخدم الوصول إلى التطبيق.",
  },
  liste: {
    searchStudent: "البحث عن تلميذ",
    searchBy: "يمكنك البحث بواسطة",
    listeElevesArchive: "قائمة التلاميذ المؤرشفين",
    reactive: "إعادة تفعيل",
    showSchoolLogo: "إظهار شعار المدرسة",
    showGovLogo: "عرض شعار الوزارة",
    reasonArchive: "سبب الأرشفة",
    addFiles: "إضافة ملفات",
    studentPhoto: " صورة التمليذ",
    studentFiles: "ملفات التلميذ",
    consulterProfil: "مراجعة الملف الشخصي لمزيد من التفاصيل",
    nomPrenom: "الإسم واللقب",
    fullName: "الاسم الكامل",
    photoMediaConsent: "الموافقة على الصور والوسائط (ولي الأمر)",
    photoMediaConsentFilterLabel:
      "موافقة التلميذ على الصور والوسائط (حساب ولي الأمر)",
    photoMediaConsentAll: "الكل",
    photoMediaConsentAccepted: "موافق",
    photoMediaConsentRefused: "غير موافق",
    photoMediaConsentPending: "لم يُجب",
    scolarite: "التعليم",
    ficheParent: "بيانات الوالدين",
    attestation: "شهادة حضور",
    inscription: "التسجيل",
    supprimerAnnuler: " حذف / إلغاء",
    inscriSupprimer: "تسجيل / حذف",
    filles: "بنات",
    garcons: " اولاد",
    total: "المجموع",
    nonInscrits: "غير مسجل",
    inscrits: " مسجل",
    parents: "الآباء",
    pere: "الأب",
    mere: "الأم",
    guardian: "الوصي",
    enfants: "الأطفال",
    email: "البريد الإلكتروني",
    ajouterEleve: " أضف تلميذًّا",
    nouveauPaiement: "دفع جديد",
    ajouterDossier: "أضف مجلد",
    ajouterPersonnel: "أضف الموظفين",
    ajouterEnseignant: "أضف مدرسًا",
    listeEleves: "قائمة الطلاب",
    administration: "الادارة",
    tranches: "الأقساط",
    toutesTranches: "كل الأقساط",
    nom: "اللقب",
    prenom: "الاسم الاول",
    notes: "درجات",
    dateNaissance: "تاريخ الميلاد",
    sexe: "الجنس",
    adresse: "عنوان بريدي",
    telephone: "هاتف",
    classes: "الأقسام",
    ajouterParent: "إضافة والد جديد",
    ajouterParentSansEleveHint:
      "أنشئ وليًا دون إضافة تلميذ. يمكنك ربطه لاحقًا بتلميذ من صفحة ملفه.",
    parentsExis: "الآباء الحاليون",
    ficheParents: "ورقة الوالدين",
    nomMere: " لقب الأم",
    prenomMere: "اسم الأم",
    telMere: "هاتف الأم",
    nomPere: " لقب الاب",
    emailMere: "البريد الإلكتروني للأم",
    adresseMere: "عنوان الأم",
    adressePere: "عنوان الأب",
    emailPere: "البريد الإلكتروني للأب",
    prenomPere: "اسم الأب",
    prenomPere: "اسم الاب",
    telPere: "هاتف الاب",
    metierPere: "وظيفة الأب",
    metierMere: "وظيفة الأم",
    cinPere: "البطاقة الوطنية للأب",
    cinMere: "البطاقة الوطنية للأم",
    cinGardian: "البطاقة الوطنية لولي الأمر",
    gardianName: "اسم المشرف",
    gardianFirstName: "اسم المشرف",
    gardianPhone: "هاتف المشرف",
    gardianJob: "وظيفة المشرف",
    gardianAdress: "عنوان المشرف",
    adresseParents: "عنوان بريدي ",
    emailParents: "البريد الإلكتروني للوالدين",
    reduction: "تخفيض رسوم التسجيل",
    reductionMensuel: "خصم على الرسوم الشهرية",
    identifiantUnique: "المعرف الوحيد",
    regionalEducation: "المندوبية الجهوية للتربيّة",
    recuEn: "سلمت في",
    nonInscrit: "غير مسجل",
    freresSoeurs: "قائمة الإخوة والأخوات",
    studentFullName: "اسم التلميذ",
    brotherSister: "أخ / أخت",
    brother: "أخ",
    sister: "أخت",
    parentFullName: "اسم الولي",
    classe: "القسم",
    siblingGroups: "مجموعات عائلية",
    noSiblingGroups: "لا توجد مجموعات إخوة وأخوات",
    changementNonEffectue: "التغيير لم يتم",
    champsVides: "لا يمكن أن تكون الحقول فارغة",
    imprimerLoginsEnsg: "تحميل دخول المعلمين",
    fichePersonnel: "الملف الشخصي",
    nombreEnfants: "عدد الأطفال",
    situationFamiliale: "الحالة مالية",
    dateEntree: "تاريخ الدخول",
    etablissementPrecedent: "المؤسسة السابقة",
    dateSortie: "تاريخ الخروج",
    motifSortie: "سبب الخروج",
    documents: "الوثائق",
    motivation: "الدافع",
    nombreInscriptions: "عدد الترسيم",
    accompanyingDocuments: "الوثائق المرافقة",
    secondarySchool: "المدرسة الثانوية",
    previousInstitution: "المؤسسة السابقة",
    behavior: "السلوك",
    attendance: "الحضور",
    includePhoto: "صورة الطالب",
    parentLogins: "دخول الوالدين",
    printSelectionMode: "طباعة حسب",
    fraisTranches: "الرسوم المتكررة",
    paymentMode: "الوضع المختار للدفع هو",
    generatePdfAnyway: "إنشاء PDF على أي حال",
    studentsWontAppearInPdf:
      "الطلاب التاليون لن يظهرون في PDF لأن أولياء أمورهم لا يملكون بيانات تسجيل الدخول:",
    studentsWithoutLogin: "الطلاب بدون بيانات تسجيل الدخول",
    studentsWithoutLoginInfo:
      "الطلاب التاليون لا يملكون بيانات تسجيل الدخول لكن سيظهرون في PDF:",
    qrCodeErrorWarning: "مشكلة في توليد رمز الاستجابة السريعة",
    qrCodeErrorDescription:
      "هذه المستخدمين لديهم مشكلات في توليد رموز الاستجابة السريعة. يمكنك طباعتهم فرديًا من ملفهم الشخصي.",
    tranches: "بالتقسيمات",
    mensuelle: "شهريا",
    generated: "تم الإنشاء في:",
    listBadges: "قائمة الشارات",
    concInfo: "معلومات الإتصال",
    elevesAssocies: "الطلاب المرتبطين",
    linkConnection: "رابط الإتصال",
    linkConnectiontext: "أو تطبيق Mobile EdParent",
    attestationInscription: "شهادة التسجيل",
  },
  cantine: {
    modifierMenu: "عدل القائمة ",
    cantine: "المطعم المدرسي",
    dateChoisie: "التاريخ المختار",
    choisirDate: "اختر تاريخًا لإدراج القائمة ",
    ajouterRepas: "أضف وجبة",
    ajouterMenu: " أضف قائمة جديدة لـ",
    choisirJour: "اختر الأيام",
    mealName: "اسم الوجبة",
    type: "نوع ",
    repeter: "كرر",
    saisirNom: " أدخل اسم الوجبة",
    saisirType: "اختر نوع الوجبة",
    saisirEndDate: "أدخل تاريخ الانتهاء",
    plat: " الطبق الرئيسي",
    entree: "المقبلات",
    goute: "الوجبة الخفيفة",
    boissons: " مشروبات",
    autre: "الآخرين",
    dessert: "الحلويات",
    menuIntrouvable: "القائمة غير موجودة ، الرجاء إضافة وجبات!",
    ajouterNewMenu: "{date} إضافة وجبة جديدة لـ",
    modifierMenu: "{name} تعديل وجبة ",
    saisirDateFin: "أدخل التاريخ النهائي",
    addSuccessMessage: "تم إضافة الوجبة بنجاح.",
    editSuccessMessage: "تم تعديل الوجبة بنجاح.",
    errorMessage: "حدث خطأ في التعديل!",
    errorMessageAdd: "حدث خطأ في الإضافة!",
    ajouterMenuHebdo: "إضافة قائمة أسبوعية",
    nomMenu: "اسم القائمة",
    saisirNomMenu: "أدخل اسم القائمة",
    descriptionMenu: "الوصف",
    saisirDescriptionMenu: "أدخل وصفًا للقائمة",
    dateDebut: "تاريخ البداية",
    saisirDateDebut: "أدخل تاريخ البداية",
    endDateAvantDebut: "يجب أن يكون تاريخ الانتهاء في نفس يوم البداية أو بعده",
    joursWeekend: "أيام نهاية الأسبوع",
    inclureSamedi: "تضمين يوم السبت",
    inclureDimanche: "تضمين يوم الأحد",
    imageMenu: "صورة القائمة",
    menusHebdo: "القوائم الأسبوعية",
    repasDuJour: "وجبات اليوم",
    aucunMenuHebdo: "لا توجد قائمة أسبوعية لهذا التاريخ",
    samediEtDimancheInclus: "يشمل السبت والأحد",
    modifierMenuHebdo: "{name} تعديل القائمة الأسبوعية",
    menuHebdoAjoute: "تمت إضافة القائمة الأسبوعية.",
    menuHebdoModifie: "تم تعديل القائمة الأسبوعية.",
    menuHebdoSupprime: "تم حذف القائمة الأسبوعية.",
    erreurSuppressionMenuHebdo: "حدث خطأ أثناء حذف القائمة الأسبوعية!",
    apercu: "معاينة",
    samediInclus: "يشمل السبت",
    dimancheInclus: "يشمل الأحد",
    joursSemaineSeulement: "أيام الأسبوع فقط",
  },
  paiement: {
    reducation: "تخفيض",
    reducationDefault: "التخفيض الأفتراضي",
    reducationRep: "التخفيض المتكرر",
    reductionBase: "التخفيض الأولي",
    selectMonths: "حدد الشهور",
    avoir: "استرداد",
    note: "ملاحظة",
    paiementClasse: "دفع/فصل دراسي",
    nom: "اسم التلميذ",
    prenom: "لقب التلميذ",
    classe: "فصل دراسي",
    parents: "الآباء والأمهات",
    tels: "هاتف الوالدين",
    etat: "حالة الدفع",
    fraisInscri: "رسوم التسجيل",
    fraisMensuel: "رسوم شهرية",
    dateDebut: "تاريخ البدء ",
    dateFin: "تاريخ النهاية",
    tousMois: "كل الشهور",
    mois: "شهر",
    tousClasses: "جميع الفصول الدراسية",
    order: "ترتيب",
    service: "الخدمات",
    nbEleves: "عدد الطلاب",
    listeClasses: "قائمة الفصول الدراسية",
    listeEleves: "قائمة الطلاب",
    imprimerTab: "طباعة الجدول",
    selectionnerMois: "إختر الشهر",
    paye: "مدفوع",
    inscriPaye: "التسجيل مدفوع",
    inscriNonPaye: "التسجيل غير مدفوع",
    impaye: "غير مدفوع",
    partiel: "مدفوع جزئياً",
    selectionnerDate: "حدد التاريخ",
    reduction: "خصم على التسجيل",
    reductionMensuel: "الخصم شهري",
    activite: "نشاط",
    annulation: "الإلغاء",
    annulationSuccess: "تم الإلغاء بنجاح",
    listeActivites: "قائمة الأنشطة",
    filtrerParStatut: "تصفية حسب الحالة:",
    actives: "نشطة",
    toutes: "الكل",
    activiteSupprimee: "الأنشطة المحذوفة",
    activiteActive: "الأنشطة النشطة",
    dt: " دينار",
    non: "لا",
    chercher: "بحث",
    annulerInscri: "هل تريد إلغاء الاشتراك؟",
    eleveRequis: "مطلوب تلميذ واحد على الأقل",
    classRequis: "مطلوب فصل واحد على الأقل",
    activiteRequis: "النشاط مطلوب",
    activitesTypeDifferent:
      "يمكنك فقط اختيار أنشطة من نفس النوع (يومي أو شهري/بالأقساط)",
    tagActiviteJournaliere: "يومي",
    tagActiviteMensuelleTranche: "شهري/بالأقساط",
    inscriptionEchecPourActivite: "فشل التسجيل للنشاط",
    inscriptionReussitePourActivites: "تم التسجيل بنجاح لعدد {count} من الأنشطة",
    dateDebutRequis: "تاريخ البدء مطلوب",
    dateFinRequis: "تاريخ الانتهاء مطلوب",
    msgReduction: "اضبط التخفيض على صفر إذا كنت لا تريد إضافة التخفيض ",
    typeDepense: "نوع المصاريف مطلوب",
    eleve: "التلميذ مطلوب",
    totalPaiements: "إجمالي المدفوعات",
    totalMontant: "إجمالي المبلغ",
    lignes: "سطور",
    paymentMode: "الوضع المختار للدفع هو",
    etatPaiementsPourMois: "حالة الدفع للشهر",
    etatPaiementsTousMois: "حالة الدفع لجميع الشهور",
    num: "رقم",
    paymentStatusActivity: "حالة_دفع_النشاط",
    impaye: "غير مدفوع",
    paye: "مدفوع",
    paymentStatusScolarite: "حالة_دفع_المدرسة",
    totalInscriptions: "عدد التسجيلات",
    trancheLabel: "القسط",
    inscriptionLabel: "التسجيل",
    title: "إدخال الدفع",
    pendingSchedules: "التخطيطات المعلقة",
    unplannedExpenses: "المصاريف غير المخططة",
    invoiceRef: "مرجع الفاتورة",
    beneficiary: "المستفيد",
    dueDate: "تاريخ الاستحقاق",
    amount: "المبلغ",
  },
  inscription: {
    nom: "الاسم الكامل",
    dateNaissance: "تاريخ الميلاد",
    sexe: "الجنس",
    tels: "هاتف الوالدين",
    parent: "الولي",
    nouvInscri: "تسجيل جديد",
    nbEleves: "{number} : عدد الطلاب",
    ficheParentClasse: "ملف الفصل / الوالدين",
    ficheClasse: " ملف الفصل",
    confirmEnrollmentTooltip: "سيصبح تسجيل تلاميذ الفصل {name} متاحًا للأولياء",
    cancelEnrollmentConfirmationTooltip:
      "لن يعد تسجيل تلاميذ الفصل {name} متاحًا للأولياء",
    enrollmentVisibleTag: "متاح للأولياء",
    enrollmentHiddenTag: "غير متاح للأولياء",
    enrollmentVisibleTooltip: "تسجيل تلاميذ الفصل {name} متاح للأولياء",
    enrollmentHiddenTooltip: "تسجيل تلاميذ الفصل {name} غير متاح للأولياء",
    enrollmentAllVisibleTooltip: "تسجيل جميع الفصول متاح للأولياء",
    enrollmentAllHiddenTooltip: "تسجيل جميع الفصول غير متاح للأولياء",
    confirmAllClassesBtn: "إتاحة جميع الفصول للأولياء",
    cancelAllConfirmationBtn: "إلغاء إتاحة جميع الفصول للأولياء",
    confirmAllClassesContent:
      "سيصبح تسجيل جميع الفصول متاحًا للأولياء.",
    cancelAllConfirmationContent:
      "لن يعد تسجيل جميع الفصول متاحًا للأولياء.",
    enrollmentConfirmedMsg: "أصبح تسجيل فصل {name} متاحًا الآن للأولياء",
    enrollmentUnconfirmedMsg: "لم يعد تسجيل فصل {name} متاحًا للأولياء",
    allClassesConfirmedMsg: "أصبح التسجيل متاحًا الآن للأولياء لجميع الفصول",
    allClassesUnconfirmedMsg: "لم يعد التسجيل متاحًا للأولياء لجميع الفصول",
    inscription: "تسجيل",
    enfant: "الطفل",
    fraisInscri: "رسوم التسجيل",
    fraisMensuel: "رسوم شهرية",
    remise: "الخصم ",
    remiseInscri: "خصم على التسجيل",
    remiseMensuel: "خصم شهري",
    rechercher: "البحث",
    mensuel: "شهريا",
    chercherParActivite: "البحث عن طريق اسم النشاط",
    sureToInscri: "هل أنت متأكد من رغبك في تسجيل هذا التلميذ؟",
    downloadTitle: "تحميل قائمة الطلاب حسب النشاط",
    activityListSelectColumnsHint:
      "اختر معلومات التلاميذ التي تريد إدراجها في قائمة النشاط.",
    noStudentInActivity: "لا يوجد طلاب مسجلين في الأنشطة التالية",
    unableToGeneratePdf:
      "لا يمكن إنشاء ملف PDF - لا يوجد طلاب مسجلين في الأنشطة المحددة",
    selectionnerModePaiement: "اختر طريقة الدفع",
    fraisDesTranches: "رسوم الأقساط",
    tranche: "قسم",
    lesFraisAPayer: "الرسوم المطلوب دفعها",
    modePaiementSelectionne: "طريقة الدفع المختارة هي",
    parTranches: "بالأقساط",
    mensuelle: "شهرية",
    frais: "الرسوم",
    inclus: "مشمول",
    selectionnerJours: "اختر الأيام",
    selectionnerAuMoinsUnJour:
      "يرجى اختيار يوم واحد على الأقل لهذا النشاط اليومي",
    ajouterDate: "إضافة تاريخ",
    ajouter: "إضافة",
    aucuneDateSelectionnee: "لم يتم اختيار أي تاريخ",
    datesSelectionnees: "التواريخ المختارة",
    toutEffacer: "مسح الكل",
    selectionnerTranches: "اختر الأقساط",
    tranchesSelectionnees: "الأقساط المختارة",
    selectionnerMois: "اختر الأشهر",
    moisSelectionnes: "الأشهر المختارة",
    elementsSelectionnes: "العناصر المختارة",
    changeClassroom: "تغيير الفصل",
    studentsList: "قائمة الطلاب المسجلين في النشاط",
    activityList: "قائمة_الأنشطة",
    num: "رقم",
    ecolePrimairePrivee: "المدرسة الابتدائية الخاصة",
    formulaireParent: "استمارة ولي الأمر",
    anneeScolaireLabel: "السنة الدراسية",
    numero: "الرقم",
    nomPrenom: "الاسم واللقب",
    dateNaissance: "تاريخ الميلاد",
    nomParent: "إسم ولي الأمر",
    telephone: "الهاتف",
    delegeRegionalEducation: "المندوبية الجهوية للتربية",
    ficheParentPDF: "ملف_الولي",
    nonDisponible: "غير متوفر",
    classe: "القسم",
    pere: "الأب",
    mere: "الأم",
    identifiantUnique: "المعرف الفريد",
    nomComplet: "الاسم الكامل",
    sexe: "الجنس",
    garcon: "ولد",
    fille: "بنت",
    nombreTotal: "العدد الإجمالي",
    nombreGarcons: "عدد الأولاد",
    nombreFilles: "عدد البنات",
    listeElevesPDF: "قائمة_التلاميذ",
    installmentFees: "رسوم الأقساط",
    installment: "قسط",
    selectedPaymentMode: "طريقة الدفع المختارة هي ",
    byInstallments: "بالأقساط",
    monthly: "شهرية",
    fees: "الرسوم",
    included: "مشمول",
    discount: "التخفيض",
    changeGroup: "تغيير المجموعة",
    monthlyPayment: "الدفع الشهري",
    installmentPayment: "الدفع بالأقساط",
    paymentMode: "طريقة الدفع",
    monthly: "شهرية",
    byInstallment: "بالأقساط",
    globalStatus: "الحالة العامة",
    notSpecified: "غير محدد",
    sureToCancel: "هل أنت متأكد من الإلغاء؟",
    sureToDelete: "هل أنت متأكد من الحذف؟",
  },
  buildingType: {
    jardinEnfantsPrive: "روضة الأطفال الخاصة",
    ecolePrimairePrivee: "المدرسة الابتدائية الخاصة",
    collegePrive: "المدرسة الإعدادية الخاصة",
    lyceePrive: "المدرسة الثانوية الخاصة",
    collegeLyceePrives: "المدرسة الإعدادية والثانوية الخاصة",
    collegeEcolePrives: "المدرسة الابتدائية و الإعدادية الخاصة",
    jardinEnfantEcolePrives: "روضة الأطفال والمدرسة الابتدائية الخاصة",
    jardinEnfantCollegePrives: "روضة الأطفال والمدرسة الإعدادية الخاصة",
    jardinEnfantLyceePrives: "روضة الأطفال والمدرسة الثانوية الخاصة",
    ecoleLyceePrives: "المدرسة الابتدائية والثانوية الخاصة",
    jardinEnfantEcoleCollegePrives:
      "روضة الأطفال والمدرسة الابتدائية و الإعدادية الخاصة",
    jardinEnfantCollegeLyceePrives:
      "روضة الأطفال والمدرسة الإعدادية والثانوية الخاصة",
    jardinEnfantEcoleLyceePrives:
      "روضة الأطفال والمدرسة الابتدائية والثانوية الخاصة",
    jardinEnfantEcoleCollegeLyceePrives:
      "روضة الأطفال والمدرسة الابتدائية و الإعدادية والثانوية الخاصة",
    collegeEcoleLyceePrives: "المدرسة الابتدائية والإعدادية والثانوية الخاصة",
    ecolePrivee: "المدرسة الخاصة",
    // Kenya school types
    preSchoolPrive: "ما قبل المدرسة الخاصة",
    prePrimaryPrive: "الروضة الخاصة",
    middlePrive: "المدرسة المتوسطة الخاصة",
    juniorPrive: "المدرسة الثانوية الدنيا الخاصة",
    seniorPrive: "المدرسة الثانوية العليا الخاصة",
    prePrimaryMiddlePrives: "الروضة والمدرسة المتوسطة الخاصان",
    prePrimaryJuniorPrives: "الروضة والمدرسة الثانوية الدنيا الخاصان",
    prePrimarySeniorPrives: "الروضة والمدرسة الثانوية العليا الخاصان",
    middleJuniorPrives: "المدرسة المتوسطة والمدرسة الثانوية الدنيا الخاصان",
    middleSeniorPrives: "المدرسة المتوسطة والمدرسة الثانوية العليا الخاصان",
    juniorSeniorPrives: "المدرسة الثانوية الدنيا والعليا الخاصان",
    prePrimaryMiddleJuniorPrives:
      "الروضة والمدرسة المتوسطة والمدرسة الثانوية الدنيا الخاصان",
    prePrimaryMiddleSeniorPrives:
      "الروضة والمدرسة المتوسطة والمدرسة الثانوية العليا الخاصان",
    prePrimaryJuniorSeniorPrives:
      "الروضة والمدرسة الثانوية الدنيا والعليا الخاصان",
    middleJuniorSeniorPrives:
      "المدرسة المتوسطة والمدرسة الثانوية الدنيا والعليا الخاصان",
    prePrimaryMiddleJuniorSeniorPrives:
      "الروضة والمدرسة المتوسطة والمدرسة الثانوية الدنيا والعليا الخاصان",
    preSchoolPrePrimaryPrives: "ما قبل المدرسة والروضة الخاصان",
    preSchoolMiddlePrives: "ما قبل المدرسة والمدرسة المتوسطة الخاصان",
    preSchoolJuniorPrives: "ما قبل المدرسة والمدرسة الثانوية الدنيا الخاصان",
    preSchoolSeniorPrives: "ما قبل المدرسة والمدرسة الثانوية العليا الخاصان",
    preSchoolPrePrimaryMiddlePrives:
      "ما قبل المدرسة والروضة والمدرسة المتوسطة الخاصان",
    preSchoolPrePrimaryJuniorPrives:
      "ما قبل المدرسة والروضة والمدرسة الثانوية الدنيا الخاصان",
    preSchoolPrePrimarySeniorPrives:
      "ما قبل المدرسة والروضة والمدرسة الثانوية العليا الخاصان",
    preSchoolMiddleJuniorPrives:
      "ما قبل المدرسة والمدرسة المتوسطة والمدرسة الثانوية الدنيا الخاصان",
    preSchoolMiddleSeniorPrives:
      "ما قبل المدرسة والمدرسة المتوسطة والمدرسة الثانوية العليا الخاصان",
    preSchoolJuniorSeniorPrives:
      "ما قبل المدرسة والمدرسة الثانوية الدنيا والعليا الخاصان",
    preSchoolPrePrimaryMiddleJuniorPrives:
      "ما قبل المدرسة والروضة والمدرسة المتوسطة والمدرسة الثانوية الدنيا الخاصان",
    preSchoolPrePrimaryMiddleSeniorPrives:
      "ما قبل المدرسة والروضة والمدرسة المتوسطة والمدرسة الثانوية العليا الخاصان",
    preSchoolPrePrimaryJuniorSeniorPrives:
      "ما قبل المدرسة والروضة والمدرسة الثانوية الدنيا والعليا الخاصان",
    preSchoolMiddleJuniorSeniorPrives:
      "ما قبل المدرسة والمدرسة المتوسطة والمدرسة الثانوية الدنيا والعليا الخاصان",
    preSchoolPrePrimaryMiddleJuniorSeniorPrives:
      "ما قبل المدرسة والروضة والمدرسة المتوسطة والمدرسة الثانوية الدنيا والعليا الخاصان",
  },
  punition: {
    eventTime: "الوقت",
    createdBy: "تم إنشاؤها بواسطة",
    eleve: "التلميذ",
    nom: "اللقب",
    prenom: "الإسم",
    details: "التفاصيل",
    seenByParents: "تمت المشاهدة من قبل الأولياء",
    noParentSeen: "لم يقم أي ولي بمشاهدة هذه العقوبة بعد.",
    notVisibleToParents: "غير مرئية لأولياء الأمور",
    notVisibleToParentsHint: "تظهر للأولياء العقوبات المُصادق عليها فقط.",
    punition: "العقاب",
    studentDiscipline: "انضباط الطالب",
    studentDisciplineList: "قائمة انضباط الطالب",
    temps: "زمن",
    raison: "السبب",
    description: "الوصف",
    validation: "فاعلية",
    valides: "تم التأكيد",
    rejetes: "مرفوض",
    nonEvalues: "لم تتم مراجعته",
    dateAjout: "تاريخ الإضافة",
    dateEvalution: "تاريخ المراجعة",
    valider: "تأكيد",
    rejeter: "رفض",
    rejectReason: "سبب رفض العقوبة",
    rejectReasonDiscipline: "سبب رفض انضباط الطالب",
    reasonRequired: "سبب الرفض مطلوب",
    typeRequired: "نوع العقوبة مطلوب",
    typeRequiredDiscipline: "نوع انضباط الطالب مطلوب",
    autoValidationMessage:
      "سيتم تأكيد هذه العقوبة بشكل تلقائي. هل تريد الاستمرار؟",
    autoValidationMessageDiscipline:
      "سيتم تأكيد انضباط الطالب هذا بشكل تلقائي. هل تريد الاستمرار؟",
    pendingValidationMessage:
      "ستبقى هذه العقوبة قيد الانتظار حتى تتم المصادقة عليها من طرف مسؤول. هل تريد الاستمرار؟",
    pendingValidationMessageDiscipline:
      "سيبقى انضباط الطالب هذا قيد الانتظار حتى تتم المصادقة عليه من طرف مسؤول. هل تريد الاستمرار؟",
    errorLoadingPunishments: "خطأ في تحميل العقوبات",
    errorLoadingDisciplines: "خطأ في تحميل انضباط الطالب",
    noPunishmentTypeFound: "لم يتم العثور على نوع العقوبة",
    noDisciplineTypeFound: "لم يتم العثور على نوع انضباط الطالب",
    timeRequired: "التاريخ والوقت مطلوبان",
  },
  days: {
    sunday: "الأحد",
    monday: "الأثنين",
    tuesday: "الثلثاء",
    wednesday: "الأربعاء",
    thursday: "الخميس",
    friday: "الجمعة",
    saturday: "السبت",
  },
  emploi: {
    hideTeacherUpdated: "تم اخفاء المعلم بنجاح",
    hideEmploi: "الجداول الدراسية غير متاحة الآن للفصول التالية: {name}",
    validateEmploi: "الجداول الدراسية أصبحت متاحة الآن للفصول التالية: {name}",
    validatedClassroom:
      "الجداول الدراسية أصبحت متاحة الآن للفصول التالية: {name}",
    unvalidatedClassroom:
      "الجداول الدراسية غير متاحة الآن للفصول التالية: {name}",
    validated: "الآن أصبحت الجداول الدراسية متاحة للفصول التالية: {name}",
    unvalidated: "الجداول الزمنية غير متاحة الآن للفصل الدراسي: {name}",
    hideEmploin: "لن يكون جدول هذه الفئة متاحًا للآباء بعد الآن",
    validateEmploin: "سيكون جدول هذه الفئة متاحًا للآباء",
    emplois: "جداول",
    temps: "الأوقات",
    choisirTemps: "اختر الوقت",
    trimestre: "الفصل الدراسي",
    listeClasses: "قائمة الفصول الدراسية",
    listeEnseignants: "قائمة المعلمين",
    emploiEnseignants: " جداول المعلمين ",
    imprimerEmploi: "  طباعة الجدول الزمني ",
    imprimerEmploiAdministrative: "طباعة الجدول الإداري",
    pdfRepublique: "الجمهورية التونسية - وزارة التربية",
    pdfDelegation: "المندوبية الجهوية ب{delegation}",
    pdfDelegationKE: "موقع الدولة: {delegation}",
    pdfAnnee: "السنة الدراسية: {year}",
    pdfImprime: "تم الطباعة بتاريخ: {date}",
    pdfEcole: "المدرسة الابتدائية الخاصة : {name}",
    pdfEmploi: "جدول أوقات القسم: {className}",
    pdfEmploiTeacher: "جدول أوقات الأستاذ: {teacher}",
    pdfEmploiAdmin: "جدول الأوقات الإداري",
    enseignant: "المعلم",
    matiere: "المواد",
    salle: "القاعة",
    duree: "المدة الزمنية",
    classe: "فصل دراسي",
    choisirEnseignant: "إختر مدرسًا ",
    choisirMatiere: "إختر مادة",
    choisirSalle: "إختر القاعة",
    choisirDuree: "إختر المدة",
    choisirClasse: "إختر فصل دراسي",
    ajouterSeance: "إضافة حصة ",
    addSession: "إضافة حصة",
    modifierSeance: " تعديل حصة",
    disponible: "متوفرة",
    indisponible: "غير متوفره",
    modeModif: "تم تنشيط وضع التحرير!",
    desc: "يمكنك تغيير مكان و مدة الحصص",
    totaleHeures: "مجموع الساعات",
    moyenneHeuresJour: "معدل الساعات في اليوم",
    maximunHeuresJour: "الحد الأقصى للساعات في اليوم",
    totaleClasses: "مجموع الفصول",
    totaleTeachers: "مجموع الأساتذة",
    seance: "الحصة",
    seanceListe: "قائمة الحصص",
    choisirName: "اكتب اسم الحصة",
    name: "اسم الحصة",
    includedSubjects: "يمكن للاستاذ تدريس",
    selectedTime: "الوقت المحدد",
    selectedDay: "اليوم المحدد",
    selectedClass: "الفصل المحدد",
    group: "المجموعة",
    groupOption: "اختر مجموعة",
    fullClass: "الفصل كاملاً",
    week: "الأسبوع",
    weekLabel: "الأسبوع",
    weekOption: "اختر أسبوعاً",
    weekBoth: "كلا الأسبوعين",
    weekA: "الأسبوع أ",
    weekB: "الأسبوع ب",
    modulesPedagogiques: "الوحدات التعليمية",
    modulesPilotes: "الوحدات النموذجية",
    additionalSubject: "مادة إضافية",
    pedagogicalModule: "وحدة تعليمية",
    pilotModule: "وحدة نموذجية",
    today: "اليوم",
    month: "الشهر",
    week: "الأسبوع",
    day: "اليوم",
    startTime: "وقت البداية",
    duration: "المدة",
    subject: "المادة",
    teacher: "المعلم",
    room: "القاعة",
    group: "المجموعة",
    notes: "ملاحظات",
    minutes: "دقائق",
    hour: "ساعة",
    hours: "ساعات",
    durationFormat: "س {hours} د {minutes}",
    pleaseSelectDay: "يرجى اختيار يوم",
    pleaseSelectStartTime: "يرجى اختيار وقت البداية",
    pleaseSelectDuration: "يرجى اختيار المدة",
    pleaseSelectSubject: "يرجى اختيار مادة",
    pleaseSelectTeacher: "يرجى اختيار معلم",
    pleaseSelectRoom: "يرجى اختيار قاعة",
    selectDay: "اختر يوم",
    selectStartTime: "اختر وقت البداية",
    selectDuration: "اختر المدة",
    selectSubject: "اختر مادة",
    selectTeacher: "اختر معلم",
    selectRoom: "اختر قاعة",
    selectGroup: "اختر مجموعة",
    addNotes: "إضافة ملاحظات",
    updateSessionOptions: "خيارات التحديث",
    updateSessionQuestion: "كيف تريد تحديث هذه الحصة؟",
    updateSessionDescription:
      "اختر ما إذا كنت تريد تحديث هذه الحصة فقط أم جميع الحصص المشابهة.",
    updateOnlyThis: "تحديث هذه الحصة فقط",
    updateOnlyThisDescription: "سيتم تعديل هذه الحصة فقط.",
    updateAllSimilar: "تحديث جميع الحصص المشابهة",
    updateAllSimilarDescription: "سيتم تحديث جميع الحصص التي لها نفس الخصائص.",
    updateDuration: "مدة التحديث",
    untilEndOfYear: "هذه الحصة وجميع الحصص التالية",
    untilEndOfYearDescription:
      "تحديث هذه الحصة وجميع الحصص التالية حتى نهاية السنة الدراسية.",
    wholeSchoolYear: "جميع حصص السنة الدراسية",
    wholeSchoolYearDescription:
      "تحديث جميع حصص السنة الدراسية، بما في ذلك الحصص السابقة.",
    customDuration: "مدة مخصصة",
    customDurationDescription: "اختر مدة محددة بالأشهر.",
    enterDurationMonths: "أدخل المدة بالأشهر",
    durationInMonths: "المدة بالأشهر (1-12)",
    enterValidDuration: "يرجى إدخال مدة صحيحة",
    sessionPreview: "معاينة الحصة",
    sessionName: "اسم الحصة",
    sessionTime: "وقت الحصة",
    teacher: "المعلم",
    selectEndDate: "اختر تاريخ الانتهاء",
    selectEndDateDescription: "اختر تاريخ الانتهاء للتحديثات المجمعة",
    selectedDate: "التاريخ المحدد",
    restoreSession: "استعادة الحصة",
    restoreSessionConfirm: "هل أنت متأكد من أنك تريد استعادة هذه الحصة؟",
    cancelSessionWarning: "إلغاء الحصة",
    cancelSessionDescription: "سيؤدي هذا إلى إلغاء الحصة وجميع تكراراتها",
    cancellationReason: "سبب الإلغاء",
    cancelUntil: "إلغاء حتى",
    cancelUntilDescription: "اختر التاريخ الذي تريد إلغاء الحصة حتى",
    sessionDetails: "تفاصيل الحصة",
    confrimCancel: "تأكيد الإلغاء",
    cancellationReasonRequired: "سبب الإلغاء مطلوب",
    deleteSession: "حذف الحصة",
    hideTeacher: "اخفاء المعلم",
    deleteSessionQuestion: "هل تريد حذف هذه الحصة؟",
    deleteSessionOptions: "اختر خياراً:",
    deleteRecuring: "حذف الحصص المتكررة",
    deleteOnlyThis: "حذف هذه الحصة فقط",
    cancelSession: "إلغاء الحصة",
    confirmCancel: "تأكيد الإلغاء",
    enterCancellationReason: "أدخل سبب الإلغاء",
    selectCancelUntilDate: "اختر تاريخ الإلغاء",
    cancelUntilRequired: "تاريخ الإلغاء مطلوب",
    cancelUntilCannotBePast: "تاريخ الإلغاء لا يمكن أن يكون في الماضي",
    deleteRecurring: "حذف هذه الحصة وجميع الحصص المتكررة المشابهة (السابقة والمستقبلية)",
    sessionCanceled: "تم إلغاء الحصة",
    validated: "الجداول الدراسية متاحة الآن للفصل الدراسي: {name}",
    unvalidated: "الجداول الدراسية غير متاحة الآن للفصل الدراسي: {name}",
    chooseSubmodule: "اختر وحدة فرعية",
  },
  bulletin: {
    bulletins: "بطاقات الأعداد",
    annualReport: "التقرير السنوي",
    displayOptions: "خيارات العرض",
    teachersByClassroom: "المدرّسون (حسب القسم)",
    showDate: "إظهار التاريخ",
    configSaved: "تم حفظ الإعدادات",
    pvAnnuel: "بطاقات الأعداد السنوية",
    ficheNotes: "بطاقات الأعداد",
    exporterExcel: "تصدير Excel",
    imprimerPV: "طباعة البطاقة",
    imprimerConseilClasse: "طباعة محضر مجلس القسم",
    imprimerPVParNiveau: "طباعة البطاقة بالمستوى",
    notesWillBeDeleted: "هذه الدرجات سيتم حذفها",
    loading: "جاري التحميل...",
    deletingNotes: "جاري حذف الدرجات...",
    classroom: "الفصل",
    numberOfAffectedNotes: "عدد الدرجات المتأثرة",
    student: "التلميذ",
    subjects: "المواد",
    duplicateSettings: "تكرار الإعدادات",
    source: "المصدر",
    targets: "الهدف (الأهداف)",
    parameters: "المعاملات",
    templates: "القوالب",
    schoolYear: "السنة الدراسية",
    selectSchoolYear: "اختر السنة الدراسية",
    selectTemplate: "اختر قالب",
    selectTypes: "اختر الأنواع",
    selectLevels: "اختر المستويات",
    selectTrimesters: "اختر الثلاثيات",
    allDataDuplicatedSuccess: "تم تكرار جميع البيانات بنجاح",
    pleaseRefreshPage: "يرجى تحديث الصفحة لرؤية التأثير الكامل",
    duplicationHappened:
      "حدثت عملية تكرار للمعاملات، يرجى تحديث الصفحة لرؤية التأثير الكامل",
    configureDisplay: "تكوين العرض",
    generalConfiguration: "التكوين العام",
    studentName: "اسم التلميذ",
    className: "اسم الفصل",
    trimesterName: "اسم الثلاثي",
    schoolYear: "السنة الدراسية",
    orientation: "الاتجاه",
    positionX: "الموضع X",
    font: "الخط",
    size: "الحجم:",
    color: "اللون:",
    vertical: "عمودي",
    horizontal: "أفقي",
    centered: "وسط",
    atBeginning: "في البداية",
    selectFont: "اختر خط",
    textSize: "حجم النص",
    arabicAndFrench: "العربية والفرنسية",
    arabicOnly: "العربية فقط",
    amiriNormal: "أميري (عادي)",
    amiriBold: "أميري (غامق)",
    notoNaskhArabicNormal: "نوتو نسخ العربية (عادي)",
    notoSansArabicBold: "نوتو سانس العربية (غامق)",
    alJazeeraArabicBold: "الجزيرة العربية (غامق)",
    imprimerPVNiveaux: "طباعة البطاقة بالمستويات",
    ConsielClass: "مجلس القسم",
    changePositions: "تعديل المواقع",
    fuseSubSubject: "دمج المواد الفرعية",
    showSubModule: "اسم المجلات الفرعية",
    hideDate: "اخفاء التاريخ",
    hideSubject: "اخفاء المواد",
    useSubModule: "استخدام الوحدات الفرعية",
    subModule: "الوحدات الفرعية",
    managerSubModule: "إدارة الوحدات الفرعية",
    manageCertType: "تعديل الشهائد ل :",
    pvSortBy: "الترتيب حسب",
    pvSortOrder: "اتجاه الترتيب",
    pvSortAverage: "المعدل",
    pvSortName: "الاسم",
    pvSortAsc: "تصاعدي",
    pvSortDesc: "تنازلي",
    defaultModule: "تعيين وحدات افتراضية",
    defaultModuleConfirm:
      "هذا الإجراء سيحذف الوحدات الحالية. هل ترغب في المتابعة بتعيين الوحدات الافتراضية؟",
    defaultDone: "تم تحديث الوحدات الافتراضية بنجاح",
    alert: "غير ممكن التعديل: يرجى التعديل في التقرير المحدد.",
    avg: "متوسط الوحدة",
    coefTrimester1: "ضارب الثلاثي الأول",
    coefTrimester2: "ضارب الثلاثي الثاني",
    coefTrimester3: "ضارب الثلاثي الثالث",
    moyenneGeneral: "المعدل العام",
    moyenneTrimestreGeneral: "معدل الثلاثي العام",
    moyenneTrimestreGeneralMatieresBase:
      "معدل الثلاثي العام في المواد الأساسية",
    bulletinCoefs: "ضوارب بطاقات الأعداد",
    coefBulletinsSaved: "تم حفظ ضوارب بطاقات الأعداد بنجاح",
    decisionConseil: "قرار مجلس القسم",
    finalBulletin: "بطاقة نهايّة السنة",
    syncClass: "مزامنة الفصل",
    syncSubject: "مزامة المادة",
    syncMarks: "مزامنة الأعداد",
    sureToSync: "هل تريد تعديل الأعداد الموجودة مسبقًا",
    syncDone: "تم مزامنة الأعداد بنجاح",
    date: "تاريخ الطبع",
    parametrageSaved: "تم حفظ إعدادات نتائج الدراسية بنجاح",
    label: "الصياغة",
    moyennePersonalized: "المعدل المخصص للمدرسة",
    moyenneSpecifique: "المعدّل المخصص",
    moyennePedagogique: "المعدّل النموذجي",
    moyenneVerySpecifique: "المعدّل المخصص للغاية",
    formulePersonalized: " الصيغة",
    imprimerFichModuleVide: "نموذج فارغ",
    imprimerFichModule: "نموذج مكتمل",
    imprimerFichModuleVideAll: "كل النماذج الفارغة",
    imprimerFichModuleAll: "كل النماذج المكتملة",
    imprimerFichModuleVideAll: "كل النماذج الفارغة",
    imprimerFichModuleVideexcel: "Excel كل النماذج المكتملة ",
    imprimerFichModuleexcel: "Excel كل النماذج الفارغة",
    certByMoyenne: "الشهادات حسب معدلات التلاميذ",
    imprimerBulletin: "اطبع تقرير المدرسة",
    note: "درجة",
    nom: "اسم التلميذ",
    bulletin: "بطاقات اعداد",
    bulletinV1: "الإصدار القديم من بطاقات اعداد",
    notes: "درجات",
    matieres: "المواد",
    bulletinPedagogique: "بطاقات اعداد بيداغوجية",
    bulletinSpecifique: "بطاقات اعداد نموذجي",
    bulletinVerySpecifique: "بطاقات اعداد مخصصة",
    performancesMatiere: "أداء المواد",
    plus15: "أعلى من 15",
    plus12: "أعلى من 12",
    plus9: "أعلى 9",
    mois9: "أقل من 9",
    listeClasses: "قائمة الفصول",
    classesActives: "الفصول النشطة",
    nombreClassesNonNote: "عدد الفصول ذات درجات ناقصة",
    tousClassesSontNotes: "!كل الفصول ذات درجات مكتملة",
    nombreMatieresNonNote: "عدد المواد ذات درجات ناقصة",
    tousMatieresSontNotes: "!كل المواد ذات درجات مكتملة",
    nombreElevesNonNotes: "عدد التلاميذ الغير الحاصلين على درجات",
    tousElevesSontNotes: "!كل التلاميذ لديهم درجات كاملة",
    classes: "فصل",
    toutMatieres: "كل المواد",
    toutEleves: "جميع الطلاب",
    enregistrerTout: "حفظ الكل",
    parEleve: "حسب الطالب",
    parMatiere: "حسب المادة",
    typeIntrouvable: "النوع غير موجود",
    saisirSchoolType: "الرجاء إدخال نوع مؤسستك في الإعدادات - منشأة!",
    aucuneDonnee: "لا توجد بيانات متاحة لهذا الثلاثي",
    confirmPrintMatieres:
      "يجب إكمال علامات المواد أدناه ({count}) لإنشاء بطاقة الاعداد!",
    confirmPrintEleves:
      "يجب ملء درجات التلاميذ أدناه ({count})) لإنشاء بطاقة الاعداد!",
    generateAnyway: "إنشاء على كل حال",
    listeClassesNonNote: "قائمة الفصول ذات درجات ناقصة",
    listeMatiereNonNote: "قائمة المواد ذات درجات ناقصة",
    listeEleveNonNote: "قائمة التلاميذ غير الحاصلين على درجات",
    performancesNotes: "أداء الدرجات",
    notePlusHaute: "أعلى درجة",
    noteEleve: "درجة التلميذ",
    notePlusBasse: "أدنى درجة",
    moyennesModules: "معدل الوحدات",
    maximaleMoyenne: "أعلى معدل",
    moyenne: "المعدل",
    minimaleMoyenne: "أدنى معدل",
    imprimerTout: "طباعة الكل",
    moyenneTrimestre: "معدل الثلاثي : {moyenne}",
    moyenneMax: "أعلى معدل : {moyenne}",
    moyenneMin: "أدنى معدل : {moyenne}",
    validated: "بطاقة الأعداد أصبحت متاحة للفصل {name} الأن",
    unvalidated: "بطاقة الأعداد أصبحت غير متاحة للفصل {name} الأن",
    hideBulletin: "بطاقات أعداد لهذا القسم ستصبح غير متاحة للأولياء",
    validateBulletin: "بطاقات أعداد لهذا القسم ستصبح متاحة للأولياء",
    cancelValidation: "إلغاء الإتاحة للأولياء",
    validatedClassroom: "إتاحة للأولياء",
    deleteMark: "هل تريد حذف هذه العلامة؟",
    markDeletedSucc: "تم حذف العلامة بنجاح",
    markDeletedFail: "لا يمكن حذف العلامة ، يرجى المحاولة مرة أخرى!",
    showStamp: "إظهار الختم",
    PersonalizedAverage: "استخدام المتوسط المخصص",
    notesManquantes: "درجات غير مكتملة",
    SubModule: "المجلات الفرعية",
    Module: "المجالات",
    noTemplateFound: "لم يتم تكوين الاعداد، يرجى إضافة التكوين أولاً",
    exempt: "إعفاء",
    alreadyExempt: "معفى",
    confirmExemptStudent: "هل أنت متأكد أنك تريد جعل هذا الطالب معفى؟",
    confirmUnexemptStudent: "هل أنت متأكد أنك تريد إلغاء إعفاء هذا الطالب؟",
    showNbrStudents: "عرض عدد التلاميذ المرسّمين",
    bulletinNotDispo: "بطاقة الأعداد غير متاحة",
    bulletinDispo: "بطاقة الأعداد متاحة",
    parentVisibility: "إظهار للوالدين",
    activeStudents: "الطلاب النشطين",
    archivedStudents: "الطلاب المؤرشفين",
    directorNotesOnBehaviorAndAttendance:
      "ملاحظات المدير(ة) حول السّلوك و المواظبة",
    destination: "الوجهة",
    pleaseSelectOrTypeAppreciation: "يرجى اختيار أو كتابة تقييم",
    pv: "PV",
    pvExcel: "PV (Excel)",
    format: "تنسيق",
    formatAnnuel: "تنسيق سنوي",
    cannotModifyEditIn:
      "لا يمكن التعديل: يرجى التعديل في {type}، الوحدة: {name}",
    module: "الوحدة",
    noLevelsAvailable: "لا يوجد مستويات متاحة لهذا النوع من المؤسسة",
  },
  markHistory: {
    action: "الإجراء",
    action_create: "إنشاء",
    action_delete: "حذف",
    action_update: "تعديل",
    after: "بعد",
    before: "قبل",
    date: "التاريخ",
    empty: "لا يوجد سجل لتعديلات العلامات",
    role: "الدور",
    title: "سجل تعديلات العلامات",
    user: "المستخدم",
    viewHistory: "السجل",
  },
  bulletinStatistics: {
    totalWithoutAverage: "مجموع غير المتحصلين على معدل",
    totalWithAverage: "مجموع المتحصلين على معدل",
    schoolStatistics: "الإحصاء المدرسي",
    level: "المستوى",
    equalsOrExceeds16: "يساوي او يفوق 16",
    between15And1599: "يتراوح بين 15 و 15.99",
    between10And1499: "يتراوح بين 10 و 14.99",
    lessThan10: "دون 10 من 20",
    exceeds15: "يفوق 15",
    exceeds10To15: "يفوق 10 إلى 15",
    equals10: "ـ 10 من 20",
    from5ToLessThan10: "من 5 الى دون 10 من 20",
    lessThan5: "دون 5 من 20",
    student: "تلميذ",
    levelSuffix: "س",
  },
  personnel: {
    nom: "اللقب",
    prenom: "الإسم",
    adresse: "العنوان",
    telephone: "الهاتف",
    qualification: "الكفاءة",
    dateNaissance: "تاريخ الميلاد",
    typeContrat: "نوع العقد",
    salaire: "الراتب",
    cin: "البطاقة الشخصية",
    idCard: "رقم بطاقة الهوية",
    etatCivil: "حالة المدنية",
    niveau: "المستوى",
    experiences: "خبرة",
    dateEntretien: "تاريخ المقابلة",
    qualifications: "كفاءات",
    tauxHoraire: "معدل ساعة",
    detailPaiement: "بيانات الدفع",
    jourSemaine: "أيام في الأسبوع",
    expectedHoursPerDay: "الساعات المتوقعة / يوم",
    daysOff: "أيام الراحة",
    daysOffPlaceholder: "اختر أيام الراحة",
    weekday_0: "الأحد",
    weekday_1: "الإثنين",
    weekday_2: "الثلاثاء",
    weekday_3: "الأربعاء",
    weekday_4: "الخميس",
    weekday_5: "الجمعة",
    weekday_6: "السبت",
    expectedTeachingHours: "ساعات التدريس / مادة / أسبوع",
    expectedTeachingHoursHint: "اختر مادة وأدخل الساعات في الأسبوع",
    hoursPerWeek: "ساعات / أسبوع",
    addSubjectHours: "إضافة مادة",
    attendanceConfig: "إعدادات الحضور",
    cnss: "الصندوق الوطني للضمان الاجتماعي",
    rib: "بيان التعريف البنكي",
    pin: "رقم التعريف الضريبي",
    sha: "التأمين الصحي",
    nssf: "صندوق الضمان الاجتماعي الوطني",
    bankAccountNo: "رقم الحساب البنكي",
    bankName: "اسم البنك",
    bankBranch: "فرع البنك",
    autre: "اخر",
    notes: "درجات",
    infoBase: "معلومات اساسية",
    infoContrat: "معلومات العقد",
    chercher: "بحث",
    listeQualifications: "قائمة الكفاءات",
    staff: "الموظفين",
    gestionPaiements: "إدارة مدفوعات الموظفين",
    chercherParNom: "البحث بالاسم",
    nbPersonnel: "عدد الموظفين",
    infoPersonnel: "معلومات الموظف",
    type: "النوع",
    personnel: "الموظف",
    enseignant: "المعلم",
    personalList: "قائمة الموظفين",
    totalSalary: "إجمالي الرواتب",
    listPersonnelPDF: "قائمة_الموظفين",
    etatPaiePersonnels: "حالة الدفع الشهرية",
  },
  enseignant: {
    advisorAddExercice: "القدرة على إضافة التمارين",
    advisorAddNews: "القدرة على إضافة الأخبار",
    advisorValidateNews: "القدرة على التحقق من الأخبار",
    newsPermissions: "صلاحيات الأخبار",
    selectClassMessage: "الرجاء اختيار فصل من الفصول المخصصة للمعلم",
    addAccess: "إضافة صلاحيات للمعلم",
    nom: "اللقب",
    prenom: "الاسم",
    adresse: "عنوان بريدي",
    telephone: "هاتف",
    qualification: "الكفاءة",
    dateNaissance: "تاريخ الميلاد",
    typeContrat: "نوع العقد",
    salaire: "الراتب",
    cin: "البطاقة الشخصية",
    etatCivil: "حالة المدنية",
    niveau: "المستوى",
    experiences: "خبرة",
    dateEntretien: "تاريخ المقابلة",
    qualifications: "كفاءات",
    tauxHoraire: "معدل ساعة",
    detailPaiement: "بيانات الدفع",
    jourSemaine: "أيام في الأسبوع",
    cnss: "الصندوق الوطني للضمان الاجتماعي",
    rib: "بيان التعريف البنكي",
    autre: "اخر",
    notes: "درجات",
    infoBase: "معلومات اساسية",
    infoContrat: "معلومات العقد",
    chercher: "بحث",
    listeQualifications: "قائمة الكفاءات",
    matiere: "المادة",
    specialite: "تخصص",
    grade: "رتبة",
    email: "البريد الإلكتروني",
    mdp: "كلمة المرور",
    compte: "الحساب",
    detailPedagogiques: "المعلومات البيداغوجية",
    usernameEmail: "إسم المستخدم / البريد الإلكتروني",
    photo: "الصورة",
    conseillersPedagogiques: "المرشدون التربويون",
    ajouterConseillerPedagogique: "إضافة مرشد تربوي",
    enterInfoConseillerPedagogique:
      "أدخل معلومات المرشد التربوي في الحقول أدناه",
    niveauxSuperviser: "المستويات الخاضعة للإشراف",
    niveauxRequis: "المستويات مطلوبة",
    listeNiveaux: "قائمة المستويات",
    aucunConseillerPedagogique: "لم يتم العثور على مستشار تربوي",
    needValidation: "التحقق التلقائي من التمارين و الدروس",
    needValidation2: " الدورات ",
    needNewsValidation: "التحقق التلقائي من الأخبار",
    teacherAddNews: "القدرة على إضافة الأخبار",
    permissionsValidation: "صلاحيات التحقق",
    listeEnseignantsPDF: "قائمة_المعلمين",
    listeConseillersPedagogiquesPDF: "قائمة_المرشدين_التربويين",
    listeConseiller: "قائمة المرشدين التربويين",
    deactivateOrActivateTeacherAccount: "إلغاء أو تفعيل حساب المعلم",
    teacherQrCode: "رمز QR للمعلم",
    modifyTeacherAccessSubtitle:
      "تعديل صلاحيات المعلمين لتسهيل إدارة الدرجات والمحتوى التعليمي في EdTeacher.",
    educationalAdvisor: "مستشار تربوي",
    duplicate: "تكرار",
    duplicateAccessForTeacher: "تكرار الوصول للمعلم",
    duplicateAllTeachers: "تكرار جميع المعلمين",
    duplicateAccessForAllTeachers: "تكرار الوصول لجميع المعلمين",
    accessLevelAddedSuccessfully: "تم إضافة مستوى الوصول بنجاح",
    accessLevelNotAdded: "لم يتم إضافة مستوى الوصول",
    revokedAccessFrom: "تم إلغاء الصلاحية من",
    onModules: "على الوحدات",
    unknownModule: "وحدة غير معروفة",
  },
  etatPaiement: {
    personnel: "عامل",
    salaire: "الراتب",
    avance: "تسبقة",
    nbJours: "عدد الأيام",
    mois: "شهر",
    etatPaiement: "حالة الدفع",
    virementBancaire: "حوالة مصرفية?",
    paiementAction: "دفع",
    selectionnerMois: "إختر شهرا",
    selectionnerFrais: "اختر الرسوم المراد دفعها",
    totalAvances: "إجمالي السلف",
    frais: "الرسوم",
    montant: "المبلغ",
    fraisAPayer: "الرسوم المراد دفعها",
    inscription: "التسجيل",
    tranche: "القسط",
    toutAfficher: "عرض الكل",
    toutMasquer: "إخفاء الكل",
    payerAvecAvance: "دفع مع سلفة",
    sansAvance: "بدون سلفة",
    activerPaiementAvance: "تفعيل الدفع مع السلفة",
    montantAvance: "مبلغ السلفة (د.ت)",
    saisirMontant: "أدخل المبلغ",
    fraisNonPayes: "رسوم غير مدفوعة",
    reste: "متبقي",
    avanceAppliquee: "السلفة المطبقة",
    restePayer: "متبقي للدفع",
    paiementPartiel: "دفع جزئي - المبلغ المتبقي للدفع",
    montantInvalide:
      "مبلغ السلفة المدخل لا يسمح بتغطية هذه الرسوم. يرجى إدخال مبلغ سلفة أعلى.",
    selectionnerTout: "اختيار الكل",
    deselecTout: "إلغاء اختيار الكل",
    montantSupTotal:
      "مبلغ السلفة المدخل أعلى من المبلغ الإجمالي للرسوم المراد دفعها. مبلغ السلفة يجب أن يكون أقل من أو يساوي",
    montantInsuffisant:
      "مبلغ السلفة المدخل لا يسمح بتغطية جميع الرسوم. يرجى إدخال مبلغ سلفة أعلى.",
    paiementsPersonnels: "الدفعات الشهرية",
    attendanceReference: "مرجع الحضور (معلم)",
    attendanceReferenceHint:
      "معلومات إرشادية للشهر المحدد. لا يتم ملء حقول الأيام/الساعات تلقائيًا.",
    noAttendanceData: "لا توجد بيانات حضور لهذا الشهر.",
    attendanceDetails: "التفاصيل",
    attendanceDetailsTitle: "تفاصيل الحصص",
    attendanceSource: "المصدر",
    attendanceSourceCheckin: "تسجيل حضور",
    attendanceSourceManual: "يدوي",
    reste: "المتبقي",
    scolarite: "الدراسة",
    activite: "النشاط",
  },
  hr: {
    nbHeures: "عدد الساعات بالأسبوع",
    nbJours: "عدد الأيام بالأسبوع",
    espece: "نقد",
    cheque: "شيك",
    modePaiement: "طريقة الدفع",
    modifierPaiement: "تعديل الدفع",
    paiementModifie: "تم تعديل الدفع بنجاح",
    paiementSupprime: "تم حذف الدفع بنجاح",
  },
  virement: {
    rib: "بيان التعريف البنكي",
    nom: "اللقب",
    prenom: "الاسم",
    etatPaiement: "حالة الدفع",
    salaire: "الراتب",
    mois: "الشهر",
    nbJours: "عدد الأيام",
    chercher: "بحث",
  },
  recette: {
    fournisseurProfil: "ملف المزود",
    checksDueThisWeek: "الشيكات المستحقة هذا الأسبوع",
    anneeScolaire: "السنة الدراسية",
    dateAjout: "تاريخ الإضافة",
    doneBy: "تم بواسطة",
    cancelledBy: "ألغى بواسطة",
    actions: "إجراءات",
    detailsReglement: "تفاصيل الدفع",
    infosGenerales: "معلومات عامة",
    repartitionMontants: "توزيع المبالغ",
    lignesReglement: "سطور الدفع",
    periodeHint:
      "تُطبَّق الفترة فقط على السنوات الدراسية المحددة. لا تُدرج الفواتير والإيصالات من السنوات الأخرى حتى إن وقعت ضمن التواريخ.",
    montantRequis: "المبلغ مطلوب ويجب أن يكون رقماً",
    montantCheque: "المبلغ عبر الصك البنكي",
    montantEspece: "المبلغ النقدي",
    montantTraite: "مبلغ السحب",
    montantTPE: "مبلغ جهاز الدفع الإلكتروني",
    montantVirement: "مبلغ التحويل",
    montantTotal: "المبلغ الإجمالي",
    typePaiement: "طريقة الدفع",
    montant: "مقدار",
    nom: "اسم الزبون",
    typeRecete: "نوع الدخل",
    typeReglement: "نوع الأجر",
    modePaiement: "طريقة الدفع",
    receiptType: "طريقة الدفع",
    montantHT: "المبلغ غير شامل الضريبة",
    montantTTC: "المبلغ شاملاً الضريبة",
    type: "النوع",
    datePaiement: "تاريخ الدفع",
    numCheque: "رقم الشيك",
    imprimer: "طباعة ",
    csv: "CSV",
    tous: "الكل",
    cheque: "صك بنكي",
    espece: "نقد",
    chequeEtEspece: "صك و نقد",
    detailsPaymentDist: "تفاصيل الصك",
    numero: "الرقم",
    titulaire: "صاحب الحساب",
    banque: "المصرف",
    dateEcheance: "تاريخ الاستحقاق",
    chequeMontantTotal: "المبلغ الإجمالي للشيك",
    relatedPayments: "المعاملات ذات الصلة",
    fermer: "إغلاق",
    ok: "حسنا",
    typeJournal: "نوع السجل",
    selectionnerDate: "حدد تاريخ",
    motCles: "الكلمات الدالة",
    chercher: "بحث",
    bouillard: "Bouillard صندوق ",
    annule: "ملغى",
    personnel: "عامل",
    salaire: "راتب",
    avance: "تسبقة",
    avanceAPayer: "السلفة المطلوب دفعها",
    invoicesCanOnlyBeCredited: "يمكن فقط إضافة فواتير دائنة (إشعار دائن)",
    listeReglements: "قائمة المدفوعات",
    nbJours: "عدد الأيام",
    mois: "شهر",
    etatPaiement: "حالة الدفع",
    virementBancaire: "حوالة مصرفية",
    typeDepense: "نوع التكاليف",
    date: "تاريخ",
    dateDebutPlaceholder: "حدد تاريخ البداية",
    dateFinPlaceholder: "حدد تاريخ النهاية",
    fournisseur: "المزود",
    numSerie: "الرقم التسلسلي",
    nomParent: "اسم الوالدين",
    dateAnnulation: "تاريخ الإلغاء",
    facture: "فاتورة ؟",
    impression: "طباعة",
    annulation: "الإلغاء",
    paiementQuoi: "المعاليم",
    selectionnerParent: "حدد الولي",
    selectionnerEnfant: "حدد الطفل",
    titre: "عنوان",
    valider: "تاكيد",
    recuPaiement: "إيصال الدفع",
    facturePaiement: "فاتورة الدفع",
    paiementTotal: "المبلغ الإجمالي؟",
    paiementPour: "الدفع مقابل ",
    restePayer: "الدفوعات المتبقيّة",
    payer: "دفع",
    payerMain: "ادفع الآن ؟",
    reducRepet: "التخفيض المتكرر",
    reducFact: "تخفيض على هذه الفاتورة",
    reducRecu: "تخفيض على هذا الإيصال",
    reducInscri: "خصم على التسجيل",
    reductionMensuel: "خصم شهري",
    fraisInscri: "رسوم التسجيل",
    fraisMensuel: "رسوم شهرية",
    ajouterPaiement: "إضافة الدفع",
    montantRestant: "الكمية المتبقية",
    inscription: "تسجيل",
    telephone: "هاتف",
    frais: "التكاليف",
    enfant: "طفل",
    activite: "نشاط",
    tousMois: "كل الشهور",
    montantHTVA: "المبلغ غير شامل ضريبة القيمة المضافة",
    nonSeule: "لا (مرة واحدة فقط)",
    payeQues: "مدفوع ؟",
    recus: "الإيصالات",
    factureTag: "فاتورة",
    traite: "سند لأمر",
    virement: "تحويل بنكي",
    TPE: "جهاز الدفع الإلكتروني",
    avantReduction: " قبل التخفيض",
    apresReduction: " بعد التخفيض",
    reduction: " التخفيض",
    saisirInfoCheque: "أدخل معلومات الشيك",
    saisirInfoChequeEtEspace: "أدخل معلومات الشيك والنقد",
    timbreFiscal: "الطابع الضريبي",
    associatedCheques: "الشيكات المرتبطة",
    associatedTraites: "السحوبات المرتبطة",
    associatedTPE: "أجهزة الدفع الإلكتروني المرتبطة",
    associatedVirements: "التحويلات المرتبطة",
    saisirInfoTraite: "أدخل معلومات السحب",
    saisirInfoTPE: "أدخل معلومات جهاز الدفع الإلكتروني",
    versable: "قابل للدفع؟",
    transactionId: "معرّف المعاملة",
    nonTransfere: "غير مجمعة",
    transfere: "مجمعة",
    paiementEffectue: "تم الدفع",
    saisirInfoVirement: "أدخل معلومات الدفع",
    replacedCheques: "شيكات مستبدلة بالنقد",
    chequeTraite: "شيكات وسحوبات",
    borderaux: "المستندات",
    stat: "الإحصائيات",
    file: "الملف",
    replacedBy: "تم الاستبدال بواسطة",
    viewFile: "عرض الملف",
    uploadFile: "رفع ملف",
    erreurChargementDonnees: "خطأ في تحميل البيانات",
    selectionnerModePaiement: "اختر طريقة الدفع",
    montantsNonEgaux: "المبالغ المدخلة لا تساوي المبلغ الإجمالي",
    paiementAjoute: "تمت إضافة الدفع",
    paiementNonEffectuer: "لم يتم تنفيذ الدفع",
    typeFactureFeesRestants:
      "لا يمكنك اختيار نوع 'فاتورة' عندما تحتوي الرسوم المحددة على مبالغ متبقية للدفع. يرجى أولاً تسوية المبالغ المتبقية أو اختيار نوع 'إيصال'.",
    sommeMontantsEgal: "يجب أن يكون مجموع المبالغ مساوياً لـ {amount}",
    montantEgal: "يجب أن يكون المبلغ مساوياً لـ {amount}",
    parentAnd: "و",
    nonValid: "لا يمكنك التحقق من صحة دفع مبلغ يساوي صفر",
    payWithAvance: "الدفع مع السلف",
    payWithoutAvance: "الدفع بدون سلف",
    selectAdvances: "اختر السلفات المراد استخدامها",
    parentBalance: "رصيد ولي الأمر",
    advanceAmountLabel: "مبلغ السلف",
    advanceAmountPlaceholder: "مبلغ السلف",
    remainingToPay: "المتبقي للدفع",
    index: "المؤشر",
    payable: "قابل للدفع",
    nonPayable: "غير قابل للدفع",
    addCheque: "إضافة شيك",
    chequeAmount: "مبلغ الشيك",
    cashAmount: "المبلغ النقدي",
    incorrectAmountsInfo:
      "معلومات مبالغ الشيكات والمبلغ النقدي غير صحيحة، يرجى تصحيحها قبل توزيع المبالغ",
    totalAmountMustBe: "يجب أن يكون المبلغ الإجمالي",
    selectFeesToPay: "اختر الرسوم المراد دفعها",
    education: "التعليم",
    addDate: "تاريخ الإضافة",
    chequeAmountColumn: "مبلغ الشيك",
    advanceAmountColumn: "مبلغ السلف",
    invoiceNumber: "فاتورة رقم",
    receiptNumber: "إيصال رقم",
    fullName: "الاسم واللقب",
    child: "الطفل",
    baseReduction: "تخفيض أساسي",
    totalAmountIs: "المبلغ الإجمالي هو",
    page: "صفحة",
    advanceDebited: "تم خصم السلف من رصيد ولي الأمر بنجاح",
    sumChequeCashEqual:
      "يجب أن يكون مجموع مبالغ الشيك والنقد مساوياً لـ {amount}",
    tranche: "القسط",
    paymentMethod: {
      ESPESE: "نقد",
      CHEQUE: "شيك",
      TPE: "جهاز الدفع الإلكتروني",
      TRAITE: "سحب",
      VIREMENT: "تحويل",
      VERSEMENT: "الإيداع",
    },
    fluxType: {
      ALIMENTATION_P: "تمويل الصندوق الرئيسي",
      ALIMENTATION_SOUS_CAISSES: "تمويل الصندوق الفرعي",
      VERSEMENT: "الإيداع",
      COLLECTE_SOUS_CAISSES: "جمع الصندوق الفرعي",
      CHEQUE_TRAITE_BANQUE: "تحويل الشيك/السحب إلى البنك",
      CHEQUE_TRAITE_CASH_REPLACEMENT: "استبدال الشيك/السحب بالنقد",
    },
    stats: {
      financialDashboard: "إحصائيات الشيكات والسحوبات والتحويلات",
      paymentsOverview: "نظرة عامة على المدفوعات والمعاملات",
      bankStatus: "الحالة المصرفية",
      generalStatus: "الحالة العامة",
      rejectedChequesAlert: "تنبيه : المدفوعات المرفوضة غير محلولة",
      rejectedPayments: "مدفوعات مرفوضة",
      rejectedPayment: "دفعة مرفوضة",
      forTotalAmount: "بمبلغ إجمالي قدره",
      elements: "عناصر",
      transactions: "معاملات",
      loadingStatsError: "خطأ في تحميل الإحصائيات",
    },
    pdfGenerationError: "حدث خطأ أثناء الطباعة",
    pdfDailyFeesCount: "{count} حصص",
    effectuePar: "تم بواسطة",
    parent: "الولي",
    nSerie: "رقم التسلسل",
    toutesDates: "كل التواريخ",
    depensesAnnule: "المصروفات الملغاة",
    montantTotalText: "المبلغ الإجمالي هو",
    tags: "العلامات",
    totalSansReduction: "الإجمالي بدون تخفيض",
    totalHTVA: "الإجمالي بدون ضريبة القيمة المضافة",
    tva: "ضريبة القيمة المضافة",
    totalTTC: "الإجمالي شامل الضريبة",
    dateRangeFrom: "من",
    dateRangeTo: "إلى",
    csvLabelTypeDepense: "نوع المصروف",
    csvLabelDate: "التاريخ",
    csvLabelMontantTTC: "المبلغ شامل الضريبة",
    csvLabelFournisseur: "المورد",
  },
  encaissement: {
    paymentMethod: "طريقة الدفع",
    cash: "نقدي",
    cheque: "شيك",
    tpe: "جهاز الدفع الإلكتروني",
    draft: "سحب",
    transfer: "تحويل",
    cashRegister: "صندوق",
    selectCashRegister: "اختر صندوق",
    period: "الفترة",
    monthlyPayment: "دفع شهري",
    singlePayment: "دفع مرة واحدة",
    installmentPayment: "دفع بالأقساط",
    activity: "نشاط",
    schooling: "مدرسي",
    fees: "رسوم",
    monthly: "شهري",
    installments: "أقساط",
    stateOfReceipts: "حالة الإيصالات",
    creditNote: "إشعار دائن",
    summaryByPaymentMethod: "ملخص حسب طريقة الدفع",
    totalGeneral: "المجموع العام",
    stateOfUnpaid: "حالة غير المدفوع",
    schoolingStateOfUnpaid: "مدرسي: حالة غير المدفوع",
    activitiesStateOfUnpaid: "أنشطة: حالة غير المدفوع",
    invoicesCanOnlyBeCredited: "يمكن فقط إضافة فواتير دائنة (إشعار دائن)",
    quantite: "الكمية",
    eleve: "الطالب",
    pdfTableHeaders: {
      clientName: "اسم العميل",
      telephone: "الهاتف",
      child: "الأطفال",
      fees: "الرسوم",
      amount: "المبلغ",
      total: "المجموع",
    },
    pdfTotal: "المجموع",
    pdfCurrencySuffix: "د.ت",
    pdfFileName: "حالة_غير_المدفوع",
  },
  scolaritePdf: {
    total: "المجموع",
    registration: "التسجيل",
    schooling: "مدرسي",
    activities: "أنشطة",
    levels: "المستويات",
    allLevels: "جميع المستويات",
    installment: "القسط {number}",
    legendPaid: "مدفوع",
    legendUnpaid: "غير مدفوع",
    legendPaidPartially: "مدفوع جزئياً",
    legendPaidWithDiscount: "مدفوع مع تخفيض",
    totalDiscountAmount: "إجمالي مبلغ التخفيض",
    totalAdvancePayments: "إجمالي المدفوعات المقدمة",
  },
  caisse: {
    caisse: "صندوق",
    SUBCAISSE: "صندوق فرعي",
    BANK: "بنك",
    PRINCIPAL: "صندوق رئيسي",
    fermerCaisse: "إغلاق الصندوق",
    ouvrirCaisse: "فتح الصندوق",
    caisseOuverte: "تم فتح الصندوق بنجاح",
    caisseFermee: "تم إغلاق الصندوق بنجاح",
    caisseFermeeMessage: "الصندوق مغلق",
    caisseOuvertureAutomatique: "سيتم فتح الصندوق تلقائياً بعد الدفع",
    erreurOuverture: "خطأ في فتح الصندوق",
    erreurFermeture: "خطأ في إغلاق الصندوق",
    confirmationOuverture: "تأكيد الفتح",
    confirmationFermeture: "تأكيد الإغلاق",
    messageOuverture: "هل تريد حقاً فتح الصندوق؟",
    messageFermeture: "هل تريد حقاً إغلاق الصندوق؟",
    erreurAlimentation: "خطأ أثناء تمويل الصندوق",
    aucuneCaisseAssigne: "لا توجد صندوق مخصص",
    aucuneCaisseAssigneDesc: "ليس لديك أي صندوق مخصص في الوقت الحالي.",
    ajouterCaisse: "إضافة صندوق",
    modifierCaisse: "تعديل الصندوق",
    gererCaisses: "إدارة الصناديق",
    detailsCaisse: "تفاصيل الصندوق",
    proprietaire: "المالك",
    proprietaires: "المالكون",
    selectionnerCaisse: "اختر صندوقًا",
    toutesLesAnnees: "كل السنوات الدراسية",
    anneeScolaireColonne: "السنة الدراسية",
    balance: "الرصيد",
    statut: "الحالة",
    type: "النوع",
    nom: "الاسم",
    reference: "المرجع",
    banque: "البنك",
    disponibilite: "التوفر",
    actif: "نشط",
    inactif: "غير نشط",
    ouverte: "مفتوح",
    fermee: "مغلق",
    enregistrer: "حفظ",
    desactiver: "إلغاء التفعيل",
    activer: "تفعيل",
    general: "عام",
    modifier: "تعديل",
    acces: "الوصول",
    transfers: "التحويلات",
    historique: "التاريخ",
    totalDebits: "إجمالي المدين",
    totalCredits: "إجمالي الدائن",
    debit: "مدين",
    credit: "دائن",
    nombreCheques: "عدد الشيكات",
    montantCheques: "مبلغ الشيكات",
    montantTotalCheques: "إجمالي مبلغ الشيكات",
    nombreTraites: "عدد السحوبات",
    montantTraites: "مبلغ السحوبات",
    montantTotalTraites: "إجمالي مبلغ السحوبات",
    nombreTPE: "عدد أجهزة الدفع الإلكتروني",
    montantTPE: "مبلغ أجهزة الدفع الإلكتروني",
    montantTotalTPE: "إجمالي مبلغ أجهزة الدفع الإلكتروني",
    nombreVirements: "عدد التحويلات",
    montantVirements: "مبلغ التحويلات",
    montantTotalVirements: "إجمالي مبلغ التحويلات",
    montantEspeces: "مبلغ نقدي",
    alerteGestionTransactions:
      "إدارة المعاملات بين الصناديق متاحة فقط في ملف الصندوق الرئيسي.",
    nomRequis: "الاسم مطلوب",
    referenceRequise: "المرجع مطلوب",
    typeRequis: "النوع مطلوب",
    nomBanque: "اسم البنك",
    caisseAjouteeSucces: "تم إضافة الصندوق بنجاح",
    erreurAjoutCaisse: "خطأ في إضافة الصندوق",
    erreurChargementCaisses: "خطأ في تحميل الصناديق",
    erreurChargementCaisse: "خطأ في تحميل الصندوق",
    settings: "الإعدادات",
    label: "التسمية",
    lePorteur: "الحامل",
    disponibiliteUpper: "التوفر",
    typeUpper: "النوع",
    statutUpper: "الحالة",
    actions: "الإجراءات",
    caisseModifieeSucces: "تم تعديل الصندوق بنجاح",
    erreurModificationCaisse: "خطأ في تعديل الصندوق",
    caisseDesactiveeSucces: "تم إلغاء تفعيل الصندوق بنجاح",
    erreurDesactivationCaisse: "خطأ في إلغاء تفعيل الصندوق",
    caisseActiveeSucces: "تم تفعيل الصندوق بنجاح",
    erreurActivationCaisse: "خطأ في تفعيل الصندوق",
    utilisateursAutorises: "المستخدمون المخولون",
    accesALaCaisse: "الوصول إلى الصندوق",
    selectionnerUtilisateur: "اختر مستخدماً",
    roles: "الأدوار",
    lire: "قراءة",
    ecrire: "كتابة",
    proprietaireRole: "مالك",
    roleDepense: "مصروف",
    roleDepenseEncaissement: "مصروف — استقبال (إيصالات، أرصدة دائنة)",
    ajouterUtilisateur: "إضافة مستخدم",
    enregistrerAcces: "حفظ الوصول",
    veuillezRemplirChamps: "يرجى ملء جميع الحقول المطلوبة",
    exactementUnProprietaire: "يجب أن يكون هناك مالك واحد بالضبط (OWNER)",
    auMoinsUnProprietaire: "يجب أن يكون للصندوق مالك واحد على الأقل (OWNER)",
    utilisateurEnDouble: "لا يمكن إدراج المستخدم أكثر من مرة في قائمة الوصول",
    accesMisAJour: "تم تحديث الوصول",
    erreurMiseAJourAcces: "خطأ في تحديث الوصول",
    erreurChargementUtilisateurs: "خطأ في تحميل المستخدمين",
    nouveauTransfert: "تحويل جديد",
    reglesCollectePartielle: "قواعد التحصيل",
    montantDemande: "المبلغ المطلوب",
    especesDisponibles: "النقد المتاح",
    collectePartielleEspecesUniquement:
      "المبلغ المطلوب يتجاوز النقد المتاح.",
    collecteTotaleTousModes:
      "يمكن أن يشمل التحصيل الكامل جميع طرق الدفع دون قيود.",
    modesNonEspecesCollecteTotale:
      "لا يمكن تحصيل TPE وطرق الدفع الأخرى جزئيًا. يجب تحصيلها بالكامل.",
    pourMontantPrecis: "للحصول على مبلغ محدد",
    etapeCollecterTout: "قم بتحصيل كامل باستخدام «تحصيل الكل».",
    etapeTransfererMontant:
      "ثم حوّل المبلغ المطلوب إلى صندوق فرعي.",
    typeDeFlux: "نوع التدفق",
    libelle: "التسمية",
    montant: "المبلغ",
    toutCollecterBtn: "جمع الكل",
    veillezSelectionnerTypeFlux:
      "يرجى أولاً اختيار نوع التدفق لمتابعة إدخال التحويل.",
    veillezSelectionnerTypeFluxMessage: "يرجى اختيار نوع التدفق",
    veillezSaisirLibelle: "يرجى إدخال تسمية",
    veillezSaisirMontant: "يرجى إدخال مبلغ",
    selectionnerTypeAlimentation: "اختر نوع التمويل",
    veillezSelectionnerType: "يرجى اختيار نوع",
    caisseSource: "الصندوق المصدر",
    caisseDestination: "الصندوق الوجهة",
    selectionnerCaisseSource: "اختر الصندوق المصدر",
    selectionnerCaisseDestination: "اختر الصندوق الوجهة",
    veillezSelectionnerCaisseSource: "يرجى اختيار صندوق مصدر",
    veillezSelectionnerCaisseDestination: "يرجى اختيار صندوق وجهة",
    commentaire: "تعليق",
    ajouterCommentaire: "أضف تعليقاً (اختياري)",
    commentaireMaxCaracteres: "يجب ألا يتجاوز التعليق 500 حرف",
    paymentsEffectues: "المدفوعات المنجزة",
    valider: "تأكيد",
    transactionsDeLaCaisse: "معاملات الصندوق",
    alimentationEffectueeSucces: "تم التمويل بنجاح",
    alimentationCaissePrincipale: "تمويل الصندوق الرئيسي",
    alimentationSousCaisses: "تمويل الصناديق الفرعية",
    versement: "إيداع",
    collecteSousCaisses: "جمع الصناديق الفرعية",
    caisseBanque: "صندوق البنك",
    augmentationCapital: "زيادة رأس المال",
    fonds: "أموال",
    historiqueTransactions: "تاريخ المعاملات",
    dateColonne: "التاريخ",
    typeDeFluxColonne: "نوع التدفق",
    montantColonne: "المبلغ",
    sourceColonne: "المصدر",
    destinationColonne: "الوجهة",
    utilisateurColonne: "المستخدم",
    actionsColonne: "الإجراءات",
    details: "التفاصيل",
    detailsTransaction: "تفاصيل المعاملة",
    utilisateurTransaction: "المستخدم",
    typeDeCollecte: "نوع الجمع",
    totale: "كامل",
    partielle: "جزئي",
    etatCaisses: "حالة الصناديق وقت المعاملة",
    etatCaisseSource: "حالة الصندوق المصدر",
    etatCaisseDestination: "حالة الصندوق الوجهة",
    erreurChargementTransactions: "خطأ في تحميل المعاملات",
    erreurRecuperationSolde: "خطأ في استرداد رصيد الصندوق",
    transactions: "المعاملات",
    erreurChargementStatistiques: "خطأ في تحميل الإحصائيات",
    nombrePaiementEspeces: "عدد المدفوعات النقدية",
    montantTotalPaiementEspeces: "إجمالي مبلغ المدفوعات النقدية",
    nombrePaiementTPE: "عدد مدفوعات أجهزة الدفع الإلكتروني",
    montantTotalPaiementTPE: "إجمالي مبلغ مدفوعات أجهزة الدفع الإلكتروني",
    typeEncaissement: "إيراد",
    typeInverseEncaissement: "إيراد عكسي",
    typeAvoirCredit: "إشعار دائن مورد (أvoir)",
    inverseDetailMissing:
      "لا يوجد جدول استحقاق مرتبط بهذا الدفع لعرض التفاصيل.",
    typeDecaissement: "صرف",
    typeColonne: "النوع",
    descriptionColonne: "الوصف",
    journalCaisseTitle: "دفتر الصندوق",
    dateImpression: "تاريخ الطباعة",
    dateHeure: "التاريخ والوقت",
    touteLaPeriode: "كامل الفترة",
    statutCollecte: "حالة التحصيل",
    totalRecettes: "إجمالي الإيرادات",
    totalDepenses: "إجمالي المصروفات",
    balanceTable: "الرصيد",
    totalEncaissements: "إجمالي المداخيل",
    totalDecaissements: "إجمالي المصروفات",
    facturesAnnulees: "الفواتير / الإيصالات الملغاة",
    depenseLabel: "دفع مصروف",
    beneficiary: "المستفيد",
  },
  tresorerie: {
    chequeTraitePdf: "الشيكات-المعالَجة",
    bordereauPdf: "كشف الإيداع",
    avoirs: "إشعار دائن",
    chequesTraites: "الشيكات والسحوبات",
    bordereaux: "كشوف الإيداع",
    statistiques: "الإحصائيات",
    listeReglementAnnule: "قائمة المدفوعات الملغاة",
    recherche: "البحث الشامل",
    type: "النوع",
    statut: "الحالة",
    statutDepot: "حالة الإيداع",
    numero: "الرقم",
    description: "الوصف",
    montant: "المبلغ",
    date: "التاريخ",
    dateCreation: "تاريخ الإنشاء",
    dateDepotPrevue: "تاريخ الإيداع المتوقع",
    dateDepotEffective: "تاريخ الإيداع الفعلي",
    caisse: "الصندوق",
    banque: "البنك",
    titulaire: "الحامل",
    note: "ملاحظة",
    selectionnerType: "اختر النوع",
    filtrerParNom: "تصفية حسب الاسم",
    recherchreParNumeroDescription: "البحث بالرقم أو الوصف",
    statutBanque: "حالة البنك",
    statutGeneral: "الحالة العامة",
    statutDuDepot: "حالة الإيداع",
    statutDuBordereau: "حالة كشف الإيداع",
    selectionnerTypeBordereau: "اختر نوع كشف الإيداع",
    dateDepotPrevuePlaceholder: "تاريخ الإيداع المتوقع",
    dateDepotEffectivePlaceholder: "تاريخ الإيداع الفعلي",
    nomTitulaire: "اسم الحامل",
    noteOptionnelle: "ملاحظة اختيارية",
    descriptionBordereau: "وصف كشف الإيداع",
    selectionnerCaisse: "اختر الصندوق",
    nouveauBordereau: "كشف إيداع جديد",
    toutSelectionner: "اختيار الكل",
    toutDeselectionner: "إلغاء اختيار الكل",
    modifier: "تعديل",
    supprimer: "حذف",
    voir: "عرض",
    details: "التفاصيل",
    gererCheques: "إدارة الشيكات",
    enAttente: "في الانتظار",
    valide: "مصادق",
    rejete: "مرفوض",
    nonDepose: "غير مودع",
    depose: "مودع",
    traite: "معالج",
    annulation: "إلغاء",
    avoir: "إشعار دائن",
    cheque: "شيك",
    traiteType: "سحب",
    numSerie: "الرقم التسلسلي",
    nomParent: "اسم الوالد",
    nomClient: "اسم العميل",
    typeReglement: "نوع الدفع",
    facture: "مفوتر",
    dateAnnulation: "تاريخ الإلغاء",
    annulePar: "ألغي بواسطة",
    typesReglement: "أنواع الدفع",
    anneeScolaire: "السنة الدراسية",
    detailsBordereau: "تفاصيل كشف الإيداع",
    modifierBordereau: "تعديل كشف الإيداع",
    creerBordereau: "إنشاء كشف إيداع",
    modifierCheque: "تعديل الشيك",
    gestionCheques: "إدارة الشيكات",
    oui: "نعم",
    non: "لا",
    erreurChargementDonnees: "خطأ في تحميل البيانات",
    erreurSauvegarde: "خطأ في الحفظ",
    erreurSuppression: "خطأ في الحذف",
    erreurCreation: "خطأ في الإنشاء",
    bordereau: {
      creeSucces: "تم إنشاء كشف الإيداع بنجاح",
      modifieSucces: "تم تعديل كشف الإيداع بنجاح",
      supprimeSucces: "تم حذف كشف الإيداع بنجاح",
    },
    verificationPermissions: "التحقق من الصلاحيات...",
    aucunAcces: "ليس لديك صلاحية للوصول إلى أي علامة تبويب في هذا القسم.",
    pasAccesOnglet: "ليس لديك صلاحية للوصول إلى هذه العلامة التبويبية",
    reglementsAnnules: "المدفوعات الملغاة",
    exportCSV: "تصدير CSV",
    rechercherCheques: "البحث في الشيكات",
    rechercherTraites: "البحث في السحوبات",
    periode: "الفترة",
    factureLabel: "فاتورة",
    espece: "نقدي",
    remplacerParEspece: "استبدال بالنقد",
    confirmationRemplacement:
      "هل أنت متأكد من أنك تريد استبدال الشيك {numero} بدفع نقدي بقيمة {montant}؟",
    chequeRemplaceSucces: "تم استبدال الشيك بالنقد بنجاح",
    erreurRemplacementCheque: "خطأ في استبدال الشيك",
    chequeNonEligible: "الشيك غير مؤهل للاستبدال",
    chequeNonTrouve: "الشيك غير موجود",
    remplacementChequeNote: "استبدال الشيك {numero} بدفع نقدي",
    elements: "عناصر",
    sur: "من",
    modifierLe: "تعديل",
    numeroChequeTraite: "رقم الشيك/السند",
    dateEcheance: "تاريخ الاستحقاق",
    informationsNonModifiables: "معلومات غير قابلة للتعديل",
    modification: "جاري التعديل...",
    numeroRequis: "الرقم مطلوب",
    banqueRequis: "البنك مطلوب",
    dateEcheanceRequis: "تاريخ الاستحقاق مطلوب",
    titulaireRequis: "الحامل مطلوب",
    virement: "تحويل",
    actif: "نشط",
    inactif: "غير نشط",
    chequeModifieSucces: "تم تعديل الشيك بنجاح",
    erreurModification: "خطأ أثناء التعديل",
    cheques: "الشيكات",
    traites: "السحوبات",
    chequesPluriel: "شيك(ات)",
    traitesPluriel: "سند(ات)",
    valides: "مصادق(ة)",
    gererLesCheques: "إدارة الشيكات",
    aucunCheque: "لا توجد شيكات",
    confirmationSuppressionBordereau:
      "هل أنت متأكد من أنك تريد حذف كشف الإيداع هذا؟",
    impossibleSupprimerBordereau:
      "لا يمكن حذف كشف إيداع يحتوي على شيكات مصادقة",
    selectionnes: "مختار(ة)",
    aucunSelectionne: "لا شيء",
    modificationEnCours: "جاري التعديل...",
    creationEnCours: "جاري الإنشاء...",
    creer: "إنشاء",
    typeBordereauRequis: "نوع كشف الإيداع مطلوب",
    statutRequis: "الحالة مطلوبة",
    caisseRequise: "الصندوق مطلوب",
    auMoinsUnElementRequis: "مطلوب عنصر واحد على الأقل",
    num: "رقم",
    rib: "الرقم البنكي",
    erreurChargementCaisses: "خطأ في تحميل الصناديق",
    erreurChargementElements: "خطأ في تحميل العناصر",
    erreurCreationBordereau: "خطأ في إنشاء كشف الإيداع",
    rechercheParNumeroTitulaireBanque: "البحث بالرقم، الحامل، البنك...",
    rechercheParNumeroBanque: "البحث بالرقم، البنك...",
    informationsDuBordereau: "معلومات كشف الإيداع",
    total: "المجموع",
    montantTotal: "المبلغ الإجمالي",
    listeDes: "قائمة",
    aucuneDescription: "لا يوجد وصف",
    fermer: "إغلاق",
    erreurGenerationBordereau: "خطأ في إنشاء كشف الإيداع.",
    chequesTraites: "الشيكات والسحوبات",
    echeance: "تاريخ الاستحقاق",
    nombreTotalElements: "إجمالي عدد العناصر",
    repartitionParType: "التوزيع حسب النوع",
    repartitionParStatut: "التوزيع حسب الحالة",
    virements: "التحويلات البنكية",
    pdfGeneratedSuccessfully: "تم إنشاء ملف PDF بنجاح",
    pdfGenerationError: "خطأ في إنشاء ملف PDF",
    summary: "الملخص",
    borderaux: "كشوف الإيداع",
    nombreBordereaux: "عدد البروديرو",
    nombreTotalCheques: "إجمالي عدد الشيكات",
    nombreCheques: "رقم الشيكات",
    montantTTC: "المبلغ شامل الضريبة",
    creationDate: "تاريخ الإنشاء",
    numberOfElements: "عدد العناصر",
    actions: "الإجراءات",
    errorLoadingBordereaux: "خطأ في تحميل سندات الإيداع",
    errorDuringDeletion: "خطأ أثناء الحذف",
    errorRetrievingBordereau: "خطأ في استرجاع سند الإيداع",
    errorGeneratingPdf: "خطأ في إنشاء PDF",
    erreurTelechargementCSV: "خطأ في تحميل ملف CSV",
  },
  choisir: {
    enseignant: "اختر مدرسًا",
    matiere: "اختر مادة",
    salle: "اختر قاعة",
    duree: "اختر المدة",
    classe: "اختر فصل",
    repas: "اختر نوع الوجبة",
    jour: "اختر أيام هذه الوجبة",
    dateDebut: "اختر تاريخ البدء",
    dateFin: "اختر تاريخ الانتهاء",
    niveauClass: "اختر المستوى دراسي الفصل",
    template: "القالب",
  },
  requis: {
    nameActivite: "اسم النشاط مطلوب",
    template: "القالب مطلوب",
    smsContenue: "محتوى الرسالة القصيرة مطلوب",
    message: "الرسالة مطلوبة",
    required: "مطلوب",
    coefficient: "الضارب مطلوب ",
    red: "اضبط التخفيض على صفر إذا كنت لا تريد إضافة التخفيض",
    activite: "النشاط مطلوب",
    cnss: "مطلوب CNSS",
    rib: "مطلوب RIB",
    specialite: "التخصص مطلوب",
    niveau: "المستوى مطلوب",
    etatCivil: "الحالة المدنية مطلوبة",
    jourSemaine: "مطلوب أيام في الأسبوع",
    tauxHoraire: "مطلوب معدل بالساعة",
    dateEntretien: "تاريخ الخدمة مطلوب",
    matiere: "المواد مطلوبة",
    typeContrat: "نوع العقد مطلوب",
    qualification: "الكفاءة مطلوبة",
    telephone: "يجب أن يتكون رقم الهاتف من 8 أرقام",
    telephoneKE: "يجب أن يحتوي الهاتف على 10 رقم",
    phoneRequired: "رقم الهاتف مطلوب",
    birthCertificate: "شهادة الميلاد مطلوبة للصف الثالث فما فوق",
    cin01: "يجب أن يتكون رقم بطاقة الهوية من 8 أرقام ويبدأ ب 0 أو 1",
    cin8: "يجب أن تتكون رقم بطاقة الهوية من 8 أرقام",
    cin: "رقم بطاقة الهوية الوطنية مطلوب",
    pourcentage: "نسبة الخصم مطلوبة",
    dinar: "المبلغ بالدينار مطلوب",
    order: "الطلب مطلوب",
    mail: "أدخل بريدك الإلكتروني!",
    mois: "الشهر مطلوب",
    mdp: "كلمة المرور مطلوبة",
    noWhitespace: "لا يمكن أن يحتوي الحقل على مسافة بيضاء",
    alphabeticOnly: "يجب أن يحتوي على أحرف أبجدية ومسافات فقط",
    confirmation: "مطلوب تأكيد كلمة المرور",
    username: " اسم المستخدم مطلوب",
    usernameEmail: " اسم المستخدم أو البريد الإلكتروني مطلوب",
    titre: "العنوان مطلوب ",
    categorie: "اختيار القسم مطلوبe",
    designation: "التعيين مطلوب",
    cible: "الهدف مطلوب",
    salaire: "الراتب مطلوب",
    role: "الدور مطلوب",
    repas: "أدخل اسم الوجبة",
    depense: "نوع المصاريف مطلوب",
    fournisseur: "المزود مطلوب",
    nom: " مطلوب اسم ",
    min: " الحد الأدنى للعلامة المطلوبة ",
    max: " الحد الأقصى للعلامة المطلوبة",
    nomPersonnel: "إسم العامل مطلوب",
    date: "التاريخ مطلوب",
    selection: "مطلوب اختيار الوالدين",
    nomPere: "مطلوب اسم الاب",
    nomMere: "اسم الأم مطلوب",
    prenom: "الاسم الأخير مطلوب",
    prenomPere: "الاسم الأول للأب مطلوب",
    prenomMere: "الاسم الأول للأم مطلوب",
    telPere: "هاتف الأب مطلوب",
    telMere: "مطلوب هاتف الأم",
    email: "بريد إلكتروني خاطئ  ",
    activite: "النشاط مطلوب ",
    carac: "4 أحرف كحد أدنى لكلمة المرور ",
    genre: "الجنس مطلوب",
    adresse: "العنوان مطلوب",
    service: "يجب اختيار الخدمة",
    fraisInscri: "مطلوب رسوم التسجيل ",
    fraisMensuel: "الرسوم الشهرية مطلوبة",
    fraisParJour: "الرسوم اليومية مطلوبة",
    ajoutLogo: "أضف شعارًا جديدًا",
    coefficient: "الضارب مطلوب",
    dateNaissance: "تاريخ الميلاد مطلوب",
    nbJours: "عدد الأيام مطلوب",
    montant: "المبلغ مطلوب ويجب أن يكون رقمًا",
    modePaiement: "طريقة الدفع مطلوبة",
    avance: " مقدما مطلوب",
    selectionEnfant: "مطلوب اختيار الطفل",
    etatPaiement: "حالة الدفع مطلوبة",
    specification: "المواصفات مطلوبة",
    observation: "المراقبة مطلوبة",
    reductionInscro: "مطلوب تخفيض رسوم التسجيل (ضع صفرًا إذا لم يكن هناك تخفيض",
    reductionMensuel:
      "مطلوب تخفيض الرسوم الشهرية (أدخل صفرًا إذا لم يكن هناك تخفيض)",
    supp: "هل انت متأكد من الحذف؟",
    supp2:
      "إذا قمت بحذف تلميذ ، فسيتم تحديث حالة الدفع الخاصة به ، وسيتم حذف جميع الأشهر غير المدفوعة. آمن للحذف؟ ",
    annu: "إذا قمت بإلغاء التسجيل ، فسيتم تحديث حالة تسجيل للعام الدراسي الحالي. هل أنت متأكد من إلغاء الاشتراك؟",
    appreciation: "الملاحظة مطلوبة",
    subject: "الموضوع مطلوب",
    grade: "الدرجة مطلوبة",
    reqcoverpicture: "صورة الغلاف مطلوبة",
    reqdescription: "الوصف مطلوب",
    reqtags: "مطلوب وسم واحد على الأقل",
  },
  phoneInput: {
    countryCodeLabel: "رمز البلد",
    countrySelectorError: "اختر البلد",
    phoneNumberLabel: "رقم الهاتف",
    example: "مثال:",
    descriptionTN: "8 أرقام (تونس)",
    descriptionKE: "10 أرقام (كينيا)",
    required: "رقم الهاتف مطلوب",
  },
  success: {
    niveauAjout: "تمت إضافة المستوى",
    niveauxCrees: "تم إنشاء المستويات",
    niveauMSA: "تم تحديث المستوى",
    niveauSupp: "تم حذف المستوى",
    studentExemptionRemoved: "تم إلغاء إعفاء الطالب بنجاح",
    appreciationOptionAjout: "تم إضافة ملاحظة جديدة",
    appreciationOptionMSA: "تم تحديث الملاحظة",
    appreciationOptionSupp: "تم حذف الملاحظة",
    certificationAjout: "تمت إضافة الشهادة",
    certificationMSA: "تم تحديث الشهادة",
    certificationSupp: "تمت إزالة الشهادة",
    modification: " modifiée avec succès",
    suppression: " supprimée avec succès",
    ajout: "ajoutée avec succès",
    decisionConseilAjout: "تم إضافة القرار",
    decisionConseilMSA: "تم تحديث القرار",
    decisionConseilSupp: "تم حذف القرار",
    decisionConseilApplied: "تم تطبيق قرار المجلس بنجاح",
    noteEnregistre: "تم حفظ العدد بنجاح",
    noteToutesEnregistre: "تم حفظ جميع الأعداد بنجاح",
    noteRemoved: "تمت إزالة العدد بنجاح",
    notesRemoved: "تمت إزالة الأعداد بنجاح",
    smsEnvoye: "تم إرسال الرسائل القصيرة بنجاح",
    modificationsEnseignantsEffectue: "تم تحديث المعلمين بنجاح",
    modificationsMatieresEffectue: "تم تحديث المواد بنجاح",
    operationEffectue: "تمت العملية بنجاح",
    cacheAjout: "تم رفع الختم بنجاح",
    cacheSupp: "تم حذف الختم بنجاح",
    inscriAjout: "تم إضافة التسجيل",
    eleveInscrit: "تم تسجيل الطلاب بنجاح",
    inscriSupp: "تم حذف التسجيل",
    inscriAnnule: "تم إلغاء التسجيل",
    pubAjout: "تمت اضافة المنشور",
    pubModif: "تم تحديث المنشور",
    pubSupp: "تم أرشفة المنشور",
    pubModif: "تم تحديث المنشور",
    photoAjout: "تمت إضافة الصورة",
    compte: "تمت إضافة نوع الحساب",
    autorisationMSA: "تم تحديث التفويض",
    autorisationSupp: "تمت إزالة الصلاحية ",
    utilisateurAjout: " تمت إضافة المستخدم",
    utilisateurMSA: "تم تغيير المستخدم",
    utilisateurSupp: " تمت أرشفة المستخدم",
    utilisateurDesac: "تم إلغاء تنشيط المستخدم ",
    utilisateurActiv: " تم تنشيط المستخدم",
    repasAjout: "تمت إضافة الوجبة",
    repasMSA: "تم تغيير الوجبة",
    repasSupp: "تم حذف الوجبة",
    depenseMSA: "تم تحديث المصاريف",
    depenseSupp: "تم أرشفة المصاريف",
    reglementSupp: "تم حذف الدفع ",
    paiementAjout: "تم إضافة الدفع",
    paiementModifie: "تم تعديل الدفع بنجاح",
    paiementSupprime: "تم حذف الدفع بنجاح",
    dossierMSA: "تم تحديث الملف",
    dossierSupp: "تم حذف الملف",
    buildingMSA: "بنجاح {name} تم تحديث المؤسسة",
    eleveAjout: "تمت إضافة التلميذ",
    eleveMSA: "تم تحديث التلميذ",
    bulletinMSA: " تم تعديل النشرة ",
    typeDepenseAjout: "تمت إضافة نوع المصاريف",
    typeDepenseModif: "تم تغيير نوع المصاريف",
    typeDepenseArchiv: "تمت أرشفة نوع المصاريف",
    fournisseurAjout: "تمت إضافة المزود",
    fournisseurMSA: "تم تعديل المزود",
    fournisseurArchiv: "تمت أرشفة المزود",
    typeRecetteMSA: "تم تغيير نوع الدخل",
    typeRecetteAjout: "تم إضافة نوع الإيرادات",
    typeRecetteArchiv: "تمت أرشفة نوع الدخل",
    activiteAjout: "تمت إضافة النشاط",
    activiteSupp: "تم أرشفة النشاط",
    activiteMSA: "تم تعديل النشاط",
    emploiMSA: "تم تعديل جدول الأوقات",
    accessRevoked: "تم إلغاء الوصول بنجاح",
    logoMSA: " تم تغيير الشعار ",
    fileUploadedPleaseSave: "تم رفع ملف {name} بنجاح ، يرجى الحفظ!",
    seanceAjout: " تمت إضافة الحصة",
    seanceMSA: "تم تعديل الحصة",
    seanceSupp: " تم أرشفة الحصة",
    punitionValid: "تم مراجعة العقوبة بنجاح",
    disciplineValid: "تم مراجعة انضباط الطالب بنجاح",
    personnelAjout: " تمت إضافة الموظف",
    personnelMSA: "تغير الموظف",
    personnelSupp: "تمت أرشفة الموظف ",
    personnelNonSupp: "لم يتم إزالة الموظف",
    enseignantAjout: "تمت إضافة المعلم",
    enseignantMSA: "تم تعديل المعلم",
    enseignantSupp: "تم حذف المعلم",
    enseignantNonSupp: "لم يتم حذف المعلم",
    classeAjout: "تمت إضافة الفصل",
    classeMSA: "تم تعديل الفصل",
    classeSupp: "تم وضع الفصل في الأرشيف",
    moduleSupp: "تم إزالة الوحدة بنجاح",
    typePunitionAjout: "تمت إضافة نوع العقوبة",
    typePunitionMSA: "تم تغيير نوع العقوبة",
    typePunitionArchiv: "تمت أرشفة نوع العقوبة",
    typeStudentDisciplineAjout: "تمت إضافة نوع انضباط الطالب",
    typeStudentDisciplineMSA: "تم تغيير نوع انضباط الطالب",
    typeStudentDisciplineArchiv: "تمت أرشفة نوع انضباط الطالب",
    typeQualificationAjout: "تم إضافة نوع الكفاءة",
    typeQualificationMSA: "تم تعديل نوع الكفاءة",
    typeQualificationArchiv: "تمت أرشفة نوع الكفاءة",
    matiereAjout: "تمت إضافة المادة",
    submoduleAdded: "تمت إضافة الوحدة الفرعيّة",
    subsubjectAdded: "تمت إضافة المادة الفرعيّة",
    matiereMSA: "تم تعديل المادة",
    matiereSupp: "تمت أرشفة المادة",
    anneeAjout: "تمت إضافة العام الدراسي",
    anneeMSA: "تم تعديل العام الدراسي",
    anneeSupp: "تم أرشفة العام الدراسي",
    serviceAjout: "تمت إضافة الخدمة ",
    serviceMSA: "تم تعديل الخدمة",
    serviceSupp: "تمت إزالة الخدمة ",
    salleAjout: "تمت إضافة القاعة",
    salleMSA: "تم تعديل القاعة",
    salleSupp: "تم وضع القاعة في الأرشيف",
    eleveAjout: "تمت إضافة التلميذ",
    eleveMSA: "تم تعديل التلميذ",
    eleveSupp: "تم وضع التلميذ في الأرشيف",
    eleveSupp2: "تم حذف التلميذ ",
    eleveRective: "تم إعادة تفعيل التلميذ",
    parentAjout: "تمت إضافة الولي",
    parentMSA: "تم تعديل الولي",
    parentSupp: "تم وضع الولي في الأرشيف",
    eleveAjoutAuClasse: "تمت إضافة التلميذ إلى الفصل بنجاح!",
    eleveDemeangeAuClasse: "تم نقل التلميذ بنجاح إلى {name}",
    InscriptionAnnulee: "تم إلغاء التسجيل بنجاح.",
    imageTelecharge: "تم تحميل ملف {name} بنجاح.",
    videoAdded: "تمت إضافة الفيديو {name} بنجاح",
    moduleOrderUpdated: "تم تحديث ترتيب الوحدة بنجاح",
    conseillerPedagogiqueAjout: "تم إضافة المستشار التربوي",
    conseillerPedagogiqueMSA: "تم تعديل المستشار التربوي",
    newsValidationSettingUpdated:
      "تم تحديث إعداد التحقق التلقائي من الأخبار بنجاح",
    conseillerPedagogiqueSupp: "تمت ارشفة المستشار التربوي",
    productUpdate: "تم تحديث المنتج بنجاح.",
    fetchCommands: "جاري جلب الأوامر...",
    commandSupp: "تم حذف الأمر بنجاح.",
    commandUpdate: "تم تحديث الأمر بنجاح.",
    prodSupp: "لقد قمت بتعطيل المنتج بنجاح.",
    prodReactivate: "تمت إعادة تفعيل المنتج بنجاح",
    libraryAddDoc: "تمت إضافة المستند",
    libraryUpdateDoc: "تم تحديث المستند",
    libraryArchiveDoc: "تمت أرشفة المستند",
    libraryReactiveDoc: "تمت إعادة تفعيل المستند",
    moduleOrderUpdated: "تم تحديث ترتيب الوحدة بنجاح",
    studentPhotoUploaded: "تم تحميل صورة التلميذ بنجاح",
    studentPhotoDeleted: "تم حذف صورة التلميذ بنجاح",
    studentExempted: "تم إعفاء الطالب بنجاح",
    sessionsUpdated: "تم تحديث {count} حصة بنجاح",
    sessionsCanceled: "تم إلغاء {count} حصة بنجاح",
    sessionsRestored: "تم استعادة {count} حصة بنجاح",
    recurringSessionsDeleted: "تم حذف {count} حصة متكررة بنجاح",
    changementEffectue: "تم تطبيق التغييرات بنجاح",
    parentMisAJour: "تم تحديث معلومات الوالدين",
    groupUpdated: "تم تحديث المجموعة",
    studentRemovedFromGroup: "تم إزالة الطالب من المجموعة",
    submoduleAdded: "تمت إضافة الوحدة الفرعية",
    excelGenerated: "تم إنشاء ملف Excel بنجاح.",
  },
  error: {
    dateFinPlusGrande: "تاريخ النهاية يجب أن يكون أكبر من تاريخ البداية",
    oops: "عذراً! حدث خطأ",
    impoAjoutAppreciationOption: "غير قادر على إضافة ملاحظة",
    fetchError: "خطأ في تحميل البيانات",
    fetchingStudents: "خطأ في جلب قائمة التلاميذ",
    impoEnregistrerVide: "لا يمكن حفظ قيمة فارغة",
    invalidNote: "درجة غير صالحة !. يجب أن يكون بين 0 و 20",
    smsFormat: "تنسيق غير صالح ، يجب فصل أرقام الهواتف بفاصلات!",
    noPhoneNumber: "لا يوجد رقم هاتف",
    invalid: "غير صالح",
    notEnrolled: "غير مسجل",
    noStudentFound: "لم يتم العثور على أي تلميذ",
    noClassFound: "لا توجد أي فصول للمستوى المختار",
    phoneNumberExists: "رقم الهاتف موجود بالفعل في النظام",
    eleveDejaInscritPourMois: "التلميذ مسجل بالفعل بالأشهر المحددة",
    impoModifiEleve: "تعذر تحديث التلميذ",
    impoModifi: "تعذر تحديث ",
    eleveNonAjoutAuClasse:
      "التسجيل لم يتم إضافته برجاء الغاء التسجيل ثم تخصيص فصل جديد للتلميذ!",
    InscriptionNonModifi:
      "التسجيل لم يتم تعديله برجاء الغاء التسجيل ثم تخصيص فصل جديد للتلميذ!",
    matiereNonAffecte: "يجب إختيار مادة واحدة على الأقل!",
    matiereNonAffecte: "يجب ملئ كل المواد مع الضوارب الخاصة بها",
    subsubjectNonAffecte:
      "{subject} : يجب ملئ جميع المواد الفرعيّة مع الأعداد الخاصة بها ",
    capacite: "- سعة القاعة أقل من عدد الطلاب",
    fichiers: "يمكنك فقط تحميل ملفات JPG أو JPEG أو PNG!",
    fileTooLarge: "يجب أن يكون حجم الملف أقل من 5 ميجابايت",
    fichiersPNG: "يمكنك فقط تحميل ملفات PNG!",
    fichiersPDFWord:
      "يمكنك فقط تحميل ملفات JPG, JPEG, PNG, PDF, Word (.doc, .docx)!",
    fileTypeNotAllowed:
      "يُسمح فقط بالصور وملفات PDF وملفات Office (Word و Excel و PowerPoint) ومقاطع الفيديو (MP4 و WebM)",
    onlyPDFAllowed: "يمكنك فقط تحميل ملفات PDF!",
    onlyImagesAndPDFAllowed:
      "يمكنك فقط تحميل صور (JPEG, PNG, WebP) أو ملفات PDF!",
    onlyImagesPDFWordExcel:
      "يُسمح فقط بتحميل صور (JPEG, PNG, WebP) أو PDF أو Word أو Excel!",
    onlyAudioFilesAllowed: "يُسمح فقط بملفات صوتية (مثل MP3، WAV، M4A).",
    allowedFileTypes: "أنواع الملفات المسموح بها فقط: {types}",
    allowedImageTypes: "أنواع الصور المسموح بها فقط: {types}",
    classe: "الفصل غير موجود",
    activite: "النشاط غير موجود",
    service: "الخدمة غير موجودة",
    inscription: "تسجيل ",
    aucScol: "لم يتم العثور على تسجيل الرسوم الدراسية",
    aucClasse: "لم يتم العثور على الفصل",
    aucEleve: "لم يتم العثور على أي تلميذ",
    aucInscri: "لم يتم العثور على تسجيل للنشاط",
    aucPersonnel: "لم يتم العثور على موظفين",
    aucService: "لا توجد خدمة",
    aucActivite: "لم يتم العثور على أي نشاط",
    aucActualite: "لم يتم العثور على أخبار",
    aucRole: "لم يتم العثور على دور",
    aucEtablissement: "لم يتم العثور على مؤسسة",
    aucRecette: "لم يتم العثور على نوع الدخل",
    aucMatiere: "لم يتم العثور على أي مادة",
    aucSubsubject: "لم يتم العثور على أي مادة فرعية",
    aucUser: "لم يتم العثور على المستخدم",
    aucFournisseur: "لم يتم العثور على مورد",
    aucDepense: "لا توجد نفقات",
    aucQualification: "لم يتم العثور على نوع مؤهل",
    aucEnseignant: "لم يتم العثور على مدرس ",
    aucAnnee: "لم يتم العثور على العام الدراسي",
    aucSalle: "لم يتم العثور على القاعة",
    aucModule: "لم يتم العثور على الوحدات",
    aucSubsubject: "لم يتم العثور على المادة الفرعيّة",
    verifier: "تحقق من كلمات المرور",
    modif: "خطأ في التحديث",
    ajout: "خطأ في الإضافة",
    supp: "خطأ في الحذف أو الأرشفة",
    impoInscriSupp: "غير قادر على حذف هذه القائمة",
    impoPubAjout: "غير قادر على إضافة آخرn",
    impoPubModif: "غير قادر على تعديل آخرn",
    impoPubSupp: "غير قادر على حذف آخر",
    impoPubModif: "غير قادر على تحديث آخر",
    impoAjoutType: "غير قادر على إضافة هذا النوع",
    impoAjoutActivite: "غير قادر على إضافة النشاط",
    impoAjoutAnnee: "غير قادر على إضافة السنة الدراسية",
    impoAjoutClasse: "غير قادر على إضافة الفصل الدراسي",
    impoAjoutSalle: "غير قادر على إضافة القاعة",
    impoAjoutService: "غير قادر على إضافة الخدمة",
    impoAjoutFournisseur: "غير قادر على إضافة المزود",
    impoAjoutCeType: "غير قادر على إضافة هذ النوع",
    impoModifiMatieres: "غير قادر على تعديل المواد",
    impoModifiEnseignants: "غير قادر على تعديل المعلمين",
    image: "يجب أن تكون الصورة أقل من 5 ميغا بايت",
    image50: "يجب أن تكون الصور أقل من 50 ميغا بايت",
    maxImage: "الحد الأقصى لعدد الصور هو 15",
    maxFiles: "الحد الأقصى لعدد الملفات هو 15",
    videoFormat: "يُسمح فقط بصيغ الفيديو MP4 و MOV و AVI و MKV و WebM",
    maxVideos: "الحد الأقصى 5 فيديوهات مسموح بها",
    videoSize: "يجب أن يكون حجم الفيديو أقل من 500 ميجابايت",
    nonAjoute: "غير مضاف",
    autorisationNonMSA: "لم يتم تحديث التفويض",
    autorisationNonSupp: "لم تتم إزالة الصلاحية",
    eleveNonMSA: "لم يتم تحديث التلميذ",
    impoTelecharger: " تعذر تنزيل الصورة",
    dossier: "تعذر العثور على سجل التلميذ",
    dossierNonMSA: " لم يتم تحديث الملف",
    nonValid: "لا يمكنك التحقق من صحة دفع مبلغ يساوي صفر",
    recetteNonAjoute: "الدخل غير مضاف",
    recetteNonMSA: "لم يتم تحديث الدخل",
    recetteNonSupp: "لم يتم حذف الدخل",
    qualificationNonAjoute: "التأهيل غير مضاف",
    qualificationNonMSA: "لم يتم تحديث التأهيل",
    qualificationNonSupp: "لم تتم إزالة التأهيل",
    serviceNonSupp: "لم يتم حذف الخدمة",
    erreur: "حدث خطأ",
    selectionnerDates: "يرجى تحديد الفصل والفترة",
    dateDebutApresFin: "يجب أن يكون تاريخ البداية قبل تاريخ النهاية",
    erreurRecuperationSeances: "خطأ في استرجاع الجلسات",
    erreurRecuperationAssiduite: "خطأ في استرجاع بيانات الحضور",
    erreurGenerationPdf: "خطأ في إنشاء PDF",
    depenseNonMSA: "لم يتم تحديث المصاريف",
    depenseNonSupp: "لم يتم حذف المصاريف",
    buildingEchoue: "{name} فشل تحديث المؤسسة",
    inscriEchoue: "فشل التسجيل",
    personnelNonAjoute: "الموظف غير مضاف ",
    personnelNonMSA: "لم يتم تحديث الموظف",
    enseignantNonAjoute: "لم تتم إضافة المعلم",
    enseignantNonMSA: "لم يتم تحديث المعلم",
    listeNonTrouve: "قائمة التلاميذ غير متوفرة!",
    anneeNonAjoute: "السنة الدراسية غير مضافة",
    anneeNonMSA: "لم يتم تحديث السنة الدراسية",
    punitionNonAjoute: "العقوبة غير مضافة",
    punitionNonMSA: "لم يتم تحديث العقوبة",
    serviceNonAjoute: "الخدمة غير مضافة",
    serviceNonMSA: "لم يتم تحديث الخدمة",
    depenseNonAjoute: "المصاريف غير مضافة ",
    depenseNonMSA: "لم يتم تحديث المصاريف",
    fournisseurNonAjoute: "المزود غير مضاف",
    fournisseurNonMSA: "لم يتم تحديث المزود",
    fournisseurNonSupp: "لم يتم حذف المزود",
    activiteNonMSA: "لم يتم تعديل النشاط، يرجى إعادة المحاولة",
    moduleNonAjoute: "لم يتم إضافة الوحدة",
    moduleNonMSA: "لم يتم تحديث الوحدة",
    moduleNonSupp: "لم يتم حذف الوحدة",
    personnelNonMSA: "لم يتم تحديث الموظف",
    matiereNonAjoute: "المادة غير مضافة",
    subModuleNonAjoute: "الوحدة الفرعيّة غير مضافة",
    subsubjectNonAjoute: "المادة الفرعيّة غير مضافة",
    matiereNonMSA: "لم يتم تحديث المادة",
    listeNonTrouve: "قائمة التلاميذ غير متوفرة!",
    inscrEchoue: "فشل التسجيل",
    anneeNonSupp: "لا يمكن حذف السنة الدراسية",
    classeNonSupp: "لا يمكن حذف الفصل",
    classeIndis: "الفصل غير متوفر",
    salleIndis: "القاعة غير متوفرة",
    enseignantIndis: "المعلم غير متوفر",
    selectEnseignant: "اختر مدرسًا",
    selectSeance: "إختر الحصة",
    teacherConflictFuture:
      "المعلم {teacherName} مُجدول بالفعل لنفس الوقت ويوم الأسبوع في المستقبل",
    classConflictFuture:
      "الفصل {className} مُجدول بالفعل لنفس الوقت ويوم الأسبوع في المستقبل",
    teacherConflictUpdate: "المعلم {teacherName} مشغول في هذا الوقت",
    classConflictUpdate: "الفصل {className} مشغول في هذا الوقت",
    conflictDetails: "تفاصيل التعارض",
    conflictingTeacher: "المعلم المتعارض",
    conflictingClass: "الفصل المتعارض",
    conflictTime: "الوقت",
    conflictDate: "التاريخ",
    conflictGroup: "المجموعة",
    conflictWeek: "الأسبوع",
    conflictEndTime: "وقت الانتهاء",
    classroomGroupConflict: "تم اكتشاف تعارض مجموعة الفصل",
    classroomGroupConflictDesc:
      "لا يمكن جدولة مجموعات مختلفة في نفس الوقت لنفس الفصل",
    classroomMixedConflict: "تم اكتشاف تعارض مجموعة مختلطة للفصل",
    classroomMixedConflictDesc:
      "لا يمكن خلط جلسات المجموعة والعادية لنفس الفصل في نفس الوقت",
    teacherGroupConflict: "تم اكتشاف تعارض مجموعة المعلم",
    teacherGroupConflictDesc:
      "لا يمكن للمعلم تدريس مجموعات مختلفة في نفس الوقت",
    teacherMixedConflict: "تم اكتشاف تعارض مجموعة مختلطة للمعلم",
    teacherMixedConflictDesc:
      "لا يمكن خلط جلسات المجموعة والعادية لنفس المعلم في نفس الوقت",
    selectClasse: "حدد فصل المدرسة",
    sallePriseEntre:
      "الغرفة {room} محجوزة لدى {name} ما بين الساعة {start} إلى {end}",
    classPriseEntre: "تم حجز القسم {name} بين {start} و {end}",
    enseignantEnseigneClasse:
      "المعلم {fullname} يعلم الفصل {name} المادة {subject} بين {start} و {end}",
    conflictingSessionInfo:
      "يتعارض مع: {subject} — {teacher} — {className} — {date} {start}-{end}{extra}",
    activiteNonSupp: "لا يمكن حذف النشاط ",
    utilisateurNonAjoutDiff:
      "لم تتم إضافة المستخدم ، يرجى المحاولة بإسم مستخدم مختلف!",
    conseillerPedagogiqueNonAjoute: "لم يتم إضافة المستشار التربويé",
    conseillerPedagogiqueNonMSA: "لم يتم تحديث المستشار التروبي",
    conseillerPedagogiqueNonSupp: "لم يتم حذف المستشار التربوي",
    invalidFormat: "تنسيق الملف غير مقبول",
    maxStudentsReached:
      "تم الوصول إلى الحد الأقصى لعدد الطلاب. يرجى ترقية اشتراكك لإضافة المزيد من الطلاب.",
    maxUsersReached:
      "تم الوصول إلى الحد الأقصى لعدد المستخدمين. يرجى ترقية اشتراكك لإضافة المزيد من المستخدمين.",
    productUpdate: "فشل في تحديث المنتج. يرجى المحاولة مرة أخرى.",
    autorisationSupp: "لست مخولاً بحذف هذا الأمر.",
    prodReactivate: "فشل في إعادة تفعيل المنتج",
    libraryAddDoc: "لم تتم إضافة المستند",
    libraryUpdateDoc: "لم يتم تحديث المستند",
    libraryArchiveDoc: "لم تتم أرشفة المستند",
    libraryReactiveDoc: "لم تتم إعادة تفعيل المستند",
    failedToUpdateModuleOrder: "فشل تحديث ترتيب الوحدة. يرجى المحاولة مرة أخرى",
    alreadyAssigned: "مرتبط بالفعل بـ",
    studentPhotoUploadError: "فشل في تحميل صورة التلميذ",
    studentPhotoDeleteError: "فشل في حذف صورة التلميذ",
    fileUploadError: "خطأ في تحميل الملف. يرجى المحاولة مرة أخرى.",
    fetchingData: "فشل في جلب البيانات. يرجى المحاولة مرة أخرى.",
    usernameExists: "اسم المستخدم غير متوفر ",
    noDataToUpdate: "لا توجد بيانات للتحديث",
    updateSessions: "خطأ في تحديث الحصص",
    deleteRecurringSessions: "خطأ في حذف الحصص المتكررة",
    activiteHasPayments:
      "لا يمكن تغيير العام الدراسي لأن النشاط يتضمن التسجيل خلال العام الدراسي الحالي.",
    failedToLoadFinancialStats: "فشل تحميل الإحصائيات المالية",
    failedToLoadAnalytics: "فشل تحميل تحليل {tab}",
    errorLoadingSchoolYears: "خطأ في تحميل السنوات الدراسية",
    classNotFound: "الفصل غير موجود!",
    studentListNotFound: "قائمة الطلاب غير موجودة",
    unexpectedError: "حدث خطأ غير متوقع.",
    groupUpdateFailed: "خطأ في تحديث المجموعة",
    allSubModuleNeedToBeSelected: "اختر جميع الوحدات الفرعية",
    noSubMoudoleIsfound: "لم يتم العثور على وحدة فرعية",
    aucCert: "لم يتم العثور على أي شهادة",
    impoAjoutCertification: "تعذرت إضافة الشهادة",
    subModuleNonAjoute: "لم تتم إضافة الوحدة الفرعية",
    teacherWeekConflict:
      "تعارض المعلم: لا يمكن جدولة أسابيع مختلفة في نفس الوقت",
    classroomWeekConflict:
      "تعارض القاعة: لا يمكن جدولة أسابيع مختلفة في نفس الوقت",
    teacherWeekConflictDesc:
      "المعلم مجدول بالفعل لأسبوع مختلف (A/B) في هذا الوقت. لا يمكن تعيين المعلمين لأسابيع متعددة في وقت واحد.",
    classroomWeekConflictDesc:
      "القاعة مجدولة بالفعل لأسبوع مختلف (A/B) في هذا الوقت. يمكن للأسابيع المختلفة استخدام نفس القاعة.",
    deleteSession: "خطأ في حذف الحصة",
  },
  warning: {
    verifieDonnees: "تحقق من البيانات",
    connectionProblem: "مشكلة في الاتصال ، يرجى تحديث الصفحة!",
    selectModePaiement: "اختار طريقة الدفع",
    paiementNonEffectuer: "لم يتم الدفع",
    invalidMarks: "يرجى التأكد من أن اعدادك بين 0 و 20",
    notCorrectMarks: "يرجى التأكد من إدخال اعدادك بشكل صحيح.",
    missedSubsubjects:
      "يبدو أنه لم يتم إكمال جميع الاعداد ({name}). يرجى إدخال جميع الاعداد المفقودة.",
  },
  stats: {
    userStats: "إحصائيات المستخدمين",
    connectedStats: "المستخدمون المتصلون",
    connects: "اتصال",
    connect: "اتصال",
    disconnect: "انقطاع الاتصال",
    seen: " تم رؤيته",
    published: " تم نشره",
    mainStats: "عدد المستخدمين المتصلين حسب التاريخ",
    nb_connections: "عدد الاتصالات",
    connection_duration: "عدد الاتصالات",
    mainStatSelected: "مدة الاتصال (بالساعات) لـ {name} حسب التاريخ",
    secondaryStatsteacher: "نشر الدورات/التمارين يوميا",
    secondaryStatsparent: "رأية الدورات/التمارين يوميا",
    secondaryStatSelectedteacher: "نشر الدورة/التمرين بواسطة {name} يوميًا",
    secondaryStatSelectedparent:
      "عدد الدورات/التمارين التي شاهدها {الاسم} يوميًا",
    detailedStats: "تفاصيل الاتصال",
    detailedStatSelected: "تفاصيل الاتصال لـ {name}",
    lastConnection: "آخر اتصال",
    duration: "مدة الاتصال",
    neverLoggedIn: "لم يتم تسجيل الدخول",
    hasLoggedIn: "تم تسجيل الدخول",
    noConnectionHistory: "لا يوجد سجل اتصال",
    fullName: "الاسم الكامل",
    childName: "اسم الطفل",
  },
  bulletinBuilder: {
    contradictoryWith: "هذا الخيار متعارض مع {option}",
    subjectsOptions: "خيارات المواد/المواد الفرعية",
    modulesOptions: "خيارات المجالات/المجالات الفرعية",
    otherOptions: "خيارات أخرى",
    hideSubjectMark: "إخفاء المعدلات المواد/المواد الفرعية",
    hideModuleMark: "إخفاء المعدلات المجالات/المجالات الفرعية",
    additionalImages: "صور إضافية",
    customGovLogo: "تخصيص شعار الوزارة",
    showSubmodule: "إظهار اسم المجالات الفرعية",
    showSubmoduleMoy: "إظهار معدل المجالات الفرعية",
    noStampFound: "لم يتم العثور على العلامة",
    errorPrintingBulletin: "حدث خطأ أثناء طباعة النشرة",
    errorGettingBulletinData: "حدث خطأ أثناء الحصول على بيانات النشرة",
    selectStudentFirst: "يرجى اختيار طالب أولاً",
    scaleImagesTooltip:
      "هذه الخيارات تسمح لك بتغيير حجم الصور في النشرة، استخدمها بحذر.",
    certifUsePersonalizedMoy: "شهادة بمعدل مخصص",
    scaleImages: "تحجيم الصور",
    hideSubModuleMark: "إخفاء معدّل ​​المجالات الفرعية",
    certif: "الشهادة",
    adminAppreciation: "ملاحظات الإدارة",
    pedaLike: "تقريب المستطيلات",
    onlyForForceOnePage: "مفيد لإجبار صفحة واحدة أو تمديدها إلى صفحة كاملة",
    textuelle: "العناصر النصية",
    images: "الصور",
    couleurs: "الألوان",
    taillesPolice: "أحجام الخطوط",
    optionsAvancees: "خيارات متقدمة",
    enTete: "الرأس",
    corps: "الجسم",
    cote: "الجانب",
    espacement: "المسافات",
    arrierePlanQR: "الخلفية والرمز QR",
    schoolName: "اسم المدرسة",
    schoolarYear: "السنة الدراسية",
    className: "اسم الفصل",
    studentName: "اسم الطالب",
    birthDate: "تاريخ الميلاد",
    nbInscription: "رقم التسجيل",
    uniqueIden: "المعرف الفريد",
    schoolLogo: "شعار المدرسة",
    studentImage: "صورة الطالب",
    govLogo: "شعار الوزارة",
    subsubjectMark: "علامة المادة الفرعية",
    subjectMark: "علامة المادة",
    moduleMark: "علامة الوحدة",
    appreciation: "التقدير",
    minPerClass: "الحد الأدنى للفصل",
    maxPerClass: "الحد الأقصى للفصل",
    normal: "المعدل العام",
    peda: "المعدل التربوي",
    personalized: "المعدل المخصص",
    afficherNomEcole: "إظهار اسم المدرسة",
    afficherAnneeScolaire: "إظهار السنة الدراسية",
    afficherNomClasse: "إظهار اسم الفصل",
    afficherTextMinistere: "إظهار نص الوزارة",
    afficherNomEleve: "إظهار اسم الطالب",
    afficherDateNaissance: "إظهار تاريخ الميلاد",
    afficherNbInscription: "إظهار رقم التسجيل",
    afficherIdentifiantUnique: "إظهار المعرف الفريد",
    enteteTrimestre: "رأس الفصل الدراسي",
    afficherLogoEcole: "إظهار شعار المدرسة",
    afficherImageEleve: "إظهار صورة الطالب",
    afficherLogoMinistere: "إظهار شعار الوزارة",
    personnaliserCouleurs: "تخصيص الألوان",
    paletteCouleurs: "لوحة الألوان",
    noteSousMatiere: "علامة المادة الفرعية",
    noteMatiere: "علامة المادة",
    noteModule: "علامة الوحدة",
    appreciation: "التقدير",
    minParClasse: "الحد الأدنى للفصل",
    maxParClasse: "الحد الأقصى للفصل",
    fusionnerSousMatieres: "دمج المواد الفرعية",
    masquerMatieres: "إخفاء المواد",
    masquerMinParMatiere: "إخفاء الحد الأدنى للمادة",
    masquerMaxParMatiere: "إخفاء الحد الأقصى للمادة",
    pasEncoreDisponible: "هذه الميزة غير متوفرة بعد",
    forcerUnePage: "إجبار صفحة واحدة",
    etirerPageEntiere: "تمديد الصفحة كاملة",
    margeGauche: "الهامش الأيسر",
    trimersterLineMargin: "هامش الرأس",
    slowingFactor: "قد يؤدي هذا الخيار إلى إبطاء إنشاء ملفات PDF",
    margeInferieure: "الهامش السفلي",
    ajouterQRCode: "إضافة رمز QR",
    ajouterArrierePlan: "إضافة خلفية",
    cliquezGlisser: "انقر أو اسحب وأفلت الملف",
    supportImageUnique: "يدعم الصور فقط",
    apercuBulletin: "معاينة الشهادة",
    selectionnerEleve: "اختر الطالب",
    selectionnerTemplate: "اختر القالب",
    actualiser: "تحديث",
    selectionnerEleveDabord: "الرجاء اختيار طالب أولاً",
    visualiserBulletin: "عرض الشهادة",
    configurer: "تكوين",
    titre: "العنوان",
    valeur: "القيمة",
    position: "الموضع",
    centre: "الوسط",
    gauche: "اليسار",
    droit: "اليمين",
    bas: "الأسفل",
    ordre: "الترتيب",
    changerPositions: "تغيير المواضع",
    optionsAffichage: "خيارات العرض",
    afficherMinimum: "إظهار الحد الأدنى",
    afficherMaximum: "إظهار الحد الأقصى",
    afficherRang: "إظهار الرتبة",
    recommandeActiver: "يوصى بتفعيل 2 فقط من 3 متوسطات كحد أقصى.",
    couleurMoyenne: "لون المعدل",
    couleurRang: "لون الرتبة",
    couleurMin: "لون الحد الأدنى",
    couleurMax: "لون الحد الأقصى",
    legende: "الوسيط",
    libelle: "التسمية",
    coefficientMoyenne: "معامل المعدل",
    coefficientMoyennePedagogique: "معامل المعدل التربوي",
    sensitiveOption: "هذه الخيارات حساسة، استخدمها بحذر.",
    modifierCouleurs: "تعديل الألوان",
    couleurPrincipale: "اللون الرئيسي",
    enteteTrimestreTitres: "رأس الفصل والعناوين",
    bordureCouleurPrincipale: "حدود اللون الرئيسي",
    couleurSecondaire: "اللون الثانوي",
    titresMoyennes: "عناوين المعدلات",
    bordureCouleurSecondaire: "حدود اللون الثانوي",
    couleurTertiaire: "اللون الثالث",
    arrierePlanMinMaxRang: "خلفية الحد الأدنى/الأقصى/الرتبة",
    bordureCouleurTertiaire: "حدود اللون الثالث",
    configurerPolice: "تكوين الخط",
    taille: "الحجم",
    couleur: "اللون",
    font: "الخط",
    lineReturn: "العودة إلى السطر بعد العنوان",
    nonDisponiblePourEnTeteBas: "غير متوفر للعناوين السفلية",
    veuillezVerifierChamps: "يرجى التحقق من الحقول",
    afficherMoyenne: "إظهار المعدل",
    afficherMoyennePedagogique: "إظهار المعدل التربوي",
    afficherMoyennePersonnalise: "إظهار المعدل المخصص",
    afficherCertif: "إظهار الشهادة",
    afficherCache: "إظهار الختم",
    afficherDate: "إظهار التاريخ",
    selectFont: "اختر خط",
    positionX: "الموضع X",
    parametresEnregistres: "تم حفظ الإعدادات",
    parametresNonEnregistres: "لم يتم حفظ الإعدادات",
    checkInputs: "يرجى التحقق من المدخلات",
    positionUsedBy: "هذا الموضع مستخدم من قبل",
    restaureParametres: "تمت استعادة الإعدادات الافتراضية",
    modeleSelectionne: "تم اختيار القالب",
    arabicAndFrench: "العربية والفرنسية",
    arabicOnly: "العربية فقط",
    selectionnerElevePourVisualiser: "اختر تلميذًا لعرض النشرة",
    parametresEnregistresAvecSucces: "تم حفظ الإعدادات بنجاح",
  },
  teacherGradePermissions: {
    title: "صلاحيات درجات المعلم",
    subTitle: "التحكم في إمكانية تعديل المعلمين لدرجات الطلاب بعد التقديم",
    gradeEditingEnabled: "تم تفعيل تعديل الدرجات",
    gradeEditingDisabled: "تم تعطيل تعديل الدرجات",
    selectTeachers: "اختر المعلمين",
    allTeachers: "كل المعلمين",
    specificTeachers: "معلمين محددين",
    permissionSaved: "تم حفظ صلاحيات الدرجات بنجاح",
    chooseTrimester: "اختر الثلاثي",
    gradeEditing: "تعديل الدرجات",
    teacherAccessMode: "منح الوصول إلى",
    canEdit: "يمكن تعديل الدرجات",
    searchTeachers: "البحث عن طريق اسم المعلم",
    filterAccess: "تصفية حسب وصول المعلم",
    withAccess: "المعلمون الذين لديهم حق الوصول",
    withoutAccess: "المعلمون الذين ليس لديهم حق الوصول",
    selectTeachersError:
      "الرجاء اختيار معلم واحد على الأقل عندما يكون وضع 'معلمين محددين' مفعلاً.",
  },
  aiFeedback: {
    title: "تقييم الذكاء الاصطناعي",
    lastUpdated: "آخر تحديث",
    summary: "الملخص",
    strengths: "نقاط القوة",
    weaknesses: "نقاط الضعف",
    recommendations: "التوصيات",
    generalAppreciation: "التقدير العام",
    noFeedback: "لا يوجد تقييم متاح",
    generateReport: "توليد تقرير باستخدام الذكاء الاصطناعي",
    initiatedMessage: "تحليل الذكاء الاصطناعي قيد التنفيذ",
    initiatedDescription: "نحن نحلل أداء الطالب. قد يستغرق هذا بضع ثوانٍ.",
    information: "تفاصيل التقرير",
    generatedByAI: "تم توليده بواسطة الذكاء الاصطناعي",
    generatedAt: "تم توليده في",
    pdfGenerationError: "خطأ في توليد التقرير",
    pdfGeneratedSuccessfully: "تم توليد التقرير بنجاح",
  },
  invoice: {
    addressedTo: " موجه إلى ",
    editAddressedTo: "تعديل الموجه إليه",
    type: "النوع",
    selectType: "اختر النوع",
    particular: "فرد",
    entreprise: "شركة",
    MF: "الرقم الضريبي",
    representative: "الممثل",
    enterMF: "أدخل الرقم الضريبي",
    selectRepresentative: "اختر الممثل",
    father: "الأب",
    mother: "الأم",
    other: "آخر",
    addressedToName: "الاسم",
    enterName: "أدخل الاسم",
    typeRequired: "النوع مطلوب",
    nameRequired: "الاسم مطلوب",
    representativeRequired: "الممثل مطلوب",
    MFRequired: "الرقم الضريبي مطلوب",
    selectAddressedTo: "اختر المرسل إليه",
    loadingParentsInfo: "جاري تحميل معلومات الوالدين...",
    selectParent: "اختر ولي أمر",
    multipleParentsFound: "تم العثور على عدة أولياء أمور",
    parentFound: "تم العثور على ولي أمر",
    selectParentForDocument: "يرجى اختيار ولي الأمر لمعالجة المستند",
    documentAddressedTo: "المستند موجه إلى",
    noParentFound: "لم يتم العثور على ولي أمر",
    fatherLabel: "الأب",
    motherLabel: "الأم",
    parentMissingInfo: "ولي أمر (معلومات مفقودة)",
    errorLoadingParents: "خطأ في تحميل أولياء الأمور",
    facture: "فاتورة",
    factureAvoir: "فاتورة - إشعار دائن",
    recu: "إيصال",
    recuAvoir: "إيصال - إشعار دائن",
    nomPrenomEleve: "الاسم واللقب (الطالب)",
    designation: "التعيين",
    frais: "الرسوم",
    quantite: "الكمية",
    prixUnitaireHT: "سعر الوحدة بدون ضريبة",
    montantHT: "المبلغ بدون ضريبة",
    montantTTC: "المبلغ شامل الضريبة",
    qte: "الكمية",
    prixUnitaire: "سعر الوحدة",
    total: "المجموع",
    totalHTBrut: "المجموع الإجمالي بدون ضريبة",
    remise: "الخصم",
    totalHT: "المجموع بدون ضريبة",
    totalTVA: "مجموع ضريبة القيمة المضافة",
    timbre: "الطابع",
    retenueALaSource: "الخصم من المصدر",
    netAPayer: "الصافي للدفع",
    reste: "المتبقي",
    adresseeA: "موجهة إلى:",
    cachetSignature: "الختم والتوقيع",
    arreteePresenteFacture: "توقف هذه الفاتورة على مبلغ:",
    dinarsEt: "دينار و",
    millimes: "مليم",
    ecolePrimairePrivee: "مدرسة ابتدائية خاصة",
    page: "صفحة",
    mf: "م.ف",
    tel: "هاتف",
    mail: "بريد إلكتروني",
    numeroLabel: "الرقم:",
    dateLabel: "التاريخ:",
    avanceLabel: " ( سلفة )",
    signature: "التوقيع",
    paymentMethods: "وسائل الدفع",
    tuitionSummary: "ملخص دفع الدراسة",
    activitySummary: "ملخص دفع الأنشطة",
    summaryTotalToPay: "المجموع الواجب دفعه",
    summaryDebitPaid: "مدين – مدفوع",
    summaryCreditUnpaid: "دائن – غير مدفوع",
    summaryTotalPaid: "مجموع المدفوع",
    summaryTotalUnpaid: "مجموع غير المدفوع",
    summaryPartial: "جزئي",
    chequeDetail: "شيك",
    transactionCode: "رمز المعاملة",
    pmNumber: "رقم",
    pmReference: "المرجع",
    pmHolder: "صاحب الحساب",
    pmBank: "البنك",
    pmRib: "RIB",
    pmDueDate: "تاريخ الاستحقاق",
    pmDate: "التاريخ",
    baseReduction: "التخفيض الأساسي",
    baseReductionShort: "تخفيض",
    baseReductionTotal: "مجموع التخفيضات الأساسية",
    schoolCopy: "نسخة المؤسسة",
  },
  promotion: {
    button: "الترقية التلقائية",
    title: "الترقية التلقائية للتلاميذ",
    subtitle: "ترقية التلاميذ إلى السنة الدراسية التالية حسب مستواهم.",
    back: "رجوع",
    fromYear: "السنة المصدر",
    toYear: "السنة الهدف",
    noNextYearShort: "لا توجد سنة تالية",
    noNextYearTitle: "لا توجد سنة دراسية تالية",
    noNextYearDesc: "أنشئ السنة الدراسية التالية أولاً لبدء الترقية.",
    missingTitle: "فصول افتراضية مفقودة",
    missingDesc:
      "أنشئ المستويات التالية (فصول التعيين) للسنة الهدف قبل بدء الترقية:",
    doneTitle: "تمت الترقية",
    promoted: "تمت ترقيتهم",
    kept: "المحتفظ بهم (المعيدون)",
    archived: "المؤرشفون",
    skipped: "تم تجاهلهم (موزعون مسبقًا)",
    noStudents: "لا يوجد تلاميذ للترقية.",
    toPromote: "للترقية",
    toKeep: "للاحتفاظ",
    toArchive: "للأرشفة",
    students: "تلميذ",
    endOfCycle: "نهاية المرحلة",
    keptShort: "محتفظ بهم",
    archivedShort: "مؤرشفون",
    terminalHint:
      "سيتم أرشفة هؤلاء التلاميذ. حدد المعيدين للاحتفاظ بهم في السنة الدراسية الجديدة.",
    terminalHintNoKeep:
      "سيتم أرشفة هؤلاء التلاميذ (لا يوجد فصل تعيين بنفس المستوى للاحتفاظ بهم).",
    alreadyPlaced: "موزع مسبقًا",
    confirmText: "تأكيد ترقية التلاميذ إلى السنة التالية؟",
    confirmOk: "تأكيد",
    execute: "بدء الترقية",
    notReady: "صحّح المتطلبات قبل بدء الترقية.",
  },
  inscriptionStats: {
    tabNormal: "الفصول",
    tabAffectation: "التعيينات",
    tabIndicators: "المؤشرات",
    total: "إجمالي عدد التلاميذ",
    enrolled: "التلاميذ المسجلون",
    affected: "التلاميذ المعينون",
    unplaced: "التلاميذ غير الموزعين",
    repartition: "توزيع التلاميذ",
    effectifParClasse: "عدد التلاميذ لكل فصل",
    parNiveau: "الأعداد حسب المستوى",
    bandAffectation: "تعيين (مستوى)",
    bandNormal: "الفصول",
    eleves: "تلميذ",
    moyenne: "المعدل",
    imbalance: "عدم توازن الأعداد",
    imbalanceTag: "غير متوازن",
    imbalanceHint:
      "يتم تمييز المستوى عندما يكون الفارق كبيرًا بين الفصل الأكثر امتلاءً والأقل. الأحمر = الأكثر امتلاءً، البرتقالي = الأقل.",
    aucuneDonnee: "لا توجد بيانات متاحة",
    loadError: "تعذر تحميل المؤشرات",
  },
  errorCode: {
    LEVEL_REQUIRED_FIRST:
      "يجب إنشاء هذا المستوى في علامة التبويب المستويات قبل إضافة فصل.",
    LEVEL_ALREADY_EXISTS: "هذا المستوى موجود بالفعل لهذه السنة الدراسية.",
    LEVEL_HAS_PAYMENTS:
      "لا يمكن حذف هذا المستوى لأن هناك مدفوعات مرتبطة به.",
    LEVEL_HAS_STUDENTS:
      "لا يمكن حذف هذا المستوى لأن هناك تلاميذ ما زالوا معيّنين إليه.",
    EXACTLY_ONE_OWNER_REQUIRED: "يجب أن يكون هناك مالك واحد فقط للصندوق.",
    AT_LEAST_ONE_OWNER_REQUIRED: "يجب أن يكون للصندوق مالك واحد على الأقل.",
    DUPLICATE_CAISSE_USER: "لا يمكن إدراج المستخدم أكثر من مرة في الصندوق.",
    CAISSE_REFERENCE_ALREADY_EXISTS: "هناك صندوق يستخدم هذا المرجع بالفعل.",
    PRINCIPAL_CAISSE_ALREADY_EXISTS:
      "يوجد صندوق رئيسي بالفعل. يُسمح بصندوق رئيسي واحد فقط.",
    CAISSE_SELECTION_REQUIRED:
      "لديك حق الوصول إلى عدة صناديق، اختر الصندوق المطلوب.",
    NOT_OWNER_OF_CAISSE: "لا يمكنك إجراء هذا الدفع لأنك لست مالكًا لأي صندوق.",
    CAISSE_NOT_PERMITTED:
      "الصندوق أو الحساب البنكي غير موجود أو ليس لديك إذن للدفع منه.",
    INSUFFICIENT_BALANCE: "رصيد غير كافٍ",
    //config bulletin collége errors
    SUBJECT_REQUIRED: "المادة مطلوبة",
    SUBJECT_ALREADY_EXISTS: "هذه المادة موجودة بالفعل في الإعدادات",
    CONFIG_NOT_FOUND: "الإعدادات غير موجودة",
    SUBJECT_NOT_FOUND: "المادة غير موجودة",
    MISSING_REQUIRED_FIELDS: "الحقول المطلوبة مفقودة",
    NO_GRADES_FOR_TRIMESTER:
      "لا توجد علامات مسجّلة لهذا التلميذ في الفصل المحدد. لا يمكن إنشاء التقرير.",
    CONFIG_DELETE_FAILED: "فشل حذف الإعدادات",
    CONFIG_CLONE_FAILED: "فشل استنساخ الإعدادات",
    CONFIG_UPDATE_ORDERS_FAILED: "فشل تحديث ترتيب الإعدادات",
    SUBJECT_ORDER_UPDATE_FAILED: "فشل تحديث ترتيب المادة",
    DUPLICATE_CONFIG:
      "توجد إعدادات بالفعل لهذه المجموعة من المستوى والثلث والسنة الدراسية",
    SUBJECT_ADD_FAILED: "فشل إضافة المادة",
    SUBJECT_UPDATE_FAILED: "فشل تحديث المادة",
    SUBJECT_DELETE_FAILED: "فشل حذف المادة",
    SUBJECTS_QUERY_FAILED: "فشل جلب المواد",
    CONFIG_QUERY_FAILED: "فشل جلب الإعدادات",
    CONFIG_SAVE_FAILED: "فشل حفظ الإعدادات",
    INVALID_CONFIG_OPTIONS: "خيارات الإعدادات غير صالحة",
    PACK_PERMISSION_ERROR: "ليس لديك الإذن لتنفيذ هذا الإجراء",
    NO_AUTO_APPRECIATION:
      "لا توجد قواعد تقييم آلية للنسخ لهذه المادة والسنة الدراسية.",
    AUTO_APPRECIATION_MISSING_TEACHER_ACCESS:
      "لا يمكن تطبيق التقدير التلقائي للوحدة \u2066{moduleName}\u2069. لا يوجد صلاحية أستاذ للأقسام التالية: \u2066{classrooms}\u2069.",
    AUTO_APPRECIATION_NO_TEACHER_SUBJECT_ACCESS:
      "تعذر تطبيق التقدير التلقائي لأنه لا يوجد معلم مكلّف بهذه المادة في بعض الأقسام. يرجى تحديث صلاحيات المادة للمعلمين ثم إعادة المحاولة.",
    CLUB_ACTIVITY_REQUIRED: "يرجى اختيار نشاط أو إدخال اسم النادي",
    CLUB_POST_NOT_FOUND: "منشور النشاط / النادي غير موجود",
    CLUB_JOIN_NOT_FOUND: "طلب التسجيل غير موجود",
    CLUB_STUDENT_NOT_FOUND: "التلميذ غير موجود",
    CLUB_CLASSROOM_NOT_FOUND: "القسم غير موجود",
    CLUB_REGISTRATION_NOT_STARTED: "لم يبدأ التسجيل بعد",
    CLUB_REGISTRATION_CLOSED: "التسجيل مغلق",
    CLUB_NO_PLACES_LEFT: "لا توجد أماكن متبقية",
    CLUB_INVALID_STUDENT: "تلميذ غير صالح",
    CLUB_ALREADY_REGISTERED: "مسجل مسبقاً",
    ACTIVITY_GROUP_MISSING_SCHOOLARYEAR: "رأس سنة الدراسة مفقود",
    ACTIVITY_GROUP_ACTIVITY_ID_REQUIRED: "النشاط مطلوب",
    ACTIVITY_GROUP_ID_REQUIRED: "المجموعة مطلوبة",
    ACTIVITY_GROUP_INVALID_ID: "مجموعة غير صالحة",
    ACTIVITY_GROUP_ACTIVITY_NOT_FOUND: "النشاط غير موجود",
    ACTIVITY_GROUP_NOT_FOUND: "مجموعة النشاط غير موجودة",
    ACTIVITY_GROUP_NAME_EXISTS: "توجد مجموعة بهذا الاسم بالفعل",
    ACTIVITY_GROUP_PAYMENT_NOT_FOUND: "تسجيل النشاط غير موجود",
    ACTIVITY_GROUP_LIST_FAILED: "تعذر تحميل مجموعات النشاط",
    ACTIVITY_GROUP_CREATE_FAILED: "تعذر إنشاء المجموعة",
    ACTIVITY_GROUP_RENAME_FAILED: "تعذر إعادة تسمية المجموعة",
    ACTIVITY_GROUP_DELETE_FAILED: "تعذر حذف المجموعة",
    ACTIVITY_GROUP_ASSIGN_FAILED: "تعذر تعيين التلميذ إلى المجموعة",
    ACTIVITY_GROUP_UNASSIGN_FAILED: "تعذر إزالة التلميذ من المجموعة",
    CAISSE_INSUFFICIENT_BALANCE:
      "الرصيد الإجمالي للصندوق المحدد غير كافٍ لهذا الدفع.",
    CAISSE_INSUFFICIENT_MODE_BALANCE:
      "لا توجد أموال كافية في الصندوق المحدد لهذه الطريقة من الدفع (نقد، شيكات، تحويلات، إلخ).",
    CAISSE_NOT_FOUND: "الصندوق غير موجود",
    INVOICE_NOT_FOUND: "الفاتورة غير موجودة، يرجى التحقق من القيمة المرسلة",
    AMOUNT_EXCEEDS_INVOICE_TOTAL: "المبلغ يتجاوز إجمالي الفاتورة",
    AVOIR_DUPLICATE_DEPENSE:
      "يوجد إشعار دائن بالفعل لهذه الفاتورة. يُسمح بإشعار دائن واحد لكل فاتورة.",
    AVOIR_INVOICE_NOT_FULLY_PAID:
      "لا يمكن إنشاء إشعار دائن إلا للفاتورة المسددة بالكامل.",
    PAYMENT_NOT_FOUND: "الدفع غير موجود، يرجى التحقق من القيمة المرسلة",
    PAYMENT_ID_REQUIRED: "معرف الدفع مطلوب",
    DUPLICATE_PAYMENT_MONTH:
      "تم دفع هذا الموظف بالفعل لهذا الشهر. يرجى اختيار شهر آخر أو موظف آخر.",
    ALREADY_TRANSFERRED: "هذه الفاتورة محولة بالفعل، لا يمكن إلغاؤها",
    NOT_AUTHORIZED_TO_CANCEL:
      "لا يمكنك إلغاء هذه الفاتورة، يمكنك إلغاء الفواتير المحولة فقط من قبل مالك الصندوق الرئيسي",
    ALREADY_CANCELLED: "هذه الفاتورة ملغية بالفعل",
    VALIDATED_CHEQUES_EXIST: "لا يمكن إلغاء الفاتورة: توجد مدفوعات معتمدة",
    BORDEREAU_VALIDATED_CHEQUES_EXIST:
      "لا يمكن حذف البورديرة: توجد مدفوعات معتمدة",
    FACTURE_ONLY_AVOIR: "لا يمكن إلغاء الفواتير إلا بنوع 'إشعار دائن'",
    CHEQUE_TRAITE_ALREADY_REPLACED_OR_CANCELLED:
      "الشيك/الكمبيالة مستبدل أو ملغي بالفعل",
    CHEQUE_TRAITE_ALREADY_VALIDATED: "الشيك/الكمبيالة معتمد بالفعل",
    DUPLICATE_CHEQUES: "بعض الشيكات موجودة بالفعل في قاعدة البيانات",
    DUPLICATE_CHEQUE_OR_TRAITE_NUMBER:
      "رقم الشيك أو الكمبيالة مستخدم مسبقاً، أو تم إدخاله أكثر من مرة في هذا الدفع.",
    DUPLICATE_PROVIDER_INVOICE_NUMBER:
      "هذه الفاتورة موجودة بالفعل، يرجى تعديل الفاتورة الموجودة",
    DUPLICATE_INPUT_CHEQUES: "بعض الشيكات مكررة في البيانات المدخلة",
    TRANCHES_ALREADY_PAID: "التلميذ مسجل بالفعل بالأشهر المحددة",
    MONTHS_ALREADY_PAID: "التلميذ مسجل بالفعل بالأشهر المحددة",
    INSCRIPTION_ALREADY_PAID: "التلميذ مسجل بالفعل بالأشهر المحددة",

    DUP_CIN: "المعلم بهذا الرقم المعرف موجود بالفعل !",
    DUP_EMAIL: "المعلم بهذا البريد الإلكتروني موجود بالفعل !",
    DB_NOT_FOUND: "المدرسة غير موجودة.",
    CREATE_TEACHER_FAILED: "فشل إضافة المعلم، يرجى المحاولة مرة أخرى !",
    UPDATE_EMPLOYEE_FAILED: "فشل تحديث الموظف، يرجى المحاولة مرة أخرى !",
    //default system errors
    VALIDATION_ERROR: "بعض المعلومات غير صحيحة، يرجى التحقق من الإدخال.",
    TEACHER_INVALID_PHONE: "رقم الهاتف غير صالح. استخدم الصيغة الدولية، مثال: +21620123456.",
    TEACHER_INVALID_BIRTH_DATE: "تاريخ الميلاد غير صالح. اختر تاريخًا صالحًا (يوم/شهر/سنة) أو اترك الحقل فارغًا.",
    TEACHER_INVALID_CIN_CREATED_AT: "تاريخ إصدار بطاقة التعريف غير صالح. اختر تاريخًا صالحًا (يوم/شهر/سنة) أو اترك الحقل فارغًا.",
    TEACHER_INVALID_INTERVIEW_DATE: "تاريخ المقابلة غير صالح. اختر تاريخًا صالحًا (يوم/شهر/سنة) أو اترك الحقل فارغًا.",
    TEACHER_INVALID_START_DATE: "تاريخ البداية غير صالح. اختر تاريخًا صالحًا (يوم/شهر/سنة) أو اترك الحقل فارغًا.",
    TEACHER_INVALID_END_DATE: "تاريخ النهاية غير صالح. اختر تاريخًا صالحًا (يوم/شهر/سنة) أو اترك الحقل فارغًا.",
    TEACHER_INVALID_BANK_BRANCH: "فرع البنك غير صالح. استخدم الحروف والمسافات والشرطات والأقواس فقط.",
    TEACHER_INVALID_EXPECTED_HOURS: "عدد الساعات المتوقعة يوميًا غير صالح. أدخل رقمًا بين 0 و24.",
    TEACHER_CIN_DUPLICATE: "رقم بطاقة التعريف مسجّل لموظف آخر. أدخل رقمًا مختلفًا أو اترك الحقل فارغًا.",
    AUTHENTICATION_ERROR: "فشل تسجيل الدخول، يرجى التحقق من بيانات الدخول.",
    AUTHORIZATION_ERROR: "وصول غير مسموح.",
    NOT_FOUND_ERROR: "المورد المطلوب غير موجود.",
    CONFLICT_ERROR: "هذا الإجراء يتعارض مع بيانات موجودة.",
    DATABASE_ERROR: "حدثت مشكلة، يرجى المحاولة مرة أخرى.",
    EXTERNAL_SERVICE_ERROR:
      "الخدمة الخارجية غير متوفرة مؤقتًا، يرجى المحاولة لاحقًا.",
    CREATE_EMPLOYEE_FAILED: "فشل إضافة الموظف، يرجى المحاولة مرة أخرى !",
    UPDATE_EMPLOYEE_FAILED: "فشل تحديث الموظف، يرجى المحاولة مرة أخرى !",
    EMPLOYEE_DUP_CIN: "الموظف بهذا الرقم المعرف موجود بالفعل !",
    ENCAISSEMENT_BANK_INCOMPATIBLE_METHOD:
      "لا يمكن لحساب بنكي استقبال نقدي. استخدم شيكاً أو تريتة أو تحويلاً بنكياً أو TPE.",
    ENCAISSEMENT_NON_CASH_REQUIRES_BANK:
      "يجب إيداع الشيك والتريتة والتحويل البنكي وTPE في حساب بنكي.",
    OUTBOUND_PAYMENT_NOT_READY:
      "يجب التحقق من الصرف في المطابقة قبل تأكيد الاستلام.",
    STORAGE_QUOTA_EXCEEDED:
      "حصة التخزين لا تسمح بهذا الرفع. تواصلوا مع فريق المبيعات لزيادة الحصة، أو أفرغوا مساحة بحذف ملفات.",
    UPLOAD_PRESIGN_FAILED: "تعذر تجهيز الرفع. أعيدوا المحاولة.",
    ACTIVITY_SCHEDULE_MISSING_SCHOOLARYEAR: "اختر السنة الدراسية.",
    ACTIVITY_SCHEDULE_INVALID_DATA: "تحقق من معلومات الحصة.",
    ACTIVITY_SCHEDULE_INVALID_ID: "الحصة المحددة غير صالحة.",
    ACTIVITY_SCHEDULE_INVALID_RECURRENCE:
      "يجب أن ينشئ التكرار من حصة واحدة إلى 500 حصة.",
    ACTIVITY_SCHEDULE_ACTIVITY_NOT_FOUND: "لم يتم العثور على النشاط.",
    ACTIVITY_SCHEDULE_TEACHER_NOT_FOUND: "لم يتم العثور على المعلم.",
    ACTIVITY_SCHEDULE_ROOM_NOT_FOUND: "لم يتم العثور على القاعة.",
    ACTIVITY_SCHEDULE_GROUP_NOT_FOUND:
      "المجموعة لا تنتمي إلى هذا النشاط.",
    ACTIVITY_SCHEDULE_NOT_FOUND: "لم يتم العثور على الحصة.",
    ACTIVITY_SCHEDULE_CONFLICT:
      "المعلم أو القاعة مشغول بالفعل في هذا الوقت.",
    ACTIVITY_SCHEDULE_CANCELED: "استعد الحصة قبل تعديلها.",
    ACTIVITY_SCHEDULE_LIST_FAILED: "تعذر تحميل حصص النشاط.",
    ACTIVITY_SCHEDULE_CREATE_FAILED: "تعذر إنشاء الحصة.",
    ACTIVITY_SCHEDULE_UPDATE_FAILED: "تعذر تعديل الحصة.",
    ACTIVITY_SCHEDULE_CANCEL_FAILED: "تعذر إلغاء الحصة.",
    ACTIVITY_SCHEDULE_RESTORE_FAILED: "تعذر استعادة الحصة.",
    ACTIVITY_SCHEDULE_DELETE_FAILED: "تعذر حذف الحصة.",
    ACTIVITY_SCHEDULE_HAS_ATTENDANCE:
      "هذه الحصة تحتوي على سجلات حضور. قم بإلغائها بدلاً من حذفها.",
    ACTIVITY_ATTENDANCE_MISSING_SCHOOLARYEAR: "اختر السنة الدراسية.",
    ACTIVITY_ATTENDANCE_INVALID_ID: "معرف الحضور غير صالح.",
    ACTIVITY_ATTENDANCE_INVALID_DATA: "بيانات الحضور غير صالحة.",
    ACTIVITY_ATTENDANCE_SESSION_NOT_FOUND: "حصة النشاط غير موجودة.",
    ACTIVITY_ATTENDANCE_SESSION_CANCELED: "لا يمكن تسجيل الحضور لحصة ملغاة.",
    ACTIVITY_ATTENDANCE_SESSION_FUTURE: "لا يمكن تسجيل الحضور لحصة قادمة.",
    ACTIVITY_ATTENDANCE_FORBIDDEN: "غير مسموح بتسجيل هذه الحصة.",
    ACTIVITY_ATTENDANCE_YEAR_LOCKED: "حضور الأنشطة مقفل لهذه السنة الدراسية.",
    ACTIVITY_ATTENDANCE_VALIDATED_LOCKED: "أكّدت الإدارة هذا الحضور وهو مقفل.",
    ACTIVITY_ATTENDANCE_NOT_VALIDATED:
      "لم تؤكد الإدارة حضور هذه الحصة بعد.",
    ACTIVITY_ATTENDANCE_REOPEN_FAILED: "تعذّرت إعادة فتح الحصة.",
    ACTIVITY_ATTENDANCE_YEAR_NOT_FOUND: "السنة الدراسية غير موجودة.",
    ACTIVITY_ATTENDANCE_YEAR_LOCK_FAILED:
      "تعذّر تحديث صلاحية المدرّسين لهذه السنة الدراسية.",
    ACTIVITY_ATTENDANCE_STUDENT_NOT_ON_ROSTER:
      "التلميذ غير موجود في قائمة هذه الحصة.",
    ACTIVITY_ATTENDANCE_ALREADY_EXISTS: "سجل حضور موجود بالفعل لهذا التلميذ.",
    ACTIVITY_ATTENDANCE_NOT_FOUND: "سجل الحضور غير موجود.",
    ACTIVITY_ATTENDANCE_ROSTER_FAILED: "تعذر تحميل قائمة التلاميذ.",
    ACTIVITY_ATTENDANCE_CREATE_FAILED: "تعذر إنشاء سجل الحضور.",
    ACTIVITY_ATTENDANCE_UPDATE_FAILED: "تعذر تحديث سجل الحضور.",
    ACTIVITY_ATTENDANCE_DELETE_FAILED: "تعذر حذف سجل الحضور.",
    ACTIVITY_ATTENDANCE_SUMMARY_FAILED: "تعذر إنشاء ملخص الحضور.",
    ACTIVITY_ATTENDANCE_ACTIVITY_NOT_FOUND: "لم يتم العثور على النشاط.",
    ACTIVITY_ATTENDANCE_NOT_DAILY:
      "تتوفر إشارة الحضور فقط للأنشطة اليومية.",
    ACTIVITY_ATTENDANCE_PAYMENT_NOT_FOUND: "لم يتم العثور على التسجيل في النشاط.",
    ACTIVITY_ATTENDANCE_INDICATION_FAILED: "تعذر تحميل إشارة الحضور.",
    ACTIVITY_ATTENDANCE_VALIDATE_FAILED: "تعذر تأكيد حضور النشاط.",
    ACTIVITY_ATTENDANCE_EMPTY_ROSTER: "لا يوجد تلاميذ في قائمة هذه الحصة.",
    ACTIVITY_ATTENDANCE_ROSTER_INCOMPLETE:
      "يجب أن تغطي العلامات قائمة الحصة كاملة.",
    ACTIVITY_GROUP_MISSING_SCHOOLARYEAR: "اختر السنة الدراسية.",
    ACTIVITY_GROUP_INVALID_ID: "مجموعة النشاط المحددة غير صالحة.",
    ACTIVITY_GROUP_PAYMENT_INVALID_ID: "التسجيل المحدد غير صالح.",
    ACTIVITY_GROUP_INVALID_DATA: "تحقق من معلومات مجموعة النشاط.",
    ACTIVITY_GROUP_ACTIVITY_NOT_FOUND: "لم يتم العثور على النشاط.",
    ACTIVITY_GROUP_NOT_FOUND: "لم يتم العثور على مجموعة النشاط.",
    ACTIVITY_GROUP_PAYMENT_NOT_FOUND:
      "لم يتم العثور على التسجيل في النشاط.",
    ACTIVITY_GROUP_NAME_EXISTS: "توجد بالفعل مجموعة نشطة بهذا الاسم.",
    ACTIVITY_GROUP_LIST_FAILED: "تعذر تحميل مجموعات النشاط.",
    ACTIVITY_GROUP_CREATE_FAILED: "تعذر إنشاء مجموعة النشاط.",
    ACTIVITY_GROUP_RENAME_FAILED: "تعذر تعديل مجموعة النشاط.",
    ACTIVITY_GROUP_DELETE_FAILED: "تعذر حذف مجموعة النشاط.",
    ACTIVITY_GROUP_ASSIGN_FAILED: "تعذر إسناد الطالب إلى المجموعة.",
    ACTIVITY_GROUP_UNASSIGN_FAILED: "تعذر إزالة الطالب من المجموعة.",
  },
  upload: {
    failedTitle: "فشل الرفع",
  },
  status: {
    VALIDATED: "معتمد",
    REJECTED: "مرفوض",
    PENDING: "قيد الإنتظار",
    NON_DEPOSE: "غير مؤرشف",
    DEPOSE: "مؤرشف",
    TRAITE: "معالج",
    REPLACED: "مستبدل نقدا",
    CANCELLED: "ملغي بالفعل",
    ACTIVE: "مفعل",
    INACTIVE: "غير مفعل",
    active: "مفعل",
    cancelled: "ملغي",
  },
  financialStats: {
    title: "إحصائيات مالية",
    subtitle: "رؤى وتحليلات مالية شاملة لمؤسستك",
    refresh: "تحديث",
    startDate: "تاريخ البدء",
    endDate: "تاريخ الانتهاء",
    total: "المجموع",
    totalRevenue: "إجمالي الإيرادات",
    revenueSubtitle: "إجمالي الدخل من جميع المصادر",
    totalExpenses: "إجمالي المصروفات",
    expensesSubtitle: "إجمالي التكاليف والمصروفات",
    netProfit: "صافي الربح",
    profitSubtitle: "الإيرادات مطروحًا منها المصروفات",
    profitMargin: "هامش الربح",
    marginSubtitle: "نسبة الربحية",
    financialHealth: "الصحة المالية",
    health: {
      excellent: "ممتاز",
      good: "جيد",
      fair: "متوسط",
      poor: "ضعيف",
      unknown: "غير معروف",
    },
    healthDescription: {
      excellent: "أداء مالي متميز مع ربحية قوية",
      good: "صحة مالية جيدة مع اتجاهات نمو إيجابية",
      fair: "أداء مالي مقبول مع مجال للتحسين",
      poor: "الأداء المالي يحتاج إلى اهتمام فوري",
      unknown: "غير ممكن تقييم الصحة المالية",
    },
    totalInvoices: "إجمالي الفواتير",
    cancellationRate: "معدل الإلغاء",
    monthlyTrend: "الاتجاه الشهري",
    paymentMethods: "طرق الدفع",
    revenueExpenseComparison: "الإيرادات مقابل المصروفات",
    topPerformingMonths: "أفضل الأشهر أداءً",
    revenueAnalytics: "تحليل الإيرادات",
    expenseAnalytics: "تحليل المصروفات",
    studentAnalytics: "تحليل الطلاب",
    caisseAnalytics: "تحليل الصناديق",
    averageInvoiceValue: "متوسط قيمة الفاتورة",
    growthRate: "معدل النمو",
    dailyRevenue: "الإيرادات اليومية",
    dailyRevenueTrend: "اتجاه الإيرادات اليومي",
    revenueByType: "الإيرادات حسب النوع",
    factures: "فواتير",
    receipts: "إيصالات",
    paymentMethodsBreakdown: "تفصيل طرق الدفع",
    paymentMethod: "طريقة الدفع",
    amount: "المبلغ",
    percentage: "النسبة المئوية",
    cash: "نقدًا",
    check: "شيك",
    card: "بطاقة",
    transfer: "تحويل",
    wire: "تحويل بنكي",
    employeeExpenses: "مصروفات الموظفين",
    generalExpenses: "المصروفات العامة",
    cancellations: "الإلغاءات",
    monthlyExpenseBreakdown: "تفصيل المصروفات الشهرية",
    expenseDistribution: "توزيع المصروفات",
    expenseCategories: "فئات المصروفات",
    category: "الفئة",
    trend: "الاتجاه",
    employees: "الموظفون",
    general: "عام",
    totalStudents: "إجمالي الطلاب",
    averagePaymentPerStudent: "متوسط الدفع لكل طالب",
    topPayingStudents: "أعلى الطلاب دفعًا",
    showAll: "عرض الكل",
    showLess: "عرض أقل",
    rank: "الترتيب",
    student: "طالب",
    totalPaid: "إجمالي المدفوع",
    invoices: "الفواتير",
    lastPayment: "آخر دفعة",
    actions: "إجراءات",
    viewDetails: "عرض التفاصيل",
    paymentMethodsDistribution: "توزيع طرق الدفع",
    paymentFrequency: "تكرار الدفع",
    singlePayment: "دفعة واحدة",
    multiplePayments: "دفعات متعددة",
    frequentPayers: "دافعون متكررون",
    noData: "لا توجد بيانات متاحة",
    totalCaisses: "إجمالي الصناديق",
    averageRevenuePerCaisse: "متوسط الإيرادات لكل صندوق",
    caissePerformance: "أداء الصندوق",
    caisse: "صندوق",
    averageInvoiceValue: "متوسط قيمة الفاتورة",
    performance: "الأداء",
    monthlyTrend: "الاتجاه الشهري",
    revenueComparison: "مقارنة الإيرادات",
    caisseDistribution: "توزيع الصناديق",
    principal: "رئيسي",
    subcaisse: "صندوق فرعي",
    bank: "بنك",
    excellent: "ممتاز",
    good: "جيد",
    fair: "متوسط",
    poor: "ضعيف",
    positivePerformance: "إيجابي",
    negativePerformance: "سلبي",
    monthlyTrends: "الاتجاهات الشهرية",
    revenueExpenseProfit: "الإيرادات، المصروفات والأرباح",
    financialOverview: "نظرة عامة مالية",
    revenueVsExpenses: "الإيرادات مقابل المصروفات",
    revenue: "الإيرادات",
    expenses: "المصروفات",
    profit: "الربح",
    tnd: "د.ت",
    inscrit: "مسجل",
    nonInscrit: "غير مسجل",
    categories: "فئات",
    revenueSourcesTitle: "مصادر الإيرادات",
    revenueSourcesSubtitle: "الرسوم مقابل واردات وحدة المصروفات",
    revenueSource: {
      tuition: "الرسوم / الفواتير",
      inverseEncaissement: "مصروف عكسي (استلام)",
      avoirFournisseur: "إشعار دائن مورد مستلم",
    },
    depenseOutflowTitle: "المدفوعات حسب وسيلة الدفع",
    depenseOutflowSubtitle: "المبالغ المدفوعة فعلياً (مصروفات)",
    depenseByTypeTitle: "المصروفات المدفوعة حسب النوع",
    depenseByTypeSubtitle: "حسب نوع المصروف (مبالغ مدفوعة)",
    moneyFlowTitle: "تدفق النقد (الفترة)",
    moneyIn: "وارد",
    moneyOut: "صادر",
    netCashPosition: "صافٍ (وارد − صادر)",
    tuitionShort: "رسوم",
    inverseShort: "عكسي",
    avoirShort: "دائن",
    depensePaidOut: "مصروفات مدفوعة (الوحدة)",
    otherCategory: "أخرى",
  },
  schedule: {
    weekA: "أ",
    weekB: "ب",
    unknownClass: "فصل غير معروف",
    unknown: "غير معروف",
    teacher: "معلم",
    classroom: "قاعة الدراسة",
    session: "حصة",
    scheduleNotFound: "لم يتم العثور على الجدول الزمني",
    errorCreatingSession: "حدث خطأ أثناء إنشاء الحصة",
    addSessionFailed: "فشل في إضافة الحصة",
    timetableExceeded:
      "وقت انتهاء الحصة ({endTime}) يتجاوز وقت انتهاء الجدول الزمني ({timetableEnd}) ليوم {day}",
    time: "الوقت",
    monday: "الاثنين",
    tuesday: "الثلاثاء",
    wednesday: "الأربعاء",
    thursday: "الخميس",
    friday: "الجمعة",
    saturday: "السبت",
    group: "مجموعة",
    week: "الأسبوع",
    sunday: "الأحد",
  },

  college: {
    bulletin: {
      config: {
        title: "إعدادات كشف العلامات للمرحلة الإعدادية",
        description:
          "قم بتكوين المواد وأنواع العلامات لكشوف العلامات للمرحلة الإعدادية !",
        subjectOrderUpdated: "تم تحديث ترتيب المادة بنجاح",
        subjectAlreadyExists: "هذه المادة موجودة بالفعل في الإعدادات",
        failedToUpdateSubjectOrder:
          "فشل تحديث ترتيب المادة. يرجى المحاولة مرة أخرى",
        configClone: "تم استنساخ الإعدادات بنجاح",
        ajouterConfigCollege: "إضافة إعدادات المرحلة الإعدادية",
        modifierConfigCollege: "تعديل إعدادات المرحلة الإعدادية",
        modifierConfigSubject: "تعديل إعدادات المادة",
        niveau: "المستوى",
        order: "الترتيب",
        markTypes: "أنواع العلامات",
        configurerMarkType: "إعداد العلامة",
        aucuneMatiere: "لا توجد مواد",
        confirmDeleteWithMarks:
          "تحتوي هذه المادة على {count} علامة محفوظة. هل أنت متأكد من حذفها؟.",
        from: "من",
        to: "إلى",
        niveaux: "المستويات",
        trimestres: "الثلاثيات",
        anneeScolaire: "السنة الدراسية",
        count: "العدد",
        markType: {
          oral: "شفوي",
          cont1: "فرض 1",
          cont2: "فرض 2",
          synth: "تأليفي",
          written: "كتابي",
          tp: "تطبيقي",
        },
      },
    },
  },
  error404: {
    pageInaccessible: "صفحة غير متاحة",
    subscriptionMessage: "اشتراكك الحالي لا يدعم هذه الميزة.",
    upgradeMessage: "قم بالترقية الآن لإثراء تجربتك!",
    returnButton: "العودة",
  },
  reduction: {
    designation: "التعيين",
    reduction: "التخفيض",
    reductionTND: "التخفيض (دينار تونسي)",
    reductionKES: "التخفيض (شلن كيني)",
    reductionPercent: "التخفيض (%)",
    amountBeforeReduction: "المبلغ قبل التخفيض",
    amountAfterReduction: "المبلغ بعد التخفيض",
    actions: "الإجراءات",
    amountInTND: "المبلغ بالدينار التونسي",
    amountInKES: "المبلغ بالشلن الكيني",
    percentage: "النسبة المئوية",
    selected: "محدد",
  },
  payment: {
    selectFeesToPay: "اختر الرسوم المراد دفعها",
    showAll: "إظهار الكل",
    hideAll: "إخفاء الكل",
    payWithAdvance: "الدفع مقدماً",
    withoutAdvance: "بدون مقدمة",
    enableAdvancePayment: "تفعيل الدفع مقدماً",
    advanceAmountTND: "مبلغ المقدمة (دينار تونسي)",
    enterAmount: "أدخل المبلغ",
    advanceAmountExceedsTotal:
      "المبلغ المقدم المدخل أكبر من إجمالي الرسوم المراد دفعها. يجب أن يكون مبلغ المقدمة أقل من أو يساوي {maxAmount}",
    advanceAmountInsufficient:
      "المبلغ المقدم المدخل لا يسمح بتغطية جميع الرسوم. يرجى إدخال مبلغ مقدمة أعلى.",
    tuition: "الرسوم الدراسية",
    activity: "النشاط",
    feesToPay: "الرسوم المراد دفعها",
    remaining: "المتبقي",
    advanceApplied: "المقدمة المطبقة",
    remainingToPay: "المتبقي للدفع",
    partialPaymentRemaining: "دفع جزئي - المبلغ المتبقي للدفع",
    advanceInsufficientForFee:
      "المبلغ المقدم المدخل لا يسمح بتغطية هذه الرسوم. يرجى إدخال مبلغ مقدمة أعلى.",
    paid: "مدفوع",
    deselectAll: "إلغاء تحديد الكل",
    selectAll: "تحديد الكل",
    registration: "التسجيل",
    installment: "قسط",
    fees: "الرسوم",
    amount: "المبلغ",
  },
  activityPayment: {
    service: "الخدمة",
    numberOfStudents: "عدد الطلاب",
    order: "الترتيب",
    no: "لا",
    allMonths: "جميع الأشهر",
    allClasses: "جميع الفصول",
    monthlyPayment: "دفع شهري",
    installmentPayment: "دفع بالأقساط",
    studentName: "اسم الطالب",
    classroom: "الفصل",
    parents: "الوالدان",
    parentPhones: "هواتف الوالدين",
    paymentMode: "طريقة الدفع",
    monthly: "شهري",
    byInstallment: "بالأقساط",
    globalStatus: "الحالة العامة",
    paid: "مدفوع",
    unpaid: "غير مدفوع",
    noClassFound: "لم يتم العثور على أي فصل",
    activityNotFound: "النشاط غير موجود!",
    noActivityRegistrationFound: "لم يتم العثور على أي تسجيل في النشاط",
  },
  inscriptionActivites: {
    monthlyPayment: "دفع شهري",
    installmentPayment: "دفع بالأقساط",
    paymentMode: "طريقة الدفع",
    monthly: "شهري",
    byInstallment: "بالأقساط",
    globalStatus: "الحالة العامة",
    paid: "مدفوع",
    unpaid: "غير مدفوع",
    noClassFound: "لم يتم العثور على أي فصل",
    manageGroups: "إدارة المجموعات",
    manageGroupsTitle: "المجموعات — {activity}",
    addGroup: "إضافة",
    groupName: "اسم المجموعة",
    renameGroup: "إعادة تسمية",
    deleteGroup: "حذف",
    noGroupsYet: "لا توجد مجموعات لهذا النشاط بعد",
    confirmDeleteGroup: "حذف هذه المجموعة؟",
    selectActivityFirst: "اختر نشاطًا أولاً",
    selectActivityToManageGroups: "اختر نشاطًا لإدارة مجموعاته",
    filterByGroup: "تصفية حسب المجموعة",
    groupCreated: "تم إنشاء المجموعة بنجاح",
    groupRenamed: "تمت إعادة تسمية المجموعة بنجاح",
    groupDeleted: "تم حذف المجموعة بنجاح",
    groupAssigned: "تم تعيين التلميذ إلى المجموعة بنجاح",
    groupUnassigned: "تمت إزالة التلميذ من المجموعة بنجاح",
    multipleRegistration: "تسجيل متعدد",
    multipleRegistrationTitle: "التسجيل في عدة أنشطة",
    multipleRegistrationStep1Title: "1. الأنشطة والتلاميذ",
    multipleRegistrationStep1Subtitle:
      "اختر عدة أنشطة من نفس النوع (كلها يومية أو كلها شهري/بالأقساط) ثم التلاميذ المراد تسجيلهم",
    multipleRegistrationStep2Title: "2. إعداد كل نشاط",
    multipleRegistrationStep2Subtitle:
      "قم بإعداد التواريخ ووضع الدفع لكل نشاط على حدة",
    multipleRegistrationNoActivitiesSelected: "لم يتم اختيار أي نشاط",
  },
  emploiActivites: {
    title: "جدول الأنشطة",
    addSession: "إضافة حصة",
    editSession: "تعديل الحصة",
    selectActivityHint: "اختر نشاطًا لإدارة جدوله",
    selectActivityEmpty: "اختر نشاطًا لعرض الحصص",
    filterByGroup: "تصفية حسب المجموعة",
    wholeActivity: "النشاط بالكامل",
    day: "اليوم",
    time: "الوقت",
    duration: "المدة (دقيقة)",
    selectTeacher: "اختر معلمًا",
    selectRoom: "اختر قاعة",
    dayRequired: "اليوم مطلوب",
    timeRequired: "الوقت مطلوب",
    durationRequired: "المدة مطلوبة",
    cancelSession: "إلغاء الحصة",
    confirmCancelSession: "إلغاء هذه الحصة؟",
    restoreSession: "استعادة الحصة",
    confirmRestoreSession: "استعادة هذه الحصة الملغاة؟",
    confirmDeleteSession: "حذف هذه الحصة؟",
    canceled: "ملغاة",
    active: "نشطة",
    sessionCreated: "تم إنشاء الحصة",
    sessionUpdated: "تم تعديل الحصة",
    sessionCanceled: "تم إلغاء الحصة",
    sessionRestored: "تمت استعادة الحصة",
    sessionDeleted: "تم حذف الحصة",
    repeat: "تكرار الحصة",
    repeatHint: "إنشاء عدة حصص بين تاريخين",
    repeatFrequency: "التكرار",
    repeatDaily: "يومي",
    repeatWeekly: "أسبوعي",
    repeatMonthly: "شهري",
    startDate: "تاريخ البداية",
    endDate: "تاريخ النهاية",
    dateRangeRequired: "تاريخا البداية والنهاية مطلوبان",
    endBeforeStart: "يجب أن يكون تاريخ النهاية بعد البداية",
    frequencyRequired: "اختر التكرار",
    noOccurrences: "لا توجد حصص لإنشائها في هذه الفترة",
    sessionsWillBeCreated: "سيتم إنشاء {count} حصة/حصص",
    sessionsCreated: "تم إنشاء {count} حصة/حصص",
  },
  activityAttendance: {
    title: "حضور الأنشطة",
    sessionsTab: "الحصص",
    summaryTab: "الملخص",
    period: "الفترة",
    quickPeriod: "فترة سريعة",
    weekly: "هذا الأسبوع",
    monthly: "هذا الشهر",
    student: "التلميذ",
    studentCount: "{nb} تلاميذ",
    expected: "المتوقعة",
    attended: "الحضور",
    needDates: "اختر فترة زمنية",
    pickActivity: "اختر نشاطًا لعرض الحصص",
    sessionsHint:
      "افتح حصة لتسجيل الحضور. لا يُحفظ شيء حتى تضغط تأكيد. لا تؤكد في أيام العطل.",
    noSessions: "لا توجد حصص لهذه الفلاتر",
    group: "المجموعة",
    teacher: "المعلم",
    room: "القاعة",
    day: "اليوم",
    time: "الوقت",
    status: "الحالة",
    canceled: "ملغاة",
    canceledHint: "هذه الحصة ملغاة",
    future: "قادمة",
    futureHint: "يمكن تسجيل الحضور لحصص اليوم أو الحصص السابقة فقط",
    adminValidated: "أكّدته الإدارة",
    pendingAdmin: "أكّده المدرّس",
    pendingAdminHint:
      "أكّد المدرّس هذا الحضور ولا يزال بإمكانه تعديله. راجعه ثم اضغط على تأكيد لقفله بالنسبة للمدرّس.",
    teacherValidatedAt: "تأكيد المدرّس",
    teacherNotValidated: "لم يؤكده المدرّس بعد",
    notRecorded: "غير مسجّل",
    nothingRecordedYet:
      "لم يُسجَّل حضور لهذه الحصة بعد. اضبط الحالات (حاضر افتراضيًا) ثم اضغط تأكيد. لا تؤكد في أيام العطل.",
    validatedHint:
      "أكّدته الإدارة: مقفل بالنسبة للمدرّس. يمكنك التعديل ثم التأكيد مرة أخرى، أو إعادة فتحه للمدرّس.",
    reopen: "إعادة الفتح للمدرّس",
    reopenConfirm:
      "السماح للمدرّس بتعديل حضور هذه الحصة مرة أخرى؟ سيُقفل مجددًا عندما تؤكده الإدارة.",
    reopenSuccess: "تمت إعادة فتح الحصة للمدرّس",
    reopened: "أُعيد فتحها",
    reopenedHint:
      "أُعيد فتحها: يمكن للمدرّس تعديل هذه الحصة إلى أن تؤكدها الإدارة مرة أخرى.",
    yearLockedForTeachers:
      "هذه ليست السنة الدراسية الحالية. لا يمكن للمدرّسين تعديل حضور الأنشطة فيها.",
    yearUnlockedForTeachers:
      "هذه ليست السنة الدراسية الحالية، لكن المدرّسين مسموح لهم حاليًا بتعديل حضور الأنشطة فيها.",
    allowTeacherEdit: "السماح للمدرّسين بالتعديل",
    yearLockUpdated: "تم تحديث صلاحية المدرّسين",
    validate: "تأكيد الحضور",
    validateConfirm: "حفظ حضور جميع التلاميذ لهذه الحصة؟",
    validateSuccess: "تم تأكيد الحضور بنجاح",
    openSheet: "ورقة الحضور",
    markTitle: "تسجيل الحضور",
    emptyRoster: "لا يوجد تلاميذ مسجلون في هذه الحصة",
    groupRosterHint: "يُعرض فقط التلاميذ المعيّنون للمجموعة «{group}».",
    hint:
      "تُحتسب فقط الحصص المؤكَّدة. اختر نشاطًا لعرض كل المسجلين. بدون نشاط، يظهر فقط التلاميذ الذين لديهم حصة مطابقة في الفترة. أزل فلتر القسم إن وُجد.",
    empty:
      "لا يوجد تلاميذ لهذه الفلاتر. اختر نشاطًا أو وسّع التواريخ أو أزل فلتر القسم.",
  },
  activityPaymentAttendance: {
    title: "الحضور في هذه الفترة",
    subtitle:
      "إشارة فقط — اختر أيام الدفع يدويًا أدناه. تُحسب الحصص المؤكَّدة فقط (حاضر وتأخير = حضور).",
    refresh: "تحديث",
    needDates: "اختر فترة زمنية",
    missingIds: "التلميذ أو النشاط مفقود",
    noSessions: "لا توجد حصص مجدولة في هذه الفترة",
    noSessionsHint:
      "جدول النشاط لا يحتوي على حصص لهذا التلميذ في التواريخ المحددة.",
    present: "حاضر",
    retard: "تأخير",
    absence: "غائب",
    exclus: "مقصي",
    none: "لا يوجد",
    totals:
      "{sessions} حصة · حاضر {present} · تأخير {retard} · غائب {absence} · مقصي {exclus}",
  },
  activityMultiForm: {
    installmentFees: "رسوم الأقساط",
    installment: "قسط",
    selectedPaymentMode: "طريقة الدفع المختارة هي ",
    byInstallments: "بالأقساط",
    monthly: "شهرية",
    feesToPay: "الرسوم المراد دفعها",
    fees: "الرسوم",
    included: "مشمول",
  },
  studentCredentials: {
    deactivateOrActivateAccount: "إلغاء تفعيل أو تفعيل حساب الطالب",
    accountActivated: "الحساب مفعل، يمكن للمستخدم الوصول إلى التطبيق.",
    accountDeactivated: "الحساب غير مفعل، لا يمكن للمستخدم الوصول إلى التطبيق.",
    deactivate: "إلغاء التفعيل",
    activate: "تفعيل",
    studentQrCode: "رمز QR للطالب",
    usernameNoWhitespace: "اسم المستخدم لا يمكن أن يحتوي على مسافات",
    passwordConfirmationRequired: "يرجى إدخال كلمة المرور مرة أخرى",
    passwordMismatch: "المدخلان غير متطابقان!",
    statusChangeSuccess: "تم إجراء التغيير بنجاح",
  },
  footer: {
    copyright: "حقوق النشر ©",
    allRightsReserved: "جميع الحقوق محفوظة.",
    version: "الإصدار:",
  },
  attestationInscription: {
    title: "شهادة التسجيل",
    iUndersigned: "أنا الموقع أدناه",
    directorMale: "المدير",
    directorFemale: "المديرة",
    ofThe: "للمؤسسة",
    certifiesThatStudent: "أشهد أن التلميذ",
    bornOn: "المولود في",
    isEnrolledIn: "مسجل في مؤسستنا للسنة الدراسية",
    inClass: "في القسم",
    doneAt: "حرر في",
    on: "بتاريخ",
    signatureAndStamp: "التوقيع والختم",
  },
  ficheClasse: {
    nonDisponible: "غير متوفر",
    anneeScolaireLabel: "السنة الدراسية",
    delegeRegionalEducation: "المندوبية الجهوية ب",
    date: "التاريخ",
    listeEleves: "قائمة أسماء التلاميذ",
    classe: "القسم",
    garcon: "ذكر",
    fille: "أنثى",
    total: "المجموع",
    garcons: "مجموع الذكور",
    filles: "مجموع الإناث",
    numero: "العدد الرتبي",
    identifiantUnique: "المعرف الوحيد",
    nomComplet: "الاسم واللقب",
    dateNaissance: "تاريخ الولادة",
    group: "المجموعة",
    sexe: "الجنس",
    listeElevesPDF: "بطاقة_الفصل",
    formulaireParent: "استمارة ولي الأمر",
    nomPrenom: "الاسم واللقب",
    nomPrenomFr: "الاسم واللقب بالفرنسية",
    nomParent: "إسم ولي الأمر",
    telephone: "الهاتف",
    pere: "الأب",
    mere: "الأم",
    ficheParentPDF: "ملف_الولي",
    parentSheetSelectAtLeastOneColumn:
      "يرجى اختيار عمود واحد على الأقل للطباعة.",
    parentSheetSelectColumnsHint:
      "اختر الأعمدة المراد تضمينها في ملف الوالدين. يمكنك إنشاء قائمة كاملة أو الحقول المطلوبة فقط (مثل قائمة البريد الإلكتروني أو العناوين).",
    parentSheetSelectColumnsTitle: "اختر الأعمدة للطباعة",
  },
  attendanceHistoryPdf: {
    classe: "القسم",
    period: "الفترة",
    num: "الرقم",
    studentName: "اسم الطالب",
    page: "الصفحة",
    legend: "الوسيط",
    present: "حاضر",
    absence: "غائب",
    retard: "متأخر",
    exclus: "إقصاء",
    history: "التاريخ",
  },
  conseilClass: {
    managerAndTeacher: "المدير والمعلمون",
    options: "الخيارات",
    allow: "إظهار",
    auto: "تلقائي",
    useSchoolCode: "استخدام رمز المؤسسة",
    repeatEachPage: "تكرار في كل صفحة",
    rect: "إطار",
    orientation: "الاتجاه",
    landscape: "أفقي",
    portrait: "عمودي",
    govText: "النص الحكومي",
    schoolLogo: "شعار المؤسسة",
    schoolYear: "السنة الدراسية",
    govLog: "الشعار الحكومي",
    stats: "إحصائيات",
    mainTitle: "العنوان الرئيسي",
    secondaryText: "النص الثانوي",
    preParagraph: "فقرة تمهيدية",
    table: "جدول الناجحين",
    tablePostParagraph: "فقرة بعد جدول الناجحين",
    postParagraph: "فقرة بعد الجدول",
    number: "الرقم",
    fullName: "الاسم الكامل",
    firstName: "الاسم",
    lastName: "اللقب",
    birthDate: "تاريخ الولادة",
    birthPlace: "مكان الولادة",
    uniqueIden: "المعرف الفريد",
    prevYears: "السنوات السابقة",
    trim1: "الثلاثي 1",
    trim2: "الثلاثي 2",
    trim3: "الثلاثي 3",
    moy: "المعدل",
    decision: "القرار",
    handicape: "إعاقة",
    exceptionalStats: "جدول النجاح بالاستثناء",
    filled: "ملء بأسماء التلاميذ",
    specCount: "عدد الصفوف الفارغة",
    agePass: "جدول النجاح بالسن",
    fail: "جدول الراسبين",
    govSpecific: "كتلة الجهة (الصفحة الأخيرة)",
    manager: "المدير",
    teacher: "المعلمون",
    templateName: "اسم النموذج",
    templateNamePlaceholder: "مثال: محضر مجلس القسم",
    selectTemplate: "نموذج محفوظ",
    builtinDefault: "افتراضي",
    pvMissingKeyBanner: "{count} تلميذ(ة) بدون قرار مقابل (A/C/R)",
    pvMissingKeyHint:
      "لن يظهر هؤلاء التلاميذ في جداول المحضر. صحّح إعدادات قرارات المجلس أو عيّن قراراً لكل تلميذ.",
    pvMissingKeyMore: "... و {count} آخر(ين)",
    settingsSaved: "تم حفظ الإعدادات بنجاح",
    templateAssigned: "تم تعيين النموذج لهذا المستوى",
    checkInputs: "يرجى التحقق من المدخلات",
    selectClassFirst: "يرجى اختيار قسم أولاً",
    couldNotGetClassPv: "تعذر تحميل بيانات محضر القسم",
    cloneAlert: "تم نسخ الإعدادات. حدّث الصفحة لرؤية التغييرات كاملة.",
    templateNameRequired: "يرجى إدخال اسم للنموذج",
    templateNameAlreadyExists: "اسم النموذج موجود بالفعل. اختر اسماً آخر.",
    nameTemplateTitle: "تسمية النموذج",
    nameTemplatePrompt:
      "أنت تحفظ من النموذج الافتراضي. أعطِ اسماً فريداً قبل الحفظ لهذا المستوى.",
    selectSourceTemplate: "النموذج المصدر للنسخ",
    cloneSourceHint:
      "لنسخ نموذج آخر، اختره في الإعدادات ثم احفظ قبل فتح النسخ.",
    cloneSaveTemplateFirst: "احفظ النموذج المحدد في الإعدادات قبل نسخه.",
    unnamedTemplate: "بدون اسم",
    selectCloneTargets: "يرجى اختيار هدف واحد على الأقل",
  },
  pickup: {
    title: "استلام التلميذ",
    enabled: "تفعيل استلام التلميذ من طرف الولي",
    radius: "المسافة المسموح بها (بالمتر)",
    location: "موقع الاستلام",
    locationHint:
      "اتركه فارغًا لاستعمال موقع المدرسة المحدد في إعدادات المؤسسة.",
    noBuildingLocation:
      "لم يتم تحديد موقع المدرسة في إعدادات المؤسسة. أدخل موقع الاستلام.",
    noLocation:
      "الموقع إجباري لتفعيل الاستلام. أدخل موقع الاستلام أو حدّد موقع المدرسة.",
    latLngTogether: "يجب إدخال خط العرض وخط الطول معًا.",
    saved: "تم حفظ إعدادات الاستلام",
    waiting: "في الانتظار",
    history: "السجل",
    noWaiting: "لا يوجد تلميذ في الانتظار",
    student: "التلميذ",
    classe: "القسم",
    parent: "الولي",
    requestedAt: "وقت الطلب",
    expiresIn: "ينتهي بعد",
    status: "الحالة",
    statusPickedUp: "تم الاستلام",
    statusExpired: "منتهي (لم يتم التأكيد)",
    validatedBy: "تم التأكيد من طرف",
    validate: "تأكيد الخروج",
    confirmValidate: "هل تؤكد أن التلميذ خرج مع الولي؟",
    validated: "تم تأكيد خروج التلميذ",
    level: "المستوى",
    sortOldest: "الوصول: الأقدم أولاً",
    sortNewest: "الوصول: الأحدث أولاً",
    distance: "المسافة عن المدرسة",
    relation: {
      father: "الأب",
      mother: "الأم",
      guardian: "الولي",
    },
  },
};

export default {
  locale: "ar-AR",
  localeAntd,
  messages,
};
